var HUB_CATEGORIES = [
  { key: 'all', label: '所有文章', description: 'AI 图片模型、图片工具、提示词技巧、替代方案和实用教程。' },
  { key: 'reviews', label: '测评', description: 'Seedream、FLUX、Midjourney、GPT Image、Qwen、Z Image、Stable Diffusion 等 AI 图片模型测评。' },
  { key: 'how-to-guides', label: '操作方法', description: 'AI 去水印、背景移除、手写擦除、文档照片矫正等图片处理工具的操作步骤和技巧。' },
  { key: 'alternatives', label: '替代方案', description: 'Midjourney 替代、Stable Diffusion 在线替代等 AI 生图方案的对比和选型。' },
  { key: 'ai-model-insights', label: 'AI 模型洞察', description: '深入分析前沿 AI 模型的能力、上下文、工具调用、使用成本、适用场景和实际限制。' },
  { key: 'prompt-guides', label: '提示词指南', description: 'GPT Image 等模型的提示词写法：文字海报、电商卖点图、社媒封面和产品图。' }
]

var HUB_CATEGORY_MAP = HUB_CATEGORIES.reduce(function (map, item) {
  map[item.key] = item
  return map
}, {})

function makeSection(id, title, blocks) {
  return { id: id, title: title, blocks: blocks || [] }
}

function p(text) {
  return { type: 'paragraph', text: text }
}

function bullets(items) {
  return { type: 'bullets', items: items }
}

function promptList(items) {
  return { type: 'prompts', items: items }
}

function links(title, items) {
  return { type: 'links', title: title, items: items }
}

function table(columns, rows, variant) {
  return { type: 'table', columns: columns, rows: rows, variant: variant || 'default' }
}

function tip(title, text) {
  return { type: 'tip', title: title || '我的结论', text: text }
}

function figure(imageKey, alt, caption) {
  return { type: 'figure', imageKey: imageKey, alt: alt || '', caption: caption || '' }
}

function articleImage(src, alt, caption) {
  return { type: 'article-image', src: src, alt: alt || '', caption: caption || '' }
}

function gallery(imageKeys, caption, cols, fit, ratio) {
  var items = (imageKeys || []).map(function (key) {
    return { imageKey: key }
  })
  var columnCount = cols || items.length
  if (columnCount !== 2 && columnCount !== 4) {
    columnCount = items.length >= 4 ? 4 : 2
  }
  return {
    type: 'gallery',
    items: items,
    caption: caption || '',
    cols: columnCount,
    fit: fit || 'cover',
    ratio: ratio || 'square'
  }
}

function promptExample(label, prompt, imageKey) {
  return { type: 'prompt-example', label: label, prompt: prompt, imageKey: imageKey || '' }
}

function faqItem(question, answer) {
  return { type: 'faq-item', question: question, answer: answer }
}

function scenarioItem(title, text) {
  return { type: 'scenario-item', title: title, text: text }
}

function prosConsBlock() {
  return { type: 'pros-cons' }
}

function stepsBlock() {
  return { type: 'steps' }
}

function ctaBlock(title, text, buttonLabel, buttonPath) {
  return {
    type: 'cta',
    title: title,
    text: text,
    buttonLabel: buttonLabel,
    buttonPath: buttonPath || ''
  }
}

var HUB_SEARCH_SCENARIOS = require('./searchScenarios.js')
var HUB_PLATFORM_REFS = require('./platformRefs.js')
var HUB_ARTICLE_CONCLUSIONS = require('./articleConclusions.js')
var searchIndex = require('./searchIndex.js')
var brandContent = require('./brandContent.js')
var ctaLabels = require('./ctaLabels.js')

var HUB_TEXT = {
  home: '首页',
  blog: '博客',
  blogName: 'Miral AI Blog',
  allArticles: '所有文章',
  featuredReading: '精选阅读',
  featureEntry: '免费试用',
  aiImageModels: 'AI 图片模型',
  aiImageTools: 'AI 图片工具',
  categoryNavLabel: '博客分类',
  searchLabel: '搜索文章',
  searchPlaceholder: '搜模型、工具、提示词或场景，如 Seedream 电商主图',
  searchButton: '搜索',
  clearButton: '清除',
  searchResultPrefix: '搜索「',
  searchResultMiddle: '」找到 ',
  searchResultSuffix: ' 篇',
  popularSearches: '大家常查：',
  readArticle: '阅读全文',
  noResultsPrefix: '没有找到匹配「',
  noResultsSuffix: '」的文章。',
  viewAllArticles: '查看全部文章',
  paginationLabel: '博客分页',
  previousPage: '上一页',
  nextPage: '下一页',
  allPageTitle: 'AI 图片模型和工具博客',
  homeSectionTitle: 'AI 图片模型和工具博客',
  homeSectionDescription: '围绕 Seedream、FLUX、Midjourney、GPT Image、Qwen、Z Image、Stable Diffusion，以及去水印、手写擦除、图片裁剪矫正等工具，整理模型测评、提示词示例和实用教程。',
  categoryTitleSuffix: '：AI 图片生成与图片处理指南',
  defaultDescription: '围绕 AI 图片生成器、图片工具、模型测评、替代方案和提示词工作流，帮助用户快速找到合适的 Miral 功能。',
  metaTitleAll: 'AI 图片生成博客：模型测评、提示词和图片工具指南 | Miral',
  metaTitleCategorySuffix: ' - AI 图片生成博客 | Miral',
  viewAllBlog: '查看全部 AI 博客',
  inArticleLabel: '在本文中',
  expandPrefix: '展开 ',
  quickAnchorLabel: '文章快捷跳转',
  quickJump: '快速跳转',
  promptExample: '提示词示例',
  copyPrompt: '复制提示词',
  copied: '已复制',
  pros: '优点',
  cons: '缺点',
  relatedTitle: '您可能也喜欢',
  mainFeatureTitle: '在 Miral 免费试用',
  mainFeatureLinksTitle: '常用功能入口',
  tocTitle: '本页内容',
  useNow: '立即使用',
  tryForFreeTemplate: '免费试用 {name}',
  notFoundTitle: '文章不存在',
  backToBlog: '返回博客首页',
  notFoundMetaTitle: '文章不存在 | Miral',
  collapse: '收起',
  expandMore: '展开更多',
  defaultStepTitle: '我通常这样用',
  alternativesStepTitle: '我通常怎么对比模型',
  howToStepTitle: '操作步骤',
  promptStepTitle: '写提示词时我通常这样做',
  reviewStepTitle: '测评时我通常这样做',
  editorNoteTool: '如果你已经有一张需要处理的图片，可以先看适用场景和操作步骤，再根据图片问题选择是否直接进入工具处理。',
  editorNoteGuide: '下文是基于实际使用体验的指南。建议先看「快速结论」，再对照示例和步骤，最后进入 Miral 试一版。',
  editorNoteDefault: '你可以先看适用场景和操作步骤，再进入对应的 Miral 功能页试一版。',
  comparePills: ['艺术探索', '商业出片', '带字海报', '浏览器直达'],
  workflowSteps: ['文档矫正', '手写擦除', '去水印', '归档 / OCR'],
  docSearchAliasLinks: [
    { label: '图片裁剪矫正', path: '/tools/doc-crop-enhance' },
    { label: '文档矫正', path: '/tools/doc-crop-enhance' },
    { label: '手写擦除', path: '/tools/handwritten-erase' },
    { label: 'AI 去水印', path: '/tools/watermark-remover' }
  ],
  relatedGuidesTitle: '相关指南'
}

// 详情页「常见处理场景 / 常见疑问」默认展示条数；超过才折叠
var HUB_COLLAPSIBLE_VISIBLE_COUNT = 10

function countHubSectionBlocks(section, blockType) {
  var blocks = section && section.blocks ? section.blocks : []
  var count = 0
  var i
  for (i = 0; i < blocks.length; i++) {
    if (blocks[i].type === blockType) count++
  }
  return count
}

function shouldCollapseHubSection(section, sectionId, blockType) {
  return !!(
    section &&
    section.id === sectionId &&
    countHubSectionBlocks(section, blockType) > HUB_COLLAPSIBLE_VISIBLE_COUNT
  )
}

function hiddenHubSectionBlockCount(section, blockType) {
  return Math.max(0, countHubSectionBlocks(section, blockType) - HUB_COLLAPSIBLE_VISIBLE_COUNT)
}

function buildHubCollapsibleEntries(section, blockType, mode) {
  var blocks = section && section.blocks ? section.blocks : []
  var limit = HUB_COLLAPSIBLE_VISIBLE_COUNT
  var out = []
  var typeCount = 0
  var i
  for (i = 0; i < blocks.length; i++) {
    var block = blocks[i]
    if (block.type === blockType) {
      typeCount++
      if (mode === 'primary' && typeCount <= limit) {
        out.push({ block: block, index: i })
      } else if (mode === 'extra' && typeCount > limit) {
        out.push({ block: block, index: i })
      }
    } else if (mode === 'primary' && blockType === 'scenario-item') {
      out.push({ block: block, index: i })
    }
  }
  return out
}

var COMMON_MODEL_LINKS = [
  { label: 'Seedream AI 图片生成器', path: '/image-models/seedream-ai-image-generator' },
  { label: 'FLUX AI 图片生成器', path: '/image-models/flux-2-ai-image-generator' },
  { label: 'Midjourney AI 图片生成器', path: '/image-models/midjourney-ai-image-generator' },
  { label: 'GPT Image 生成器', path: '/image-models/gpt-image-ai-image-generator' },
  { label: 'Qwen Image 生成器', path: '/image-models/qwen-image-2-0-pro-ai-image-generator' },
  { label: 'Z Image Turbo 生成器', path: '/image-models/z-image-turbo-ai-image-generator' },
  { label: 'Stable Diffusion 在线生成器', path: '/image-models/stable-diffusion-ai-image-generator' }
]

var HUB_FEATURE_LINKS = [
  { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
  { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
  { label: 'Midjourney', path: '/image-models/midjourney-ai-image-generator' },
  { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' },
  { label: 'Qwen Image 2.0 Pro', path: '/image-models/qwen-image-2-0-pro-ai-image-generator' },
  { label: 'Z Image Turbo', path: '/image-models/z-image-turbo-ai-image-generator' },
  { label: 'Stable Diffusion 3.5', path: '/image-models/stable-diffusion-ai-image-generator' },
  { label: 'Miral AI 背景移除', path: '/tools/background-remover' },
  { label: 'AI 去水印', path: '/tools/watermark-remover' },
  { label: '手写擦除', path: '/tools/handwritten-erase' },
  { label: '图片裁剪矫正', path: '/tools/doc-crop-enhance' }
]

var COMMON_TOOL_LINKS = [
  { label: 'Miral AI 背景移除', path: '/tools/background-remover' },
  { label: 'AI 图片增强', path: '/tools/image-enhancer' },
  { label: 'AI 物体移除', path: '/tools/object-remover' },
  { label: 'AI 去水印', path: '/tools/watermark-remover' },
  { label: '手写擦除', path: '/tools/handwritten-erase' },
  { label: '图片裁剪矫正', path: '/tools/doc-crop-enhance' }
]

var HUB_ARTICLES = [
  {
    slug: 'kimi-k3-review',
    category: 'ai-model-insights',
    layout: 'review',
    layoutProfile: {
      showHeroImage: true,
      headerHint: '从官方规格、长上下文、代码任务和部署成本判断 Kimi K3 的实际位置。'
    },
    coverImage: '/images/hub/kimi-k3-review-cover.svg?v=20260721-3',
    heroImage: '/images/hub/kimi-k3-review-cover.svg?v=20260721-3',
    title: 'Kimi K3 评测：1M 上下文和开放权重适合谁？',
    excerpt: 'Kimi K3 是一款拥有 2.8T 参数、最高 1M 上下文和原生视觉能力的开放权重编程模型。本文分析这些规格对大型代码库、长文档和智能体任务意味着什么。',
    metaTitle: 'Kimi K3 评测：1M 上下文、开放权重与编程能力',
    metaDescription: '深入分析 Kimi K3 的长上下文、编程、多模态理解与智能体能力，涵盖适用场景、局限、使用方法和常见问题。',
    updatedAt: '2026-07-21',
    target: { label: 'Miral AI 创作工具', path: '/' },
    keywords: ['Kimi K3 测评', 'Kimi K3 是什么', 'Kimi K3 怎么用', 'Kimi K3 编程', 'Kimi K3 长文档', 'Kimi K3 智能体', 'Kimi K3 能分析 PDF 吗', 'Kimi K3 模型 ID', 'Kimi K3 1M 上下文', 'Kimi K3 上下文丢失', 'Kimi K3 开放权重', 'Kimi K3 和 GPT-5.6 Sol 对比'],
    creatingSteps: [
      { title: '先写清目标和验收标准', text: '说明要完成什么、现有 PDF 或代码、输出格式和禁止修改的范围，再让模型开始处理。' },
      { title: '长文档按证据整理', text: '要求按主题、证据页码、冲突点和待核实信息输出；漏了就把状态摘要贴回去再要一轮。' },
      { title: '编程先计划后改文件', text: '限定只能改哪些文件，先让它读结构提计划，再逐文件改；一次动太多文件容易牵一发动全身。' },
      { title: '每个阶段留下状态摘要', text: '记录已完成内容、未解决问题、允许修改的范围和下一步，避免长任务中途偏离目标。' }
    ],
    pros: [
      '最高 1M 上下文为大型代码库和多份长文档提供了更大的工作空间',
      '文本、图表、截图和代码可以放在同一任务中分析',
      '开放模型路线，开发者可以自己评估怎么部署',
      '适合承担研究、规划和代码辅助，不必把所有任务都塞进一个模型'
    ],
    cons: [
      '页码引用、代码依赖和修改范围都可能出错，重要结果必须复核',
      '智能体任务吃工具质量和权限设置，配不好容易空转',
      '开放权重并不等于部署简单，推理资源和运维成本仍需单独计算',
      '长对话可能出现上下文漂移，需要用状态摘要维持目标和约束'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '结论'], [
          ['总体判断', '适合长材料、多模态和复杂任务；简单问答没有必要使用这一等级的模型'],
          ['最适合', '大型代码库、长文档研究、截图与代码联合排错、多步骤智能体'],
          ['不太适合', '简单问答，以及未经核实就直接用于决策的高风险任务'],
          ['上手难度', '中——写清目标与验收条件后更稳'],
          ['核心优势', '把长材料、代码和多步骤任务放在一个上下文中处理'],
          ['使用建议', '先让它建立证据和任务边界，再逐步生成或修改内容']
        ], 'overview'),
        p('Kimi K3 的使用门槛不在聊天界面，而在任务组织。材料越多，越要写清证据位置、修改范围和完成标准。')
      ]),
      makeSection('what-is-kimi-k3', 'Kimi K3 是什么', [
        p('Kimi K3 是 Kimi 在 2026 年 7 月发布并开源的旗舰编程模型。官方给出的参数规模为 2.8T，并把它定位为首个达到约 3T 参数规模的开源模型。它不是 Kimi 聊天产品的一次普通升级，而是一款面向大型代码库、长程推理和智能体任务的基础模型。'),
        table(['项目', 'Kimi K3 官方信息'], [
          ['模型定位', '旗舰编程与长程推理模型'],
          ['参数规模', '2.8T'],
          ['架构', 'KDA 混合线性注意力 + Attention Residuals'],
          ['上下文', '最高 1M tokens；实际可用长度取决于套餐和接入方式'],
          ['输入能力', '文本与原生视觉理解'],
          ['推理强度', 'low / high / max，默认 max'],
          ['调用 ID', '`k3`'],
          ['主要使用方式', 'Kimi Code CLI、VS Code 扩展、API 和兼容的第三方编码工具']
        ], 'overview'),
        p('这组规格解释了 Kimi K3 为什么把重点放在代码、长文档和智能体上：它需要在较长时间内读取文件、维护任务状态、调用工具并继续推理。它可以理解图片和图表，但不是图片或视频生成模型。'),
        tip('容易混淆的一点', 'Kimi K3 是模型版本，API 或第三方工具中应填写模型 ID `k3`。关闭 thinking 可能被路由到其他模型，因此比较前必须确认实际调用的模型和推理设置。')
      ]),
      makeSection('kimi-k3-advantages', 'Kimi K3 的主要优势', [
        bullets([
          '最高 1M 上下文是它最直接的差异点，适合大型代码库、多份研究资料和持续时间较长的任务。',
          '原生视觉理解意味着截图、图表、界面和代码可以放进同一次分析，而不只处理纯文本。',
          'low / high / max 三档推理强度方便按任务复杂度控制速度与消耗，不必所有问题都使用最高档。',
          '开放权重让团队可以评估自有部署、数据控制和定制推理环境，这是闭源模型通常无法提供的选择。',
          'Kimi Code 已提供 CLI、VS Code 和第三方编码工具接入，模型能力不只停留在聊天窗口。'
        ]),
        p('不过，1M 上下文并不是“放进去就不会忘”。材料越多，越要要求证据位置、阶段摘要和明确的输出结构。智能体工具越多，也越需要权限边界和停止条件。')
      ]),
      makeSection('kimi-k3-comparison', '和 Claude Fable 5、GPT-5.6 Sol 相比怎么选', [
        table(['比较维度', 'Kimi K3', 'Claude Fable 5', 'GPT-5.6 Sol'], [
          ['更突出的定位', '长上下文、原生视觉、开放权重与智能体任务', '长期编码、知识工作和受控智能体', '复杂专业工作、完整工具生态与 computer use'],
          ['更适合', '需要数据控制、长资料处理或评估自有部署的团队', '需要持续推进复杂代码和知识任务的团队', '需要 OpenAI 工具生态、浏览器操作和多工具执行的团队'],
          ['需要注意', '长上下文仍可能遗漏细节，自部署有工程成本', '成本、权限与安全路由需要提前评估', '输出价格较高，超 272K 输入会进入更高计价档'],
          ['选择依据', '开放权重、数据控制、上下文和视觉输入', '长期任务控制与 Anthropic 工作流', '工具覆盖、computer use 与托管 API 集成']
        ], 'overview'),
        p('Kimi K3 的组合优势很明确：长上下文、原生视觉和开放权重同时出现。是否选择它，则取决于团队更看重数据控制、上下文规模，还是现成的工具生态。')
      ]),
      makeSection('kimi-k3-case-notes', '用三个任务检验 1M 上下文', [
        table(['案例', '任务设置', '编辑点评'], [
          ['大型代码库重构', '提供仓库结构、禁止修改清单和测试命令，要求先计划，再分批提交补丁', '这是 Kimi K3 最值得测试的场景。1M 上下文能帮助它看全局，但不能替代范围控制；如果一次改动大量无关文件，答案再完整也应判为失败。'],
          ['多份报告交叉核对', '提供结论互相冲突的资料，要求标出证据位置、冲突原因和待核实信息', '摘要是否流畅并不重要。引用准确、证据与推断分开，才能说明长上下文发挥了作用。'],
          ['截图与代码联合排错', '同时提供报错截图、相关组件代码和复现步骤，要求定位原因并给出最小修复', '如果回答忽略截图，只给通用排错清单，原生视觉能力就没有对结果产生帮助。']
        ], 'overview')
      ]),
      makeSection('kimi-k3-evidence', '官方规格与待验证能力', [
        table(['结论', '证据状态', '应如何理解'], [
          ['2.8T 参数、最高 1M 上下文、原生视觉、三档推理强度', '官方文档已确认', '属于模型规格，但不等同于实际任务准确率'],
          ['适合大型代码库和长程智能体任务', '官方定位明确', '仍要通过具体项目验证范围控制和代码质量'],
          ['能否准确发现长文档中的所有冲突', '取决于具体任务', '需要结合输入文件和人工核对结果判断'],
          ['是否优于 Claude Fable 5 或某个 GPT 型号', '取决于任务', '必须使用相同输入、工具、推理设置和验收标准比较'],
          ['开放部署是否更划算', '取决于基础设施', '模型开放不代表部署、推理和运维成本为零']
        ], 'overview')
      ]),
      makeSection('kimi-k3-results', '按任务类型判断，它适合做什么', [
        table(['使用场景', '结论', '理由'], [
          ['大型代码库与长期工程任务', '值得优先测试', '这是 Kimi K3 最明确的官方定位，1M 上下文和工具调用也与此匹配'],
          ['多份长文档研究', '值得测试，但必须复核证据', '上下文容量有优势，难点仍是引用准确率和冲突发现率'],
          ['截图、图表与代码联合分析', '适合', '原生视觉输入减少了在多个工具之间拆分材料的需要'],
          ['自动执行的智能体任务', '有条件适合', '效果高度依赖工具质量、权限规则、失败恢复和停止条件'],
          ['简单问答、改写和分类', '没有明显必要', '轻量模型通常更快，也更节省资源'],
          ['直接生成图片或视频', '不适合', 'Kimi K3 提供视觉理解，不是媒体生成模型']
        ], 'overview'),
        p('当大量资料、代码、视觉输入和工具执行需要留在同一条任务链里时，Kimi K3 的规格才更容易转化为实际价值。')
      ]),
      makeSection('how-to-use-kimi-k3', '代码和长文档，是最值得尝试的两个场景', [
        p('先提供任务目标、已有材料、输出格式和验收条件。处理长文档时不要只说“总结一下”，而应要求标出关键结论、证据位置、冲突信息和待核实问题。'),
        p('编程任务应先限定允许修改的文件，让模型读取结构、提出小步计划，再逐文件修改。要求它说明假设和测试方法，比一次生成整套代码更容易验证。'),
        p('截图与代码联合排错时，要同时提供复现步骤、当前文件和真实错误。要求模型指出截图中的具体线索，能减少只返回通用检查清单的情况。'),
        articleImage(
          '/images/hub/kimi-k3-review-editorial.svg',
          'Kimi K3 长文档研究、代码修改与多模态排错流程示意图',
          '长任务可以按材料整理、范围确认、分步执行和结果验证推进。'
        ),
        stepsBlock()
      ]),
      makeSection('fix-kimi-k3', '使用前要知道的几个坑', [
        p('长对话出现上下文漂移时，可把目标、已确认事实、未完成项和禁止修改内容压缩成状态摘要，再开始下一轮。不要假设模型会自动保留全部历史细节。'),
        p('代码前后对不上时，提供当前文件、依赖版本和真实报错，只允许修改导致失败的最小范围。工具调用失败时，先核对参数、权限和返回值，再决定是否重试。')
      ]),
      makeSection('pros-cons', '优点和短板', [
        prosConsBlock()
      ]),
      makeSection('conclusion', '最终结论：谁适合用 Kimi K3', [
        p('Kimi K3 适合材料多、周期长、需要代码或工具协作的任务。对于简单改写和一次性问答，使用更轻量的模型通常更省时间。'),
        bullets([
          '长文档按证据整理，编程按小步计划推进——比一次要完整答案稳。',
          '截图参与排错时，要求回答明确引用画面中的线索。',
          '涉及事实、引用和可运行代码时，始终保留人工验证。'
        ]),
        ctaBlock('还需要其他 AI 工具？', '可以按任务查看图片、视频和音乐生成模型，不必把所有工作交给同一个模型。', 'Miral AI 创作工具', '/models')
      ]),
      makeSection('search-intents', '实际应用场景', [
        p('下面六个场景覆盖 Kimi K3 最有代表性的长上下文、编程、视觉理解和开放部署需求。'),
        scenarioItem('大型代码库重构', '提供仓库地图、禁止修改模块和测试命令，先审查计划，再分批检查补丁。'),
        scenarioItem('多份长报告交叉核对', '要求标出证据页码、冲突结论和待确认信息，并逐条核对原文。'),
        scenarioItem('截图与代码联合排错', '同时提供截图、复现步骤、当前组件和真实报错，要求回答引用画面中的具体线索。'),
        scenarioItem('长任务上下文恢复', '把目标、已确认事实、未完成项和禁止修改范围整理成阶段摘要后再继续。'),
        scenarioItem('开放权重部署评估', '先核算硬件、推理框架、并发、数据要求和运维成本，再决定是否自建。'),
        scenarioItem('受控工具智能体', '限制工具和权限，定义停止条件，并为高影响操作保留人工确认。')
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何使用 Kimi K3 进行编程？', '提供项目结构、明确要修改的文件和验收条件，让模型先分析再实施，并对生成代码进行本地测试。'),
        faqItem('可以用 Kimi K3 分析长文档吗？', '可以。最好要求它按主题、证据位置、冲突点和待核实信息输出，而不是只生成普通摘要。'),
        faqItem('可以使用 Kimi K3 构建 AI 智能体吗？', '可以用于规划和执行智能体任务，但需要可靠的工具接口、权限边界、停止条件和人工确认。'),
        faqItem('Kimi K3 的模型 ID 是什么？', 'API 和兼容的第三方编码工具使用 `k3`。比较模型时还要记录推理强度和实际响应模型。'),
        faqItem('如何解决 Kimi K3 遗漏上下文的问题？', '重新提供一份包含目标、已确认事实、未完成事项和输出要求的简短状态摘要，然后从该状态继续。'),
        faqItem('Kimi K3 的 1M 上下文会记住所有内容吗？', '不会。上下文容量大不等于每个细节都能被准确调用，长任务仍需证据位置、阶段摘要和明确的输出结构。'),
        faqItem('Kimi K3 和 GPT-5.6 Sol 编程怎么选？', '需要开放权重、数据控制或自有部署时优先评估 Kimi K3；需要完整托管工具、computer use 和 OpenAI API 生态时更适合测试 GPT-5.6 Sol。'),
        faqItem('Kimi K3 可以自行部署吗？', '开放权重为自有部署提供了选择，但仍需评估硬件、推理框架、并发需求和持续运维成本。'),
        faqItem('如何解决 Kimi K3 生成代码前后不一致的问题？', '提供当前文件和真实错误信息，要求模型检查接口、依赖与数据结构，并限制它只修改导致错误的最小范围。'),
        faqItem('关闭 thinking 会影响 Kimi K3 吗？', '可能。官方说明中，关闭 thinking 可能触发其他模型路由，因此评测和 API 调用前应确认实际模型与推理设置。')
      ])
    ],
    related: ['claude-fable-5-review', 'gpt-5-6-sol-review', 'seedream-ai-image-generator-review']
  },
  {
    slug: 'claude-fable-5-review',
    category: 'ai-model-insights',
    layout: 'review',
    layoutProfile: {
      showHeroImage: true,
      headerHint: '基于 Anthropic 官方资料，拆解模型定位、使用成本、安全回退和可复核的任务测试。'
    },
    coverImage: '/images/hub/claude-fable-5-review-cover.svg?v=20260721-3',
    heroImage: '/images/hub/claude-fable-5-review-cover.svg?v=20260721-3',
    title: 'Claude Fable 5 评测：它最适合哪些编码与智能体任务？',
    excerpt: 'Claude Fable 5 是面向通用用户开放的 Mythos 级模型。本文说明它与 Mythos 5、Opus 4.8 的关系，并讨论它在长期编码、复杂文档和智能体任务中的实际位置。',
    metaTitle: 'Claude Fable 5 评测：编码与智能体适用场景',
    metaDescription: '深入分析 Claude Fable 5 的长期编码、复杂文档、工具调用与智能体能力，涵盖适用场景、局限和常见问题。',
    updatedAt: '2026-07-21',
    target: { label: 'Miral AI 创作工具', path: '/' },
    keywords: ['Claude Fable 5 测评', 'Claude Fable 5 是什么', 'Claude Fable 5 怎么用', 'Claude Fable 5 编程', 'Claude Fable 5 智能体', 'Claude Fable 5 和 Mythos 5 区别', 'Claude Fable 5 分析文档', 'Claude Fable 5 模型 ID', 'Claude Fable 5 工具调用失败', 'Claude Fable 5 Token 成本', 'Claude Fable 5 Opus 4.8 回退', 'Claude Fable 5 和 GPT-5.6 Sol 对比'],
    creatingSteps: [
      { title: '先锁定目标与边界', text: '写清项目目标、现有架构、不能修改的模块和完成标准，再让模型拆解任务。' },
      { title: '用阶段摘要推进长任务', text: '每个阶段结束记已完成、风险和下一步；长对话里不这么做，目标很容易漂。' },
      { title: '文档区分事实与建议', text: '要求模型标出事实、推断和建议，并为关键结论附上证据位置。' },
      { title: '记录模型与回退', text: '保存实际响应模型、工具轨迹和验证结果；出现 Opus 4.8 回退时单独标记。' }
    ],
    pros: [
      '面向跨文件编码、复杂文档和长时间运行的任务，而非只追求单轮回答',
      '支持视觉输入和工具调用，适合把资料分析与执行放进同一任务',
      '能将大型任务拆成可逐步检查的阶段',
      'Fable 版本让 Mythos 级能力能够面向更广泛的用户开放'
    ],
    cons: [
      '输入与输出单价都高，长任务如果缺少阶段摘要，成本会很快上升',
      '部分敏感请求可能被拦截或回退到 Opus 4.8，影响评测的一致性',
      '代码和工具返回仍需重新运行并验证，不能直接视为可交付结果',
      '它的重点是编码、知识工作和智能体任务，不是直接生成最终图片和视频'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '结论'], [
          ['总体判断', '适合需要持续编码、工具调用和状态管理的复杂工作'],
          ['最适合', '跨文件编码、知识密集型分析和需要多次工具调用的智能体'],
          ['不太适合', '无需持续上下文的简单任务，或未经验证就直接交付的高风险工作'],
          ['上手难度', '中——长任务需要阶段摘要和验收标准'],
          ['核心优势', '在较长任务中维护目标、工具状态和跨步骤依赖'],
          ['使用建议', '用阶段摘要和验收标准控制范围，并逐步验证输出']
        ], 'overview'),
        p('如果任务十分钟内就能完成，Fable 5 往往显得昂贵。它更合理的用法，是接手那些会跨越多个文件、资料来源或工具调用的工作。')
      ]),
      makeSection('what-is-claude-fable-5', 'Claude Fable 5 是什么', [
        p('Claude Fable 5 是 Anthropic 于 2026 年 6 月发布的 Mythos 级通用模型。按照 Anthropic 的模型分级，Mythos 级位于 Opus 级之上；Fable 5 面向普通用户和开发者开放，重点处理高难度编码、复杂知识工作以及需要持续运行的智能体任务。它不是 Claude 5 系列中的轻量版本，也不是单独训练的一款“小模型”。'),
        table(['项目', 'Claude Fable 5 官方信息'], [
          ['模型定位', '面向通用使用的 Mythos 级模型；能力层级高于 Opus 级'],
          ['发布时间', '2026 年 6 月 9 日；2026 年 7 月 1 日恢复全球访问'],
          ['核心场景', '长期编码、复杂知识工作、智能体任务、视觉理解与科研辅助'],
          ['模型 ID', '`claude-fable-5`'],
          ['API 价格', '每百万输入 tokens 10 美元；每百万输出 tokens 50 美元'],
          ['使用入口', 'Claude.ai、Claude Code、Claude Cowork 与 Claude API；实际权限取决于套餐和地区'],
          ['安全机制', '部分网络安全、生物化学或模型蒸馏相关请求可能回退至 Claude Opus 4.8']
        ], 'overview'),
        p('Fable 5 和 Claude Mythos 5 使用相同的底层模型，但面向的人群和安全配置不同。Fable 5 是加入额外防护、可供更广泛用户使用的版本；Mythos 5 则面向受信任的限定访问场景。换句话说，“Fable”并不代表能力更低，而是代表这套 Mythos 级能力以更严格的安全边界提供。'),
        p('因此，评测 Fable 5 不能只截取一段回答。更有意义的记录是完整任务：它读了哪些文件、改动有没有越界、工具失败后如何处理，以及最后的测试是否通过。'),
        tip('真实评测必须记录回退', '如果界面或 API 提示请求已回退到 Claude Opus 4.8，该次输出就不能算作 Fable 5 的成绩。评测记录应标明实际响应模型，否则结论会失真。')
      ]),
      makeSection('claude-fable-5-advantages', '它最擅长解决什么问题', [
        bullets([
          '跨文件修改：需要反复读取、编辑和运行测试，而不是一次生成整段代码。',
          '资料审阅：同时处理正文、表格、脚注和视觉材料，并保留证据位置。',
          '工具型智能体：在权限、人工确认点和停止条件内推进多步骤任务。'
        ]),
        p('这三类任务有一个共同点：错误会沿着后续步骤继续累积。阶段摘要、权限边界和验收标准不是提示词技巧，而是使用这类模型的基本条件。')
      ]),
      makeSection('claude-fable-5-comparison', '和 Kimi K3、GPT-5.6 Sol 相比怎么选', [
        table(['比较维度', 'Claude Fable 5', 'Kimi K3', 'GPT-5.6 Sol'], [
          ['更突出的定位', '长期编码、知识工作和受控智能体', '长上下文、原生视觉、开放权重与智能体任务', '复杂专业工作、完整工具生态与 computer use'],
          ['更适合', '跨文件代码、复杂文档和持续多阶段任务', '大量资料、多模态分析或需要开放权重的团队', '需要 OpenAI 工具生态、浏览器操作和多工具执行的团队'],
          ['需要注意', '成本、权限和安全回退需要提前记录', '自部署有工程成本，长上下文仍可能遗漏', '输出价格较高，超 272K 输入会进入更高计价档'],
          ['选择依据', '长期任务控制与 Anthropic 工作流', '数据控制、开放部署和视觉输入', '工具覆盖、computer use 与托管 API 集成']
        ], 'overview'),
        p('这里不能简单排出一张总榜。团队若看重受控的长期执行，Fable 5 更值得测试；若优先考虑开放权重或既有产品生态，选择会不同。GPT 也必须落实到具体型号后才有可比性。')
      ]),
      makeSection('claude-fable-5-case-notes', '长期任务最容易暴露的三个问题', [
        table(['案例', '任务设置', '编辑点评'], [
          ['跨文件重构', '给出仓库结构、禁止修改模块、阶段目标和测试命令', '不要只看补丁是否工整。后续步骤一旦忘记禁止修改项，或声称测试通过却没有真实结果，这次任务就应判为失败。'],
          ['复杂文档审阅', '使用包含图表、脚注和矛盾结论的材料，要求把事实、推断与建议分开', '语言流畅不是高分项，证据可追溯才是。误读脚注或把建议写成事实，都属于实质性错误。'],
          ['多工具智能体', '限制工具和权限，故意加入一次失败调用，并设置人工确认点', '记录它是否修正参数、是否遵守权限，以及是否在确认点停下。工具调用次数多，并不等于智能体表现好。']
        ], 'overview')
      ]),
      makeSection('how-to-use-claude-fable-5', '长期编码和知识工作，正确的使用方式', [
        p('先写清目标、现有架构、禁止修改的边界和完成标准。长任务应建立阶段摘要，每轮结束记录已完成内容、风险和下一步，降低目标漂移。'),
        p('读文档时，要求把事实、推断和建议分开，并为关键结论标出页码或段落。模型给出的阶段摘要也要保留，下一轮开始前先核对有没有遗漏约束。'),
        articleImage(
          '/images/hub/claude-fable-5-review-editorial.svg',
          'Claude Fable 5 长期编码、文档审阅与工具调用流程示意图',
          '长任务应保留边界、阶段摘要、工具记录和最终验证结果。'
        ),
        stepsBlock()
      ]),
      makeSection('can-claude-fable-5', '智能体任务，关键不只是多调用几个工具', [
        p('涉及外部工具时，要先明确模型可以读取和修改什么、什么时候必须停止，以及哪些操作需要人工确认。删除文件、发送消息或修改线上数据不应由含糊的自然语言授权。'),
        p('一次工具调用失败后的表现比成功调用更有参考价值：它是先读取真实错误并修正参数，还是在没有证据的情况下反复重试？这能直接反映智能体是否可靠。')
      ]),
      makeSection('what-tool-claude-fable-5', '哪些任务值得用，哪些没有必要', [
        p('复杂代码库、厚文档、工具调用和多阶段方案最能体现 Claude Fable 5 的定位。一次性的小改写、简单分类和低风险格式转换通常不需要使用这一等级的模型。'),
        table(['任务', 'Claude Fable 5 的适配度', '原因'], [
          ['长期编码 / 跨文件修改', '高', '强调多阶段状态、约束和工具协作'],
          ['复杂文档分析', '高', '适合区分事实、推断和建议并保留证据'],
          ['工具调用智能体', '高', '可在权限和确认机制下推进复杂任务'],
          ['简单改写或分类', '低', '复杂模型会带来不必要的时间与成本']
        ], 'overview')
      ]),
      makeSection('fix-claude-fable-5', '成本、工具调用和范围漂移', [
        p('回答过长时，可以限定字数、格式和决策范围，并要求先给结论再给证据。Token 用量过高时，应删除重复上下文、使用阶段摘要，并把简单分类和格式转换交给轻量模型。'),
        p('工具调用失败时，先核对工具名、参数、权限和真实报错，再要求模型只修复当前失败步骤。遇到安全限制时，应把合法任务拆成更小、更明确的子任务，而不是尝试绕过保护。')
      ]),
      makeSection('pros-cons', '优点和短板', [
        prosConsBlock()
      ]),
      makeSection('conclusion', '最终结论：谁适合 Claude Fable 5', [
        p('Claude Fable 5 的优势是让复杂任务保持结构和状态。它是否值得选择，取决于任务是否真的需要长期编码、工具调用和知识密集型分析，而不是它能否替代所有其他模型。'),
        bullets([
          '长任务用阶段摘要推进，高影响操作保留人工确认。',
          '出现模型回退时单独记录，不与 Fable 5 的结果混在一起。',
          '对代码、工具返回和关键结论保留人工验证。'
        ]),
        ctaBlock('还需要其他 AI 工具？', '可以按任务查看图片、视频和音乐生成模型，不必把所有工作交给同一个模型。', 'Miral AI 创作工具', '/models')
      ]),
      makeSection('search-intents', '实际应用场景', [
        p('下面六个场景集中在 Claude Fable 5 的长期编码、复杂文档、工具调用和安全回退。'),
        scenarioItem('跨文件代码迁移', '写清禁止修改模块、阶段目标和测试命令，逐阶段检查范围与结果。'),
        scenarioItem('图表与脚注审阅', '把事实、推断和建议分开，并为关键结论附上页码或段落。'),
        scenarioItem('工具调用失败恢复', '先核对真实报错、参数和权限，再只修复当前失败步骤，避免无依据重试。'),
        scenarioItem('带确认点的长期智能体', '保存阶段状态、限制工具权限，并在发送、删除或修改线上数据前要求确认。'),
        scenarioItem('长项目 Token 成本控制', '删除重复上下文、维护简短阶段摘要、限制输出长度，并把简单任务交给轻量模型。'),
        scenarioItem('Opus 4.8 回退识别', '部分敏感领域请求会触发安全路由；比较结果时要记录实际响应模型。')
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何使用 Claude Fable 5 进行编程？', '提供代码库背景、限制条件和测试标准，让模型先制定小步计划，再逐项修改和验证。'),
        faqItem('可以用 Claude Fable 5 执行长期智能体任务吗？', '可以，但应保存阶段状态、限制工具权限，并为高影响操作设置人工确认。'),
        faqItem('Claude Fable 5 和 Claude Mythos 5 有什么区别？', '两者使用相同的底层模型。Fable 5 增加了面向广泛用户开放所需的安全防护；Mythos 5 用于受信任的限定访问场景。'),
        faqItem('Claude Fable 5 的模型 ID 是什么？', 'Claude API 使用 `claude-fable-5`。评测时还应记录实际响应模型，以识别是否发生 Opus 4.8 回退。'),
        faqItem('如何解决 Claude Fable 5 工具调用失败的问题？', '核对工具定义、参数、权限和真实错误信息，再要求模型只修复当前失败步骤。'),
        faqItem('可以用 Claude Fable 5 分析复杂文档吗？', '可以。要求它区分事实、推断和建议，并为关键结论标出对应来源，能够让结果更容易检查。'),
        faqItem('Claude Fable 5 和 GPT-5.6 Sol 编程怎么选？', '重视 Anthropic 的长期任务工作流和受控智能体时可以优先测试 Fable 5；需要更广的托管工具、computer use 和 OpenAI API 集成时更适合测试 GPT-5.6 Sol。'),
        faqItem('为什么 Claude Fable 5 会回退到 Opus 4.8？', 'Anthropic 会对部分网络安全、生物化学和模型蒸馏相关请求启用安全路由。发生回退时，该次结果不能计入 Fable 5 的评测。'),
        faqItem('如何降低 Claude Fable 5 的 Token 成本？', '删除重复上下文，使用阶段摘要，为输出设置明确长度，并把分类、格式转换等简单任务交给更轻量的模型。'),
        faqItem('如何解决 Claude Fable 5 回答过长的问题？', '要求先给出简短结论，再按指定数量列出证据或行动项，同时明确字数、格式和不需要展开的内容。')
      ])
    ],
    related: ['gpt-5-6-sol-review', 'kimi-k3-review', 'seedream-ai-image-generator-review']
  },
  {
    slug: 'gpt-5-6-sol-review',
    category: 'ai-model-insights',
    layout: 'review',
    layoutProfile: {
      showHeroImage: true,
      headerHint: '从官方规格、公开评测、API 成本和实际任务判断 GPT-5.6 Sol 是否值得使用。'
    },
    coverImage: '/images/hub/gpt-5-6-sol-review-cover.svg',
    heroImage: '/images/hub/gpt-5-6-sol-review-cover.svg',
    title: 'GPT-5.6 Sol 评测：旗舰能力、工具生态与使用成本',
    excerpt: 'GPT-5.6 Sol 是 GPT-5.6 系列的旗舰模型，提供 1.05M 上下文、128K 最大输出和完整工具支持。本文分析它在编码、专业研究、计算机操作和智能体任务中的实际位置。',
    metaTitle: 'GPT-5.6 Sol 评测：能力、工具与 API 成本',
    metaDescription: '深入分析 GPT-5.6 Sol 的 1.05M 上下文、编码、专业研究、工具调用与智能体能力，涵盖价格、局限、模型对比和使用场景。',
    updatedAt: '2026-07-21',
    target: { label: 'Miral AI 创作工具', path: '/' },
    keywords: ['GPT-5.6 Sol 评测', 'GPT-5.6 Sol 是什么', 'GPT-5.6 Sol 怎么用', 'GPT-5.6 Sol 编程', 'GPT-5.6 Sol API 价格', 'GPT-5.6 Sol 上下文', 'GPT-5.6 Sol 模型 ID', 'GPT-5.6 Sol 和 Claude Fable 5', 'GPT-5.6 Sol 和 Kimi K3', 'GPT-5.6 Sol Agent', 'GPT-5.6 Sol computer use', 'GPT-5.6 Sol reasoning effort'],
    creatingSteps: [
      { title: '先选择合适的推理强度', text: '简单任务从 low 或 medium 开始，复杂编码和研究再提高到 high、xhigh 或 max。' },
      { title: '长任务先划定证据和修改范围', text: '提供资料清单、允许修改的文件、工具权限和验收标准，避免上下文变长后范围失控。' },
      { title: '保留完整工具记录', text: '记录搜索、文件读取、代码执行和计算机操作结果，不能只看模型最后一段总结。' },
      { title: '控制超长输入成本', text: '超过 272K 输入 tokens 前先去重、分段和建立索引，因为整次请求会进入更高计价档。' }
    ],
    pros: [
      '1.05M 上下文和 128K 最大输出适合大型代码库、长文档与多阶段任务',
      '支持网页搜索、文件搜索、代码解释器、托管 shell、computer use、MCP 和工具搜索',
      '推理强度覆盖 none 到 max，可以按任务难度控制速度和成本',
      'Responses API 中支持面向复杂工具流程的能力，适合构建专业智能体'
    ],
    cons: [
      '每百万输出 tokens 30 美元，长任务若缺少预算控制会迅速增加成本',
      '输入超过 272K tokens 后，整次请求的输入与输出都会按更高倍率计价',
      '超长上下文不保证每个细节都能被准确调用，证据与代码仍需复核',
      '不支持微调，敏感网络安全和生物相关任务还可能触发额外检查或拒绝'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '结论'], [
          ['总体判断', '适合高难度编码、长资料研究、computer use 和多工具智能体'],
          ['最适合', '大型代码库、专业知识工作、跨工具执行和长时间运行的任务'],
          ['没有必要使用', '简单改写、分类和对成本敏感的高频短请求'],
          ['核心规格', '1.05M 上下文、128K 最大输出、文本与图像输入'],
          ['API 价格', '每百万输入 5 美元、缓存输入 0.50 美元、输出 30 美元'],
          ['使用建议', '先用中等推理强度建立基线，再按任务难度提高；超长输入前先估算成本']
        ], 'overview'),
        p('GPT-5.6 Sol 的优势集中在复杂度和持续性。任务若只需要一轮短回答，Terra、Luna 或其他轻量模型通常更合适。')
      ]),
      makeSection('what-is-gpt-5-6-sol', 'GPT-5.6 Sol 是什么', [
        p('GPT-5.6 Sol 是 OpenAI 于 2026 年 7 月正式发布的 GPT-5.6 系列旗舰模型，面向复杂专业工作。Sol、Terra 和 Luna 是同一代模型的三个能力与成本层级：Sol 追求最高能力，Terra 平衡能力和价格，Luna 面向速度与高频任务。'),
        table(['项目', 'GPT-5.6 Sol 官方信息'], [
          ['模型定位', 'GPT-5.6 系列旗舰模型，面向复杂推理、编码和专业工作'],
          ['模型 ID', '`gpt-5.6-sol`；`gpt-5.6` 别名路由到 Sol'],
          ['上下文窗口', '1,050,000 tokens'],
          ['最大输出', '128,000 tokens'],
          ['知识截止日期', '2026 年 2 月 16 日'],
          ['输入与输出', '文本和图像输入，文本输出'],
          ['推理强度', 'none / low / medium / high / xhigh / max'],
          ['API', 'Responses API 与 Chat Completions API'],
          ['微调', '不支持']
        ], 'overview'),
        p('名称中的 Sol 代表旗舰能力层级，并不是单独的产品。ChatGPT、Codex 和 API 对推理强度与可用模式的展示不同，因此比较前应记录产品入口、实际模型和 reasoning effort。'),
        tip('模型 ID 与产品模式不要混淆', '`gpt-5.6-sol` 是 API 模型 ID；ChatGPT 中的 Sol Pro、Codex 的 max，以及 ChatGPT Work 的 ultra 属于不同产品配置，不能直接当作同一测试条件。')
      ]),
      makeSection('gpt-5-6-family', 'Sol、Terra 和 Luna 怎么选', [
        table(['型号', '定位', 'API 输入 / 输出价格', '更合适的任务'], [
          ['GPT-5.6 Sol', '旗舰能力', '$5 / $30', '复杂编码、专业研究、computer use、长程智能体'],
          ['GPT-5.6 Terra', '能力与成本平衡', '$2.50 / $15', '日常专业工作、批量分析和常规开发'],
          ['GPT-5.6 Luna', '速度与成本优先', '$1 / $6', '分类、抽取、高频短任务和轻量自动化']
        ], 'overview'),
        p('不要只按“越强越好”选择。大量重复任务先用 Luna 或 Terra 建立质量基线，把需要长时间推理、复杂工具协作或高价值判断的部分交给 Sol，通常更容易控制总成本。')
      ]),
      makeSection('gpt-5-6-sol-advantages', 'GPT-5.6 Sol 的主要优势', [
        bullets([
          '大型代码库：长上下文可以容纳更多文件、接口和历史决策，配合 apply patch 与托管 shell 完成分阶段修改。',
          '专业知识工作：网页搜索、文件搜索与代码解释器可以把资料查找、数据处理和结论整理放在同一流程。',
          '计算机操作：computer use 适合需要浏览器或桌面界面的任务，但高影响操作仍应保留人工确认。',
          '工具协调：MCP、工具搜索和函数调用让模型能按任务选择工具，而不必把所有能力写进单个提示词。',
          '长输出：最高 128K 输出适合生成较完整的代码、报告或迁移方案，但不应把长度当成质量指标。'
        ])
      ]),
      makeSection('gpt-5-6-sol-comparison', '和 Claude Fable 5、Kimi K3 相比怎么选', [
        table(['比较维度', 'GPT-5.6 Sol', 'Claude Fable 5', 'Kimi K3'], [
          ['更突出的定位', '复杂专业工作、完整工具生态、computer use 与多智能体', '长期编码、知识工作和受控智能体', '1M 上下文、原生视觉和开放权重'],
          ['上下文', '1.05M', '以当前 Anthropic 产品文档为准', '最高 1M'],
          ['部署方式', 'OpenAI 托管 API 与产品', 'Anthropic 托管 API 与产品', '开放权重，可评估自有部署'],
          ['价格关注点', '长输入阶梯计价与输出成本', '较高的输入输出单价', '自部署硬件、推理和运维成本'],
          ['选择依据', '工具覆盖、computer use、复杂任务效率', '持续任务控制与 Anthropic 工作流', '数据控制、开放部署和长上下文需求']
        ], 'overview'),
        p('OpenAI 公布的评测显示 Sol 在多项编码和专业任务上进步明显，但厂商基准不能替代团队自己的验收任务。选择时应固定输入、工具、推理强度和通过标准。')
      ]),
      makeSection('gpt-5-6-sol-case-notes', '最值得测试的三个专业工作流', [
        table(['案例', '任务设置', '观察重点'], [
          ['大型仓库迁移', '提供架构说明、禁止修改清单和测试命令，要求分阶段迁移接口', '是否越界、测试是否真实执行、后续阶段能否保持早期约束'],
          ['多来源专业研究', '提供本地文件并允许网页搜索，要求区分来源事实、计算结果和编辑判断', '引用能否追溯、工具结果是否被正确解释、冲突证据有没有保留'],
          ['浏览器与工具协作', '设置登录前停止、写入前确认和失败恢复规则，完成跨页面资料整理', '是否遵守确认点、界面变化后能否恢复、有没有在未授权时执行高影响操作']
        ], 'overview')
      ]),
      makeSection('gpt-5-6-sol-cost', '1.05M 上下文的成本不能忽略', [
        p('Sol 的标准 API 价格是每百万输入 tokens 5 美元、缓存输入 0.50 美元、输出 30 美元。提示词超过 272K 输入 tokens 后，整次请求按两倍输入价和 1.5 倍输出价计算，不是只对超出的部分加价。'),
        p('这意味着“把所有文件一次塞进去”可能同时增加检索难度和费用。先清除重复文件、建立目录与摘要、只加载当前阶段需要的材料，通常比单纯追求最大上下文更有效。'),
        tip('缓存也有写入成本', 'GPT-5.6 的缓存读取享受 90% 折扣，但缓存写入按未缓存输入价格的 1.25 倍计费。重复使用稳定前缀时缓存更有价值。')
      ]),
      makeSection('how-to-use-gpt-5-6-sol', '如何使用 GPT-5.6 Sol', [
        p('编码任务先给仓库地图、允许修改的文件、测试命令和完成标准。研究任务把来源范围、引用格式和不确定性标记写清楚。涉及工具时，再补权限、停止条件和必须确认的操作。'),
        p('推理强度不必默认拉到 max。先用 medium 或 high 跑一组代表性任务，记录质量、延迟、token 和工具失败率；只有当复杂任务的通过率确实提高时，再使用更高档位。'),
        articleImage(
          '/images/hub/gpt-5-6-sol-review-editorial.svg',
          'GPT-5.6 Sol 长上下文、工具调用与专业任务工作流示意图',
          '先限定输入与权限，再分阶段执行、记录工具结果并完成最终验证。'
        ),
        stepsBlock()
      ]),
      makeSection('fix-gpt-5-6-sol', '使用前要注意的问题', [
        p('长上下文出现遗漏时，不要重复发送全部材料。先让模型列出当前引用的文件和未解决项，再补缺失来源。代码修改范围扩大时，恢复禁止修改清单，并要求只提交最小补丁。'),
        p('computer use 或工具调用失败时，应检查页面状态、工具参数、权限和真实返回值。模型能够调用工具，不代表每一次调用都正确，也不代表可以跳过人工审批。')
      ]),
      makeSection('pros-cons', '优点和短板', [
        prosConsBlock()
      ]),
      makeSection('conclusion', '最终结论：谁适合 GPT-5.6 Sol', [
        p('GPT-5.6 Sol 更适合复杂度高、资料多、工具链长且结果价值较高的任务。团队若只处理短问答或批量抽取，Terra、Luna 或其他轻量模型通常更经济。'),
        bullets([
          '用固定任务比较推理强度，不要默认 max 就一定更划算。',
          '超过 272K 输入前先估算阶梯价格，并清理重复上下文。',
          '对代码、引用、工具结果和高影响操作保留人工验证。'
        ]),
        ctaBlock('还需要其他 AI 工具？', '可以按任务查看图片、视频和音乐生成模型，不必把所有工作交给同一个模型。', 'Miral AI 创作工具', '/models')
      ]),
      makeSection('search-intents', '实际应用场景', [
        p('下面这些任务更能体现 GPT-5.6 Sol 的长上下文、工具协作和专业工作能力。'),
        scenarioItem('多服务代码迁移', '先锁定接口、禁止修改项和测试命令，再按服务分批修改并验证。'),
        scenarioItem('多来源专业研究', '结合文件搜索与网页搜索整理证据，分别标出来源事实、计算结果和待确认内容。'),
        scenarioItem('Computer use 网页操作', '设置登录、提交和写入前的人工确认点，并保存每一步的页面状态。'),
        scenarioItem('可编辑专业文档生成', '提供模板、信息层级和验收清单，重点检查引用、数字、版式与可编辑性。'),
        scenarioItem('超长上下文项目管理', '按阶段加载材料，维护文件索引和状态摘要，避免重复输入推高成本。'),
        scenarioItem('多工具智能体', '限制工具集合和权限，加入失败返回与停止规则，检查模型能否恢复并正确结束。')
      ]),
      makeSection('faq', '常见问题', [
        faqItem('GPT-5.6 Sol 是什么？', '它是 GPT-5.6 系列的旗舰模型，面向复杂编码、专业知识工作、computer use 和智能体任务。'),
        faqItem('GPT-5.6 Sol 的模型 ID 是什么？', 'API 模型 ID 是 `gpt-5.6-sol`，`gpt-5.6` 别名也会路由到 Sol。'),
        faqItem('GPT-5.6 Sol 的上下文窗口多大？', '官方规格为 1,050,000 tokens，最大输出为 128,000 tokens。'),
        faqItem('GPT-5.6 Sol 的 API 价格是多少？', '标准价格为每百万输入 tokens 5 美元、缓存输入 0.50 美元、输出 30 美元。超长输入会进入更高计价档。'),
        faqItem('GPT-5.6 Sol 和 Terra、Luna 有什么区别？', 'Sol 面向最高能力，Terra 平衡能力与成本，Luna 优先速度与低成本。'),
        faqItem('GPT-5.6 Sol 适合编程吗？', '适合大型代码库、命令行工具和长程工程任务，但生成代码仍需运行测试并检查修改范围。'),
        faqItem('GPT-5.6 Sol 支持图像输入吗？', '支持文本和图像输入以及文本输出，也可通过 Responses API 使用图像生成等工具。'),
        faqItem('GPT-5.6 Sol 支持微调吗？', '当前官方模型页面标明不支持微调。'),
        faqItem('什么时候不应该使用 GPT-5.6 Sol？', '简单改写、分类和高频短请求通常不需要旗舰模型，可以先比较 Terra、Luna 或其他轻量模型。'),
        faqItem('如何降低 GPT-5.6 Sol 的使用成本？', '减少重复上下文、利用稳定前缀缓存、限制输出长度，并在输入超过 272K tokens 前重新评估材料范围。')
      ])
    ],
    related: ['claude-fable-5-review', 'kimi-k3-review', 'gpt-image-generator-guide']
  },
  {
    slug: 'seedream-ai-image-generator-review',
    category: 'reviews',
    layout: 'review',
    coverImage: 'seedream-product',
    heroImage: 'seedream-hero',
    title: 'Seedream 5 测评：电商主图与生活方式海报实测',
    excerpt: 'Miral 实测 Seedream 5 于亚马逊主图、Shopify 横幅图、eBay 商品图和 Instagram 产品帖上的表现，含提示词示例，以及和 FLUX、Midjourney 的选型建议。',
    metaTitle: 'Seedream 5 测评：电商主图、提示词与在线使用 | Miral',
    metaDescription: 'Miral Seedream 5 测评：亚马逊主图、Shopify、eBay、Etsy、Google Shopping 商品图怎么写提示词，和 FLUX、Midjourney 怎么选。',
    updatedAt: '2026-07-03',
    target: { label: '打开 Seedream 5 试一版', path: '/image-models/seedream-ai-image-generator' },
    keywords: ['Seedream AI 图片生成器', 'Seedream 提示词', 'Seedream 产品图', 'AI 电商主图', 'AI 商品图生成', 'eBay 商品图生成', 'Google Shopping 商品广告图', 'Seedream vs FLUX'],
    creatingSteps: [
      { title: '先定图片用途', text: '想清楚是做白底主图、带场景的产品海报，还是人像/社媒封面——用途不同，提示词写法差很多。' },
      { title: '写主体 + 场景 + 光线', text: 'Seedream 对「产品材质、摆放、镜头、光线」反应明显。别只写「一瓶香水」，补上台面、光感和摄影风格。' },
      { title: '连出 2–3 版再微调', text: '第一版常能看方向；第二版改背景色、构图或比例，比一次写超长提示词更有效。' },
      { title: '不满意就换模型', text: '要更硬的真实摄影质感试 FLUX；要艺术插画试 Midjourney；海报上要清晰文字试 GPT Image。' }
    ],
    pros: [
      '产品图、生活方式海报这类「按文字描述出片」的场景，上手快',
      '提示词不用堆参数，把主体、场景、光线写清楚就有稳定输出',
      '和 FLUX、Midjourney 在同一平台，试完不满意可以立刻换模型',
      '适合电商主图、社媒封面、品牌视觉草图等日常商业需求'
    ],
    cons: [
      '复杂英文排版或长句标题，不如 GPT Image 稳',
      '追求极致肤质、金属反光等硬质感时，FLUX 往往更耐看',
      '强风格插画、概念艺术不是它的强项，Midjourney 更合适',
      '正式商用前仍建议检查产品细节和品牌合规'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', '亚马逊主图、eBay 商品图、带场景的产品图、Instagram 产品帖、Shopify 横幅图'],
          ['不太适合', '强艺术插画、大段标题海报、要交稿的硬质感珠宝/手表摄影'],
          ['上手难度', '低——浏览器打开就能用，按日常描述写即可'],
          ['和 FLUX 比', 'Seedream 跟描述快；FLUX 材质和光影更「硬」'],
          ['我的建议', '先 Seedream 5 出 2–3 版定方向，质感不够再换 FLUX.2']
        ], 'overview'),
        p('一句话：做亚马逊、Shopify、Etsy、eBay 这类商业视觉，Seedream 5 是我会先开的模型；要艺术插画或复杂排版，同页换别的模型就行。')
      ]),
      makeSection('what-is-seedream', 'Seedream 是什么', [
        p('Seedream 偏真实感商业出图，不是那种一上来就给你很「艺术」的风格。用 Seedream 5 输入描述即可在线生图——浏览器打开就行，不用 Discord，也不用自己搭 Stable Diffusion。'),
        p('我把它当成「先把画面搭起来」的工具：产品放哪、什么光、什么背景，Seedream 通常几版就能看明白。真要抠玻璃瓶反光、金属边缘那种细节，我会同一套描述再跑 FLUX。'),
        p('和 Midjourney 比，Seedream 不追求奇幻氛围，更跟「产品 + 场景 + 光线」这类商业描述；和 GPT Image 比，它擅长画面而不是把大段标题排版进图里。新手从电商主图或生活方式海报入手最顺。')
      ]),
      makeSection('how-i-tested', '我实际测了什么', [
        p('这次测的是一款 30ml 护肤品玻璃瓶：亚马逊主图、Instagram 4:5 产品帖、白底 SKU 图各做一轮。每轮连出 5–6 版，记录哪一版能直接用、哪一版要改提示词。'),
        p('主图第一轮只写了「护肤品瓶身，白色背景」——能看，但台面像塑料、产品边缘发虚。第二轮加了「浅绿大理石台面、柔光、商业产品摄影、浅景深」，第三版就明显能用了。白底图反而要多试几版：有两次瓶底阴影脏、一次标签糊，第四版才挑出来上传。'),
        p('Instagram 产品帖那条，我写了人物 + 产品的组合，Seedream 对「生活方式杂志风构图、阴天柔光」反应不错；人脸不算完美，但改配色和背景比从头找图快。运动鞋和室内场景是额外试的，主要想看非美妆类能不能同样跟手——结论是可以，照样是「主体 + 场景 + 光线」三板斧。'),
        gallery(['seedream-product', 'seedream-lifestyle', 'seedream-sneaker', 'seedream-interior'], '上面四类需求里挑的代表出图', 4),
        tip('和 FLUX 对比的小结', '同一瓶护肤品的提示词，Seedream 第三版构图已经满意；换 FLUX.2 后玻璃高光和瓶身轮廓更利，但多等一轮。赶交付先用 Seedream，交客户终稿再 FLUX，是我现在的习惯。'),
        stepsBlock()
      ]),
      makeSection('ecommerce-scenarios', '电商主图怎么写', [
        p('亚马逊主图、Etsy 商品页、eBay 商品图、Shopify 横幅图看起来都是「产品图」，写法其实不一样。亚马逊更吃干净背景和材质；Etsy 生活方式图要写使用场景；eBay 更需要真实状态和细节；独立站横幅图得把 16:9 和品牌色写进提示词。Seedream 的好处是同一页改几句就能切换，不用换工具。'),
        table(['平台和场景', '我一般会加什么', '备注'], [
          ['亚马逊主图', '台面材质、柔光、产品居中', '白底要多出几版挑边缘'],
          ['亚马逊 A+ / Etsy 场景图', '使用场景、自然光、产品清晰', '适合 Seedream 5 和 4 都行'],
          ['eBay 商品图', '真实状态、细节特写、干净背景', '二手、翻新、小众商品别过度美化'],
          ['Walmart Marketplace 商品图', '产品居中、浅背景、真实材质', '日用品和家电主图更适合稳妥写法'],
          ['Shopify 横幅图', '16:9、品牌色、首屏构图', '定方向够，终稿可 FLUX'],
          ['WooCommerce 和 BigCommerce 商品图', '系列套装、品牌色、4:3 或 1:1', '独立站详情页可继续用 GPT Image 加卖点'],
          ['Squarespace 独立站横幅图', '16:9、生活方式场景、留标题区', '适合视觉型品牌首页'],
          ['TikTok Shop 商品图', '动感背景、产品前景大', '高饱和背景它跟得住'],
          ['Google Shopping 商品广告图', '产品清楚、少文字、白底或浅背景', '先别做成复杂海报'],
          ['极简白底 SKU', '纯白背景、商业摄影', '边缘不够利就再出一版'],
          ['珠宝 / 手表终稿', '微距、边缘光', 'Seedream 定构图，FLUX 交终稿']
        ], 'overview'),
        p('跨境店我常这么干：Seedream 先出 3 版场景 → 选构图 → 同一描述 FLUX 终稿 → 要英文卖点再 GPT Image。比 Midjourney 出艺术风再 P 产品省事。'),
        tip('白底主图的小坑', '只写「白色背景」有时边缘发虚或阴影脏；加上「商业摄影、柔光、产品居中」并多生成几版，第四版才满意的情况我遇到过。')
      ]),
      makeSection('social-scenarios', '社媒封面与海报', [
        p('Instagram 产品帖我习惯写清 4:5、杂志风构图、人物和产品关系；Pinterest 图钉图加 2:3 和生活方式元素就行。Seedream 不擅长把大段标题写进画面——那种活我会让 GPT Image 做，Seedream 只出无底图。'),
        p('邮件通讯头图、领英封面也适用同一套写法：比例写进提示词，氛围词（干净、暖色、杂志风）比空泛的「好看」有用。人物出镜时加「自然肤色、阴天柔光」，比单写「一个女生」出片率高。'),
        tip('Seedream 5 和 4', '新单子用 5；老项目如果提示词库建在 4 上可以继续用，写法通用，不必为了升级重头来。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('prompt-tips', '提示词怎么写', [
        p('别堆参数，按这个顺序写通常就够：主体是谁 → 材质颜色 → 放哪 / 什么背景 → 什么光 → 镜头或摄影风格 → 这张图干什么用（主图、封面、横幅图）。'),
        bullets([
          '只写「一瓶香水」往往虚；写「大理石台面、柔光、浅景深」会稳很多。',
          'Instagram、Pinterest 记得写比例：4:5、1:1、2:3，以及「杂志风构图」这类词。',
          '人像加「35mm、阴天柔光、自然肤色」，比「一个女生」靠谱。',
          '第一版故意写短，看方向；第二版再补背景和风格——比一次写满屏字高效。',
          '宠物、家居、食品等非 3C 品类同样适用：主体 + 使用场景 + 光线 + 用途（主图或横幅图）。',
          '同一条提示词在 Seedream 和 FLUX 各出一版，客户选构图还是选质感一目了然。'
        ])
      ]),
      makeSection('prompt-examples', '提示词与出图示例', [
        promptExample('3×3 材质展示架', '正面视角的 3×3 展示架，九种不同材质和颜色的物体按要求排列，保持统一影棚光和准确空间位置。', 'seedream-seo-grid'),
        promptExample('编辑风商品静物摄影', '手表、折叠亚麻布与陶瓷杯组成的编辑风商品摄影，三角构图，柔和晨光。', 'seedream-seo-still-life'),
        promptExample('电影感市场场景', '电影感市场场景，前景有人群，中心主体清晰，空间层次丰富，暖光映照在湿润路面上。', 'seedream-seo-market'),
        promptExample('陶瓷花瓶复杂构图', '正面视角的编辑风场景：三个不同造型的陶瓷花瓶摆放在错落的石质展台上，最高花瓶后方放置一个红色球体，柔和侧光，间距均衡，中性影棚背景。', 'seedream-seo-vases'),
        promptExample('人物背景与服装编辑', '保留人物身份和面部特征，将背景替换为柔和晨光下的极简摄影棚，并把服装调整为深绿色。', 'seedream-seo-studio-edit'),
        promptExample('雨夜角色一致性', '参考同一角色的外貌和服装特征，生成她在雨夜城市街道行走的电影感画面，保持面部、发型和配色一致。', 'seedream-seo-rain-character'),
        promptExample('未来海滨城市全景', '日出时分的未来海滨城市全景，层叠建筑、倒映水面、丰富空气透视、精细建筑细节，宽幅电影感构图。', 'seedream-seo-coastal-city'),
        promptExample('绿色香水瓶商品摄影', '一张干净的编辑风商品摄影：半透明绿色香水瓶放在石灰岩上，柔和晨光，细腻阴影，高端广告质感。', 'seedream-seo-perfume')
      ]),
      makeSection('model-pick', '和 FLUX、Midjourney 怎么选', [
        p('没有「最好」，只有「这单活适合谁」。我现在的默认是：商业产品视觉先 Seedream，质感终稿 FLUX，艺术探索 Midjourney，带字海报 GPT Image。'),
        table(['你的需求', '我会先试', '原因'], [
          ['电商主图、场景海报', 'Seedream 5', '跟描述快，改提示词成本低'],
          ['硬质感产品摄影', 'FLUX.2', '金属、玻璃、皮肤更利'],
          ['插画、概念艺术', 'Midjourney', '风格化强'],
          ['海报上要清楚标题', 'GPT Image 1.5', '文字可控']
        ], 'overview'),
        links('同页可切换', [
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'Midjourney', path: '/image-models/midjourney-ai-image-generator' },
          { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何用 Seedream 制作电商产品图？', '写清「产品 + 场景 + 光线 + 用途」。亚马逊主图先出几版干净构图，再慢慢抠材质和背景。'),
        faqItem('可以用 Seedream 做亚马逊主图吗？', '可以。白底或浅背景可行，但边缘常要 3–4 版才稳；生活方式场景往往第二版就能用。'),
        faqItem('是否能用 Seedream 做 Shopify 生活方式图？', '可以。横幅写 16:9 + 品牌色 + 首屏构图；主图用 1:1，写法和亚马逊类似。'),
        faqItem('做电商主图应该用什么 AI 工具？', '先用 Seedream 定商业场景；要更硬的玻璃/金属质感换 FLUX；要可读促销字再上 GPT Image。'),
        faqItem('Seedream 出图商品细节不准怎么修复？', '缩短提示词、锁死产品描述后重出；材质仍软就同一构图去 FLUX 交终稿。'),
        faqItem('Seedream 5 和 4 差别大吗？', '日常商业图写法通用，新任务我直接用 5。老项目如果提示词都调在 4 上，不必强行迁移。'),
        faqItem('不会写复杂提示词行吗？', '行。写清「玻璃瓶、大理石台面、柔光、亚马逊产品图」一样出片。'),
        faqItem('和 FLUX 怎么分工？', 'Seedream 定构图和氛围；FLUX 交质感。同一描述各出一版，客户也好选。'),
        faqItem('海报上的促销标题能直接生成吗？', '大段标题别赌 Seedream，画面用它，文字用 GPT Image。'),
        faqItem('Seedream 能做 eBay 商品图吗？', '能。写真实状态、细节特写和干净背景，二手或翻新商品不要过度美化。'),
        faqItem('Google Shopping 商品广告图怎么写？', '写产品清楚、白底或浅背景、少文字、1:1；要促销标题再交给 GPT Image。'),
        faqItem('Seedream 和 Midjourney 做电商哪个好？', '电商终稿 Seedream 跟手；MJ 更适合定艺术方向，终稿建议换 Seedream 或 FLUX。')
      ])
    ],
    related: ['flux-ai-image-generator-review', 'midjourney-alternative-online', 'gpt-image-generator-guide']
  },
  {
    slug: 'flux-ai-image-generator-review',
    category: 'reviews',
    layout: 'review',
    coverImage: 'flux-watch',
    heroImage: 'flux-hero',
    title: 'FLUX.2 测评：产品摄影与广告图，三版本怎么选',
    excerpt: 'Miral 对比 FLUX.2、Pro Ultra、Schnell 于产品摄影、Walmart 商品图、Wayfair 家居图和广告大片上的差异，附提示词示例和与 Seedream 的选型建议。',
    metaTitle: 'FLUX.2 测评：产品摄影、提示词与三版本对比 | Miral',
    metaDescription: 'Miral FLUX.2 测评：AI 产品摄影、Walmart、Target、Wayfair 商品图和广告图怎么写提示词，FLUX.2 / Pro Ultra / Schnell 怎么选。',
    updatedAt: '2026-07-03',
    target: { label: '打开 FLUX.2 试一版', path: '/image-models/flux-2-ai-image-generator' },
    keywords: ['FLUX AI 图片生成器', 'FLUX 提示词', 'FLUX 产品图', 'FLUX.2 在线', 'AI 广告图生成', 'Walmart 商品图', 'Wayfair 家居产品图', 'Target 商品广告图', 'FLUX vs Seedream'],
    creatingSteps: [
      { title: '选对 FLUX 版本', text: '要质量选 FLUX.2 或 Flux Pro 1.1 Ultra；只是看构图和光感方向，Flux Schnell 更省积分、更快。' },
      { title: '提示词里写「摄影语言」', text: 'FLUX 对镜头、光线、材质很敏感。加上「微距、边缘光、冷色调、生活方式摄影」比只写产品名出片率高。' },
      { title: '同一提示词多跑几版', text: 'FLUX 单张质量高，但构图会有波动。正式用途建议连出 3 版再挑。' },
      { title: '和 Seedream 交叉验证', text: '同一需求两个模型各出一版：Seedream 往往更快跟描述，FLUX 往往质感更硬——看项目更吃速度还是吃质感。' }
    ],
    pros: [
      '产品材质、金属反光、皮肤质感比多数通用模型更「摄影感」',
      'FLUX.2、Pro Ultra、Schnell 分工清楚，草图和终稿都能覆盖',
      '广告风、生活方式、食物、室内等商业摄影方向稳定',
      '和 Seedream、Midjourney 同平台，对比试模型很方便'
    ],
    cons: [
      '出图速度通常比 Schnell 类快速模型慢，比 Seedream 试方向略重',
      '强艺术插画、二次元风不是主战场，Midjourney 更合适',
      '海报上的多行文字仍建议 GPT Image 辅助',
      '高要求项目要多生成几版挑，不能指望一次完美'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', '产品广告图、Walmart 商品图、Wayfair 家居图、硬质感静物、肤质要求高的人像'],
          ['不太适合', '快速试很多创意方向、强艺术插画、复杂文字海报'],
          ['版本怎么选', 'FLUX.2 日常出片；Pro Ultra 大图提案；Schnell 试构图'],
          ['和 Seedream 比', 'FLUX 质感更硬；Seedream 跟描述更快'],
          ['我的建议', '交稿用 FLUX.2；探索阶段 Schnell + Seedream 组合']
        ], 'overview'),
        p('一句话：如果要金属反光、玻璃质感、Wayfair 家居摄影或 Walmart 商品图那种「硬」的真实感，FLUX.2 是我交稿时的默认；只是看方向，Flux Schnell 更省。')
      ]),
      makeSection('what-is-flux', 'FLUX 是什么', [
        p('FLUX 偏商业摄影质感，集成 FLUX.2、Flux Pro 1.1 Ultra 和 Flux Schnell 三个常用入口，浏览器打开就行，不用本地显卡。'),
        p('我把它和 Seedream 分工：Seedream 先定构图和场景，FLUX 抠材质和光影。艺术插画、二次元风则换 Midjourney 或 Stable Diffusion，不是 FLUX 的主场。'),
        p('三个版本别混用：Schnell 是「试构图的草稿纸」，FLUX.2 是日常交稿，Pro Ultra 留给大图提案或客户要放大看细节的时候。第一次用建议从手表、咖啡、护肤品这类常见静物试起，对「摄影语言」的反应最直观。')
      ]),
      makeSection('how-i-tested', '我实际测了什么', [
        p('同一组提示词我跑了智能手表、咖啡生活方式、汽车广告风、护肤品白底四类。手表那条最有代表性：Schnell 连出 5 版选构图，FLUX.2 终稿里表盘玻璃高光和金属表圈边缘明显更利。'),
        p('咖啡图写「晨光、浅景深、生活方式摄影」，FLUX.2 第二版就能用；汽车广告风我加了「雨后霓虹、低角度」，第三版氛围对了但车身细节还要再出一版。护肤品白底和 Seedream 差距不大——赶时间我会二选一，不两个都跑。'),
        gallery(['flux-watch', 'flux-coffee', 'flux-car', 'flux-skincare'], '手表、咖啡、汽车、护肤品四个方向的代表出图', 4),
        tip('三版本怎么选', 'FLUX.2 日常交稿；Pro Ultra 大图提案或印刷级细节；Schnell 只试构图和光感，别当终稿。'),
        stepsBlock()
      ]),
      makeSection('industry-scenarios', '不同行业怎么写提示词', [
        p('3C、美妆、食品、汽车和欧美电商平台图写法不一样——核心都是镜头 + 光线 + 材质，行业词只是帮你定调。Walmart 和 Target 更适合干净、真实、少修饰的商品广告图；Wayfair 家居图要把空间、材质和自然光写清楚。'),
        table(['行业', '我会加什么', '版本建议'], [
          ['3C 和手表', '微距、边缘光、冷色调、金属反光', 'Schnell 试构图 → FLUX.2 终稿'],
          ['美妆 / 护肤', '柔光、浅景深、玻璃瓶身、大理石台面', 'FLUX.2'],
          ['食品 / 咖啡', '生活方式摄影、晨光、暖色调', 'FLUX.2'],
          ['汽车 / 奢侈品', '电影级商业摄影、高对比、低角度', 'FLUX.2 或 Pro Ultra'],
          ['珠宝', '微距、黑色背景、边缘光', 'Pro Ultra 大图提案时值得试'],
          ['家居 / 家具', '自然光、生活方式、浅景深', 'FLUX.2'],
          ['Walmart 和 Target 商品图', '干净背景、真实材质、产品前景清楚', 'FLUX.2'],
          ['Wayfair 家居产品图', '室内空间、家具材质、自然光', 'FLUX.2 或 Pro Ultra']
        ], 'overview'),
        p('行业词只是定调，核心仍是镜头 + 光线 + 材质。3C 和珠宝我会加「微距、边缘光」；食品和咖啡加「晨光、暖色、生活方式摄影」；汽车广告加「电影级、低角度、高对比」。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('prompt-tips', 'FLUX 提示词怎么写', [
        p('FLUX 比 Seedream 更吃「摄影语言」——多写镜头、光线、材质，少写空泛形容词。'),
        bullets([
          '摄影词：微距、85mm、边缘光、柔光箱、浅景深、商业广告。',
          '材质写具体：拉丝金属、磨砂玻璃、皮革纹理。',
          '广告风加环境：雨后街道霓虹反射，比单写「一辆车」有画面。',
          '同一条提示词先在 Schnell 筛构图，满意再 FLUX.2 出终稿。',
          '白底 SKU 图 FLUX 和 Seedream 差距不大，赶 deadline 可以二选一。',
          'Walmart 和 Target 商品广告图别写得太花，真实材质和清晰主体比氛围更重要。',
          'Wayfair 家居图要写空间类型、家具材质、自然光和镜头距离，别只写「沙发」。',
          '和 Seedream 同一描述各出一版，让客户选「构图」还是「质感」很高效。'
        ])
      ]),
      makeSection('prompt-examples', '提示词与出图示例', [
        promptExample('山脉日落风景', '一幅色彩鲜艳、细节丰富的壮丽风景，展现山脉上空的日落。', 'flux2-seo-landscape'),
        promptExample('编程语言转换抽象艺术', '用于在函数式语言与底层语言之间转换的抽象艺术。', 'flux2-seo-abstract'),
        promptExample('手绘质感动漫头像', '一个动漫/卡通风格的角色头像，细节精致、制作精良，却宛如手绘。', 'flux2-seo-anime'),
        promptExample('银色机械腕表商品摄影', '银色机械腕表放在深色板岩上的影棚商品摄影，柔和侧光，真实拉丝金属纹理，浅景深，细腻反射，高端编辑风构图。', 'flux2-seo-watch'),
        promptExample('雨天欧洲广场电车', '雨天傍晚，一辆红色有轨电车穿过欧洲广场，前景有三名骑行者，左侧咖啡馆窗户透出暖光，蓝调天空，对称构图，电影感摄影。', 'flux2-seo-tram'),
        promptExample('FLUX 2 蓝莓文字风景', '一张唯美的神秘风景照，画面中带有文字「FLUX 2」，含蓄美感，融入蓝莓元素。', 'flux2-seo-blueberry'),
        promptExample('FLUX 2 Pro 黑森林蛋糕', '一个黑森林蛋糕，上面用文字拼出「FLUX 2 Pro」，诱人，美食摄影。', 'flux2-seo-cake'),
        promptExample('绿色香水瓶广告摄影', '一张干净的编辑风商品摄影：半透明绿色香水瓶放在石灰岩上，柔和晨光，细腻阴影，高端广告质感。', 'flux2-seo-perfume')
      ]),
      makeSection('model-pick', '和 Seedream、Midjourney 怎么选', [
        p('硬质感产品摄影、广告大片 → FLUX.2；快速出产品场景 → Seedream；艺术插画 → Midjourney；海报文字 → GPT Image。'),
        table(['你的需求', '我会先试', '原因'], [
          ['手表 / 3C 微距', 'FLUX.2', '金属反光和边缘更利'],
          ['电商场景主图', 'Seedream 5', '跟描述快，改提示词成本低'],
          ['艺术插画', 'Midjourney', '风格化强'],
          ['促销海报文字', 'GPT Image 1.5', '标题排版可控']
        ], 'overview'),
        links('同页可切换', [
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'Flux Schnell', path: '/image-models/flux-1-ai-image-generator' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'Midjourney', path: '/image-models/midjourney-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何用 FLUX 做产品摄影？', '用摄影语言写提示词：镜头、边缘光、材质、硬光。先出几版再定终稿。'),
        faqItem('可以用 FLUX 做商业产品图吗？', '可以。金属、玻璃、广告光感是强项，适合客户按摄影质感验收的终稿。'),
        faqItem('是否能用 FLUX 生成真实珠宝摄影图？', '可以，但短提示词不够。补上微距、边缘光、背景和材质细节，构图速度可与 Seedream 对比。'),
        faqItem('做硬光产品摄影应该用什么 AI 工具？', '终稿用 FLUX.2；要先快速试场景可先用 Seedream 定构图。'),
        faqItem('FLUX 材质和反光偏软怎么修复？', '加更锋利的材质/光线词，多出几版，交稿用 FLUX.2 而不是 Flux Schnell。'),
        faqItem('FLUX.2 和 Schnell 差多少？', 'Schnell 适合试方向和草图；终稿 FLUX.2，放大看细节差距很明显。'),
        faqItem('和 Seedream 怎么分工？', 'Seedream 定构图和氛围；FLUX 交质感。同一描述各出一版，客户也好选。'),
        faqItem('适合亚马逊、Shopify 产品图吗？', '带场景和硬质感的广告图很适合；极简白底和 Seedream 差距不大。'),
        faqItem('FLUX 适合 Walmart 或 Target 商品图吗？', '适合，尤其是日用品、户外和家电。写真实材质、干净背景、产品前景清楚。'),
        faqItem('Wayfair 家居产品图怎么写？', '写家具材质、室内空间、自然光和生活方式摄影；大图提案可试 Pro Ultra。'),
        faqItem('FLUX Schnell 能当终稿吗？', '不建议；先用 Schnell 筛构图，满意再 FLUX.2 出终稿。')
      ])
    ],
    related: ['seedream-ai-image-generator-review', 'midjourney-alternative-online', 'z-image-ai-generator-review']
  },
  {
    slug: 'midjourney-alternative-online',
    category: 'alternatives',
    layout: 'alternatives',
    coverImage: 'midjourney-seo-traveler',
    heroImage: 'midjourney-seo-hummingbird',
    title: 'Midjourney 替代方案：不用 Discord 的 5 款在线生图',
    excerpt: 'Miral 按场景对比 Midjourney、Seedream、FLUX、GPT Image 和 Stable Diffusion，帮你选择合适的 Midjourney 在线替代方案。',
    metaTitle: 'Midjourney 替代方案：5 款在线 AI 生图怎么选 | Miral',
    metaDescription: 'Miral Midjourney 替代方案：不用 Discord 在线生成 AI 艺术图、商业海报，Seedream、FLUX、GPT Image、SD 怎么选。',
    updatedAt: '2026-07-03',
    target: { label: '打开 Midjourney 试一版', path: '/image-models/midjourney-ai-image-generator' },
    keywords: ['Midjourney 替代方案', 'Midjourney 在线', '不用 Discord 生图', 'AI 艺术图生成器', 'AI 海报生成器', 'Midjourney 提示词'],
    creatingSteps: [
      { title: '先定你要什么图', text: '艺术插画、概念设计、商业海报、产品图——不同目标对应不同替代模型，别一上来就全试。' },
      { title: '艺术方向用 Midjourney 或 SD', text: '概念艺术、奇幻场景、风格化插画，Midjourney 或 Stable Diffusion 3.5 更合适。' },
      { title: '商业成片换 Seedream / FLUX', text: '要电商主图、产品摄影、广告大片，Seedream 跟描述快，FLUX 质感更硬。' },
      { title: '带文字海报用 GPT Image', text: '标题、卖点、活动日期要写进画面，GPT Image 比纯艺术模型稳。' }
    ],
    pros: [
      'Midjourney 和替代模型同一平台，不用 Discord 也能在线生图',
      '从艺术草图到商业终稿可以一条工作流切换模型',
      '可以直接用日常描述写提示词，跨境电商和社媒团队上手门槛低',
      '和 Leonardo、Dreamina、Firefly 等相比，模型选择更集中、对比更方便'
    ],
    cons: [
      'Midjourney 风格化强，但不擅长复杂文字排版',
      '商业产品摄影终稿往往还要 FLUX 或 Seedream 补一版',
      '不同模型积分消耗不同，建议先 Schnell 或 Z Image 试方向',
      '正式商用仍需检查版权和品牌合规'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['还在用 Midjourney 的场景', '概念艺术、插画、奇幻视觉、风格探索'],
          ['建议换替代模型的场景', '电商主图、硬质感产品摄影、带标题海报、不想绑 Discord'],
          ['我最常的组合', 'Midjourney 找风格 → FLUX/Seedream 出商业图 → GPT Image 加文字'],
          ['上手建议', '浏览器打开，按日常描述直接试']
        ], 'overview'),
        p('找「Midjourney 替代」的人，多半不是要放弃 MJ，而是想要网页直接用、或者同一项目里还要出电商图。Miral 把 MJ 和 Seedream、FLUX、GPT Image、SD 放同一工作台，比 Discord 加多个网站来回切省事。')
      ]),
      makeSection('why-alternative', '为什么有人想换 / 补充 Midjourney', [
        p('常见原因就三类：不想绑 Discord、想要更顺的网页工作流、或者项目里既要艺术插画又要电商产品图。MJ 在概念艺术、游戏原画、奇幻场景仍是强项；做亚马逊主图、带卖点文字的海报，我通常会换 Seedream、FLUX 或 GPT Image。'),
        p('我的习惯：探索阶段 MJ 或 SD 定风格和构图；定稿按需求切 FLUX（硬质感摄影）、Seedream（快速跟描述）或 GPT Image（文字海报）。'),
        p('Leonardo、Dreamina、Adobe Firefly 等单平台也有深度；Miral 的优势是 MJ 和 Seedream、FLUX、GPT Image、SD 同一工作台，不用 Discord 加多个网站来回导出。适合「这一单既要概念图又要产品图」的混合需求。')
      ]),
      makeSection('how-i-picked', '我实际怎么选型', [
        p('上周有个游戏宣传图需求：先用 Midjourney 出了 4 版奇幻场景定氛围，客户选中方向后，同一描述在 FLUX.2 出一版「更摄影」的产品植入图，活动标题再用 GPT Image 做带字版。整个过程没开 Discord，模型切换在同一页完成。'),
        gallery(['midjourney-character', 'seedream-product', 'flux-watch', 'gpt-image-demo'], '艺术风、电商主图、产品摄影、文字海报四个方向', 4),
        tip('和 Leonardo、Dreamina 比', '各平台单模型深度不同；Miral 的优势是多模型同一流程，不用来回导出。'),
        stepsBlock()
      ]),
      makeSection('best-alternatives', '我对比过的在线替代模型', [
        table(['模型', '更适合', '典型场景'], [
          ['Midjourney', '艺术插画、概念设计', '奇幻场景、角色设定、风格探索'],
          ['Seedream 5', '电商主图、生活方式海报', '亚马逊和 Shopify 场景图、Instagram 产品帖'],
          ['FLUX.2', '商业摄影、广告大片', '产品质感、硬光静物'],
          ['GPT Image 1.5', '含文字海报、说明图', '促销横幅图、卖点排版'],
          ['Stable Diffusion 3.5', '开源风格、插画角色', '动漫风、概念图、不用本地部署']
        ], 'overview'),
        p('没有「完全替代 Midjourney」——艺术探索继续 MJ 或 SD；商业出片按上表换模型。同一条提示词在 MJ 和 SD 各出一版，对比风格差异很直观。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('prompt-tips', 'Midjourney 风格提示词怎么写', [
        p('即使用替代模型，MJ 式提示词结构仍然好用：主体 + 风格 + 光线 + 构图 + 氛围词。'),
        bullets([
          '艺术图：概念艺术、超细节、电影级、体积光。',
          '商业海报：加用途和比例，如「时尚杂志封面、3:4 构图」。',
          '角色设定：写服装、姿态、世界观，比单写「一个战士」稳。',
          '同一条提示词在 MJ 和 SD 各出一版，对比风格差异。',
          '包装、品牌视觉探索用 MJ 定调，产品摄影终稿换 FLUX 或 Seedream。',
          '带夏季大促这类大字的促销图，终稿交给 GPT Image 更稳。'
        ])
      ]),
      makeSection('prompt-examples', '提示词与出图示例', [
        promptExample('雾岭日出独行旅人', '一位独行旅人站在日出时分的薄雾山脊边缘，体积光，电影感宽镜头，细腻的织物与岩石质感。', 'midjourney-seo-traveler'),
        promptExample('黄昏屋顶女剑士', '坚定的年轻女剑士站在黄昏的屋顶上，飘动的长发，发光的灯笼，富有表现力的动漫线条，明快的赛璐璐上色。', 'midjourney-seo-swordswoman'),
        promptExample('黑陶瓷花瓶参考图商品摄影', '高端商品图，磨砂黑陶瓷花瓶置于大理石底座上，柔和影棚光，干净背景，贴合所上传参考图的氛围与配色。', 'midjourney-seo-vase'),
        promptExample('雨夜霓虹小巷', '夜晚被雨淋湿的霓虹小巷，反光的积水，远处招牌的柔和散景，氛围浓郁的电影感，一个撑伞的孤独身影。', 'midjourney-seo-neon-alley'),
        promptExample('金色时刻屋顶音乐家', '金色时刻下屋顶上的音乐家肖像，温暖的逆光，镜头眩光，浅景深，胶片颗粒。', 'midjourney-seo-musician'),
        promptExample('流浪炼金师概念美术', '身披层层旅行斗篷的流浪炼金师，手提黄铜灯笼和发光药瓶，古老的林间小径，斑驳光影，繁复的服装细节。', 'midjourney-seo-alchemist'),
        promptExample('蜂鸟与热带花卉活动主视觉', '一幅大胆的活动主视觉，蜂鸟悬停在一朵发光的热带花卉上方，饱和的宝石色调，干净的留白，高对比影棚光。', 'midjourney-seo-hummingbird')
      ]),
      makeSection('workflow', '推荐工作流', [
        p('MJ 或 SD 定风格 → FLUX/Seedream 出商业质感 → GPT Image 做带文字版。素材有水印可先 AI 去水印再二次创作。'),
        tip('混合项目示例', '游戏宣传：MJ 出 4 版奇幻场景定氛围 → FLUX 出产品植入摄影感版本 → GPT Image 加活动标题。全程同页切换，不用 Discord。'),
        links('继续阅读', [
          { label: 'Seedream 测评', path: '/zh/hub/articles/seedream-ai-image-generator-review' },
          { label: 'FLUX 测评', path: '/zh/hub/articles/flux-ai-image-generator-review' },
          { label: 'GPT Image 指南', path: '/zh/hub/articles/gpt-image-generator-guide' },
          { label: 'Stable Diffusion 在线', path: '/zh/hub/articles/stable-diffusion-online-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何不用 Discord 在线使用 Midjourney？', '打开 Miral 的 Midjourney 页面，在浏览器里直接生成几版即可，不必配置 Discord 机器人。'),
        faqItem('可以在浏览器里用 Midjourney 吗？', '可以。这也是大家找 Midjourney 在线替代的主要原因：少折腾、方便同页对比。'),
        faqItem('是否能在不用 Discord 的情况下做出 Midjourney 风格？', '可以。艺术方向用浏览器里的 Midjourney；同一项目若要出电商终稿，再切 Seedream 或 FLUX。'),
        faqItem('不用 Discord 做电商图应该用什么工具？', '电商场景用 Seedream，硬质感产品摄影用 FLUX，要可读促销字用 GPT Image。'),
        faqItem('用 Midjourney 替代方案时风格不对怎么修复？', '别逼一个模型包打天下。艺术继续用 MJ/SD，商业终稿换 Seedream 或 FLUX。'),
        faqItem('Miral 能在线用 Midjourney 吗？', '能，进 Midjourney 模型页即可，不用 Discord 客户端。'),
        faqItem('替代方案哪个适合商业图？', '电商主图 Seedream；硬质感产品摄影 FLUX；带文字海报 GPT Image。'),
        faqItem('Midjourney 能做电商主图吗？', '可以试风格方向，但终稿商业产品图建议 Seedream 或 FLUX。'),
        faqItem('和 Stable Diffusion 怎么配合？', '艺术探索两者都可；SD 在线版不用 Discord，同一条提示词对比很方便。'),
        faqItem('AI 海报生成器和 Midjourney 怎么选？', '艺术探索 MJ；要把标题写进画面用 GPT Image；电商主图换 Seedream。')
      ])
    ],
    related: ['stable-diffusion-online-generator', 'flux-ai-image-generator-review', 'gpt-image-generator-guide']
  },
  {
    slug: 'gpt-image-generator-guide',
    category: 'prompt-guides',
    layout: 'prompt-guide',
    coverImage: 'gpt-image-demo',
    heroImage: 'gpt-hero',
    title: 'GPT Image 提示词指南：文字海报和卖点图怎么写',
    excerpt: '教你写 GPT Image 促销海报、产品卖点图和社媒封面的提示词，附可复制示例和与 Seedream、FLUX 的配合方式。',
    metaTitle: 'GPT Image 提示词指南：文字海报和卖点图 | Miral',
    metaDescription: 'Miral GPT Image 提示词怎么写：AI 文字海报、电商卖点图、促销横幅图示例，和 Midjourney、Seedream 怎么配合。',
    updatedAt: '2026-07-03',
    target: { label: '打开 GPT Image 试一版', path: '/image-models/gpt-image-ai-image-generator' },
    keywords: ['GPT Image 生成器', 'GPT Image 提示词', 'AI 文字海报', 'AI 产品说明图', 'OpenAI 图片生成', '带文字 AI 图片'],
    creatingSteps: [
      { title: '先写清楚文字内容', text: '主标题、副标题、卖点、日期——GPT Image 对文字结构敏感，先列文案再生成。' },
      { title: '指定版式和比例', text: '写 1:1 Instagram、4:5 信息流、2:3 Pinterest、16:9 横幅图，减少后期裁剪。' },
      { title: '连出 2–3 版挑排版', text: '短句标题比长段落稳；生成后检查错别字和换行。' },
      { title: '和产品图组合使用', text: '产品主体可先用 Seedream/FLUX 出图，再用 GPT Image 做带文字海报版。' }
    ],
    pros: [
      '带标题、卖点、按钮文案的海报比纯艺术模型可控',
      '适合 AI 促销图、活动横幅图、产品说明图、社媒封面',
      '和 Seedream、FLUX 同平台，一条工作流里完成「产品图 + 文字版」',
      '短标题和英文促销文案更稳，适合跨境电商和本地活动'
    ],
    cons: [
      '长句、小字号、复杂排版仍可能出错，需人工检查',
      '极致艺术插画不如 Midjourney',
      '硬质感产品摄影终稿常需 FLUX 辅助',
      '商用前确认文字内容和品牌规范'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', 'AI 文字海报、促销横幅图、产品卖点图、说明型社媒图'],
          ['不太适合', '纯艺术插画、极致产品摄影、长篇文章排版'],
          ['和 Midjourney 比', 'GPT Image 重文字结构；Midjourney 重艺术风格'],
          ['我的建议', '画面主体 Seedream/FLUX，文字版 GPT Image 1.5']
        ], 'overview'),
        p('要把标题、卖点、活动日期写进画面里，GPT Image 是我首选；纯视觉探索仍用 Midjourney 或 Seedream，同页切换不用导出。')
      ]),
      makeSection('best-for-text', 'GPT Image 适合什么', [
        p('GPT Image 1.5 适合需要清晰文字结构的图：促销海报、产品说明图、邮件通讯头图、Instagram 活动图、Shopify 横幅图和 Google Shopping 促销图。和 Seedream 的「跟描述出场景」、Midjourney 的「艺术风格」不同，它的价值是文字 + 布局。'),
        p('我常先用 Seedream 或 FLUX 出一版产品图，再用 GPT Image 做带「夏季促销」「新品上市」等文案的版本——画面和文字分开做，比一次赌全图稳。'),
        p('不适合的场景也很明确：纯艺术插画、极致产品摄影、长篇文章排版——这些换 Midjourney、FLUX 或排版工具更合适。GPT Image 最适合的是「短标题 + 清晰布局 + 产品或简单背景」。')
      ]),
      makeSection('how-i-tested', '我实际测了什么', [
        p('我试了四类：护肤品 1:1 促销海报、耳机三点卖点图、咖啡店周末横幅图、科技产品上新封面。每类 3–4 版，重点看标题是否可读、排版是否平衡。'),
        p('促销海报写「主标题夏日焕亮 + 清爽蓝绿背景」，第二版标题就能读；卖点图用条目式降噪、长续航比长段落稳。有一次主标题太长换行乱了，缩短成两个词后第三版才可用——这是我踩过的坑。'),
        gallery(['gpt-image-demo', 'seedream-product', 'flux-skincare', 'seedream-lifestyle'], '文字海报、产品主图、说明图、生活方式封面', 4),
        stepsBlock()
      ]),
      makeSection('poster-types', '按海报类型写提示词', [
        table(['类型', '我会怎么写', '比例'], [
          ['促销海报', '主标题 + 折扣 + 主色', '1:1 或 3:4'],
          ['产品卖点图', '三点条目 + 极简背景', '1:1'],
          ['活动横幅图', '日期 + 地点 + 风格', '16:9'],
          ['Shopify 和 WooCommerce 横幅', '主标题 + 折扣 + 品牌色', '16:9'],
          ['Google Shopping 促销图', '短标题 + 产品名 + 折扣数字', '1:1'],
          ['社媒封面', '平台比例 + 短标题', '4:5 Instagram / 2:3 Pinterest'],
          ['菜单 / 价格标签', '菜名 + 价格 + 复古排版', '竖版或 1:1']
        ], 'overview'),
        tip('标题长度', '主标题超过 6–8 个字容易换行乱；缩短成两个词或拆成主副标题，第三版往往比第一版可用。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('prompt-tips', 'GPT Image 提示词怎么写', [
        p('先列文案再生成：主标题、副标题、卖点、日期——比边想边写提示词稳。比例和风格写进同一句，减少后期裁剪。'),
        bullets([
          '直接写主标题、副标题，如：主标题「夏日焕亮」，副标题「保湿精华新品上市」。',
          '指定比例：1:1 Instagram、4:5 信息流、2:3 Pinterest、16:9 网站横幅图。',
          '说明风格：极简科技、复古促销、清爽电商、暖色咖啡店。',
          '卖点图用条目，比长段落稳；生成后检查错别字和换行。',
          'Google Shopping 促销图少写字，标题、折扣数字和产品名就够。',
          'Shopify、WooCommerce、Squarespace 横幅图要写 16:9、品牌色和留白区域。',
          '产品底图可 Seedream/FLUX 先出，GPT Image 只负责叠文字和排版。'
        ])
      ]),
      makeSection('prompt-examples', '提示词与出图示例', [
        promptExample('透明香水瓶商品摄影', '编辑风商品摄影：透明香水瓶放在浅色石材底座上，柔和晨光从左侧照入，背景干净，浅景深，高端品牌质感。', 'gpt-seo-perfume'),
        promptExample('雨夜城市与有轨电车', '雨夜城市街道，前景三名行人撑着不同颜色的伞，远处有轨电车驶过，霓虹倒映在湿润路面，电影感宽幅构图。', 'gpt-seo-rainy-city'),
        promptExample('草莓蛋糕食品广告', '高画质食品广告：黑色背景上的草莓蛋糕，奶油纹理清晰，柔和轮廓光，细腻食物摄影，商业广告构图。', 'gpt-seo-cake'),
        promptExample('灯塔旅行海报', '1024×1536 竖版旅行海报，海边悬崖与灯塔，清晨薄雾，顶部预留标题空间，现代编辑版式。', 'gpt-seo-lighthouse'),
        promptExample('CREATE THE FUTURE 科技海报', '极简科技活动海报，标题「CREATE THE FUTURE」，粗体无衬线字体，深蓝背景，绿色几何网格，标题清晰居中。', 'gpt-seo-tech-poster'),
        promptExample('MIRAL ROAST 咖啡包装', '高端咖啡包装概念，包装正面文字「MIRAL ROAST」，暖棕色纸张纹理，简洁标签，影棚商品摄影。', 'gpt-seo-coffee'),
        promptExample('陶艺师编辑人像', '自然窗光下的陶艺师近景人像，真实皮肤纹理，双手带有陶土粉尘，工作室背景，浅景深，温暖编辑摄影。', 'gpt-seo-potter')
      ]),
      makeSection('workflow', '和其他模型怎么配合', [
        p('Seedream/FLUX 出产品主图 → GPT Image 做带标题海报 → 旧素材有水印可先 AI 去水印。'),
        links('相关入口', [
          { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'AI 去水印', path: '/tools/watermark-remover' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何用 GPT Image 制作文字海报？', '提示词先写主标题、副标题、优惠、风格和比例；文案块保持简短，排版才稳。'),
        faqItem('可以用 GPT Image 做 Shopify 横幅图吗？', '可以。写明主标题、折扣、产品名、品牌色和 16:9，多出几版比布局。'),
        faqItem('是否能在 AI 图片里生成可读文字？', '可以，GPT Image 更适合。短句结构化促销文案比长段落更稳。'),
        faqItem('做产品卖点图应该用什么 AI 工具？', '文字排版用 GPT Image；摄影质感重要时先用 Seedream 或 FLUX 出底图再叠字。'),
        faqItem('GPT Image 海报文字拼错怎么修复？', '缩短文案、重生成并逐字检查；画面可用但文字错时，保留底图只重做排版。'),
        faqItem('标题怎么写更稳？', '短句英文和清晰数字最稳，生成后检查字号和换行。'),
        faqItem('和 Midjourney 怎么选？', '艺术风 MJ；要把标题写进画面 GPT Image。'),
        faqItem('和 Qwen 比呢？', 'Qwen 偏大画面海报视觉；GPT Image 偏说明型文字排版。'),
        faqItem('和产品图怎么配合？', 'Seedream/FLUX 出干净底图 → GPT Image 叠标题；比一次生成全图省心。'),
        faqItem('Google Shopping 促销图怎么写？', '用短标题、产品名和折扣数字，1:1 比例，背景保持干净，生成后检查文字。'),
        faqItem('GPT Image 能做电商详情卖点图吗？', '能，三点条目式卖点 + 产品名 + 极简背景，比纯艺术模型排版可控。')
      ])
    ],
    related: ['seedream-ai-image-generator-review', 'midjourney-alternative-online', 'ai-watermark-remover-online']
  },
  {
    slug: 'qwen-image-generator-review',
    category: 'reviews',
    layout: 'review',
    coverImage: 'qwen-image-demo',
    heroImage: 'qwen-hero',
    title: 'Qwen Image 2.0 Pro 测评：营销海报与商品图',
    excerpt: 'Miral 实测 Qwen Image 2.0 Pro 于营销海报、产品展示图和高分辨率封面上的效果，含提示词示例和与 GPT Image 的对比。',
    metaTitle: 'Qwen Image 2.0 Pro 测评：营销海报和商品图 | Miral',
    metaDescription: 'Miral Qwen Image 2.0 Pro 测评：AI 营销海报、品牌活动图、商品图提示词写法，和 GPT Image、Seedream 怎么选。',
    updatedAt: '2026-07-03',
    target: { label: '打开 Qwen Image 试一版', path: '/image-models/qwen-image-2-0-pro-ai-image-generator' },
    keywords: ['Qwen Image 生成器', 'Qwen Image 在线生成', 'Qwen Image 提示词', 'AI 海报生成', 'AI 高分辨率图片', 'Qwen 产品图'],
    creatingSteps: [
      { title: '写清产品和文字', text: 'Qwen Image 对「产品 + 标题 + 场景」理解好，营销图记得写主标题和氛围。' },
      { title: '指定高分辨率和比例', text: '详情页、封面、横幅图用途不同，比例写进提示词。' },
      { title: '和 GPT Image 对比一版', text: '文字排版要求高试 GPT Image；大画面海报视觉试 Qwen。' },
      { title: '终稿前检查文字边缘', text: '复杂小字仍建议缩短或换 GPT Image。' }
    ],
    pros: [
      '文字场景、营销海报、高分辨率商业视觉表现稳定',
      'Qwen Image 在线可用，不用本地部署',
      '产品展示图、邮件通讯头图、Instagram 和 Pinterest 封面方向清晰',
      '和 GPT Image、Seedream 同平台切换方便'
    ],
    cons: [
      '复杂多行小字排版不如 GPT Image 精细',
      '极致产品摄影质感 FLUX 往往更强',
      '艺术插画不是主战场',
      '商用前检查文字内容和品牌色'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', '营销海报、产品展示图、高分辨率封面、教育配图'],
          ['不太适合', '复杂文字排版、极致硬质感产品摄影'],
          ['和 GPT Image 比', 'Qwen 偏大画面海报；GPT Image 偏说明型文字结构'],
          ['我的建议', '品牌海报试 Qwen；卖点条目图试 GPT Image']
        ], 'overview'),
        p('大画面营销海报、Instagram 和 Pinterest 封面、Shopify 新品发布图和邮件通讯头图，我会把 Qwen 和 GPT Image 放一起试，按文字排版需求选终稿。')
      ]),
      makeSection('why-qwen', 'Qwen Image 是什么', [
        p('Qwen Image 2.0 Pro 是适合在线生成商业视觉的生图模型，浏览器直接用。适合营销海报、电商详情页视觉、课程封面、Etsy 商品页封面和 Squarespace 独立站横幅这类「产品 + 标题 + 场景」组合。'),
        p('和 Seedream 比，Qwen 在「大画面海报 + 文字」有时更稳；和 GPT Image 比，Qwen 偏整体视觉，GPT Image 偏条目式说明排版。'),
        p('Qwen Image 对日常描述很友好，写主标题、产品名、氛围色往往第二版就能读。要做三点条目式卖点图，我会同时试 GPT Image 对比排版。高分辨率、营销海报是 Qwen 最合适的区间。')
      ]),
      makeSection('how-i-tested', '我实际测了什么', [
        p('试了茶饮新品海报、智能台灯产品图、在线课程封面三类，每类 4 版。茶饮那条写「主标题春日限定 + 清新绿色背景 + 杯身水珠」，第二版标题可读、杯身轮廓清楚，就能用。'),
        p('课程封面我写了插画风 + 蓝绿科技背景，Qwen 对「高分辨率、营销海报」反应不错；说明型三点卖点图反而 GPT Image 更稳——同一需求我会两个各出一版对比。'),
        p('黑五海报我额外试了一版：写促销主题 + 品牌色 + 主标题，Qwen 大画面视觉够；若要点条目式折扣信息，终稿还是 GPT Image。'),
        gallery(['qwen-image-demo', 'seedream-product', 'gpt-image-demo', 'seedream-lifestyle'], '海报、产品图、文字版、生活方式', 4),
        stepsBlock()
      ]),
      makeSection('marketing-scenarios', '营销场景怎么写', [
        table(['场景', '我的写法', '备注'], [
          ['茶饮 / 食品海报', '杯身细节 + 主标题 + 氛围色', '3:4 或 1:1'],
          ['智能家电产品图', '使用场景 + 柔和光线', '详情页风格'],
          ['课程 / 知识封面', '标题 + 插画风 + 品牌色', '16:9'],
          ['Instagram 和 Pinterest', '比例写进提示词', '说明型排版换 GPT Image'],
          ['Shopify 新品发布图', '新品主题 + 品牌色 + 产品场景', '16:9 或 4:5'],
          ['Squarespace 品牌横幅图', '大画面视觉 + 短标题 + 留白', '16:9'],
          ['Etsy 商品页封面', '手作感 + 材质细节 + 生活方式', '1:1 或 4:5'],
          ['黑五和节日促销', '促销主题 + 品牌色 + 主标题', '高分辨率写清楚'],
          ['直播预告封面', '主标题 + 时间 + 插画风', '3:4 或 16:9']
        ], 'overview'),
        p('大促海报记得写「高分辨率、营销海报」；详情页配图加「使用场景、柔和光线、电商详情页风格」。和 GPT Image 同一需求各出一版，按文字排版需求选终稿。'),
        tip('标题检查', '生成后看主标题换行和字号；不对就缩短标题或再出一版，别硬用第一版。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('prompt-tips', 'Qwen Image 提示词怎么写', [
        p('按「产品 + 主标题 + 场景 + 比例 + 高分辨率」顺序写，比堆形容词稳。大促海报把促销主题和品牌色写清楚。'),
        bullets([
          '茶饮/食品：杯身细节、主标题、清新或暖色背景。',
          '产品图：使用场景、光线、电商详情页风格、高分辨率。',
          '课程封面：标题文字、插画风、平台比例。',
          '独立站横幅：Shopify 或 Squarespace、品牌色、16:9、标题留白。',
          'Etsy 商品页封面：材质细节、手作感、生活方式场景和 1:1 比例。',
          '和 GPT Image 同一需求各出一版，对比文字和构图。',
          '邮件通讯头图写 16:9 或 2.35:1；Instagram 写 4:5；Pinterest 写 2:3。'
        ])
      ]),
      makeSection('prompt-examples', '提示词与出图示例', [
        promptExample('玻璃护肤瓶商品摄影', '高端商品摄影：玻璃护肤瓶放在湿润的石头上，柔和晨光，干净背景。（负向：杂乱背景，低分辨率，畸形反射。）', 'qwen-seo-product'),
        promptExample('秋日自然光人像', '一位年轻女性的秋日光下人像，自然皮肤纹理，浅景深。（负向：过度磨皮，蜡像感，过饱和色彩。）', 'qwen-seo-portrait'),
        promptExample('雨窗阅读角落', '雨中窗边的温馨阅读角落。', 'qwen-seo-reading'),
        promptExample('未来霓虹城市街道', '夜晚霓虹闪烁的未来城市街道。', 'qwen-seo-future-city'),
        promptExample('北欧陶瓷台灯商品摄影', '极简陶瓷台灯放在胡桃木边桌上，温暖的夜间室内环境，奶油色墙面，柔和阴影，北欧风商品摄影。', 'qwen-seo-lamp'),
        promptExample('金色时刻海岸悬崖', '一张电影感宽幅风景：金色时刻的海岸悬崖，戏剧性云层，细腻岩石纹理，2688×1536。', 'qwen-seo-coast'),
        promptExample('年长陶艺师编辑人像', '一位年长陶艺师在阳光照进的工作室中的编辑风近景人像，自然皮肤纹理，双手沾有陶土粉末，温暖窗光，浅景深。', 'qwen-seo-potter')
      ]),
      makeSection('model-pick', '和 GPT Image、Seedream 怎么选', [
        p('品牌大促海报、高分辨率封面 → Qwen；说明型条目排版 → GPT Image；快速跟描述出场景 → Seedream；硬质感摄影 → FLUX。'),
        table(['需求', '优先试', '原因'], [
          ['大画面营销海报', 'Qwen Image 2.0 Pro', '高分辨率 + 主标题场景'],
          ['三点卖点说明图', 'GPT Image 1.5', '条目排版更稳'],
          ['电商场景主图', 'Seedream 5', '跟描述快'],
          ['产品摄影终稿', 'FLUX.2', '质感更硬']
        ], 'overview'),
        links('继续尝试', [
          { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何用 Qwen Image 制作高分辨率海报？', '写清产品或活动主题、主标题、氛围和输出尺寸；大营销主视觉是它的强项。'),
        faqItem('可以用 Qwen Image 做电商详情页主图吗？', '可以，尤其需要强主视觉和 2K 级营销图时。'),
        faqItem('是否能用 Qwen 生成 2K 营销图？', '可以。把分辨率目标和比例写进提示词，发布前检查文字边缘。'),
        faqItem('做大型活动海报应该用什么 AI 工具？', '大画面冲击用 Qwen Image；说明型促销文案更重时换 GPT Image。'),
        faqItem('Qwen 海报文字不清晰怎么修复？', '缩短主标题、减少细碎小字后重出；长卖点列表交给 GPT Image 排版。'),
        faqItem('和 GPT Image 怎么选？', '大画面海报视觉 Qwen；说明型条目排版 GPT Image。'),
        faqItem('和 Seedream 比呢？', 'Seedream 跟商业场景快；Qwen 偏高分辨率海报和文字场景。'),
        faqItem('能做 Instagram 或 Pinterest 封面吗？', '可以，写 4:5 或 2:3 比例、主标题、品牌色和生活方式氛围。'),
        faqItem('Qwen 适合 Shopify 或 Squarespace 横幅图吗？', '适合大画面品牌视觉。写 16:9、品牌色、短标题和产品场景。'),
        faqItem('Qwen 出图分辨率够打印吗？', '2.0 Pro 适合 2K 级营销海报和提案；印刷前建议放大检查文字边缘。')
      ])
    ],
    related: ['gpt-image-generator-guide', 'seedream-ai-image-generator-review', 'image-crop-dewarp-online']
  },
  {
    slug: 'z-image-ai-generator-review',
    category: 'reviews',
    layout: 'review',
    coverImage: 'z-image-demo',
    heroImage: 'z-hero',
    title: 'Z Image Turbo 测评：快速广告图和社媒视觉',
    excerpt: 'Miral 实测 Z Image Turbo 出广告草图和社媒封面的速度和质量，以及和 FLUX、Seedream 配合出终稿的方式。',
    metaTitle: 'Z Image Turbo 测评：快速 AI 广告图和社媒图 | Miral',
    metaDescription: 'Miral Z Image Turbo 测评：快速 AI 广告图、电商横幅图提示词示例，和 FLUX、Seedream 怎么配合出终稿。',
    updatedAt: '2026-07-03',
    target: { label: '打开 Z Image Turbo 试一版', path: '/image-models/z-image-turbo-ai-image-generator' },
    keywords: ['Z Image Turbo', 'Z Image AI 生成器', '快速 AI 生图', 'AI 广告图', 'AI 社媒图片', 'AI 横幅图生成'],
    creatingSteps: [
      { title: '一次试 3–5 个方向', text: 'Z Image Turbo 适合快速探索配色、构图和卖点表达，别第一轮就追求终稿。' },
      { title: '写用途和平台', text: 'Facebook 广告、Instagram 帖子、电商横幅图——写进提示词更贴版式。' },
      { title: '选中方向换 FLUX/Seedream', text: '终稿需要更硬质感或更跟描述时，换模型用同一提示词再出一版。' },
      { title: '文字版交给 GPT Image', text: '促销大字、活动日期建议 GPT Image 做终稿。' }
    ],
    pros: [
      '出图快，适合 AI 广告创意草图和社媒方向探索',
      '电商横幅图、促销图、活动视觉试错成本低',
      '和 FLUX、Seedream、GPT Image 同平台，切换顺滑',
      '提示词不用写得很技术化，适合跨境电商和本地活动'
    ],
    cons: [
      '终稿质感和细节通常不如 FLUX.2',
      '复杂文字排版仍建议 GPT Image',
      '硬质感产品摄影不是强项',
      '正式商用前建议换模型精修一版'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', '快速 AI 广告图、社媒封面草图、电商横幅图方向探索'],
          ['不太适合', '交客户终稿的硬质感产品摄影、复杂文字海报'],
          ['和 FLUX 比', 'Z Image 更快；FLUX 质感更摄影'],
          ['我的建议', 'Z Image 试方向 → FLUX/Seedream 出终稿 → GPT Image 加文字']
        ], 'overview'),
        p('Z Image 我用来「先试方向」——连出几版配色和构图，定稿再同页换 FLUX 或 Seedream。')
      ]),
      makeSection('what-is-z-image', 'Z Image Turbo 是什么', [
        p('Z Image Turbo 是偏速度的 AI 生图模型，浏览器直接用。适合快速出广告创意、Meta 广告图、Google Shopping 促销图、Facebook/Instagram 视觉草图、促销横幅图和产品发布图方向。'),
        p('它的价值不在「一张到位」，而在短时间内连出多个构图和配色方案，帮你决定下一版该用 FLUX 做质感还是 Seedream 跟描述。'),
        p('我把它当广告部门的「第一轮头脑风暴」：黑五促销、新品预告、直播封面草图，Z Image 连出 5 版比开会讨论快。定方向后同一条提示词丢 FLUX 或 Seedream 出终稿，促销日期和大字交给 GPT Image。')
      ]),
      makeSection('how-i-tested', '我实际测了什么', [
        p('试了蓝牙音箱促销横幅图、健身饮料社媒海报、SaaS 博客封面三类，每类连出 5 版。音箱那条写「红色背景 + 大促 + 动感光效」，第三版配色和构图差异最明显，我就拿这版提示词去 FLUX 出终稿。'),
        p('写提示词时把平台和用途写进去效果更好——Instagram 帖子、TikTok 9:16、Google Shopping 1:1、eBay 促销图、电商横幅图比例，各试一版，方向定下来再换模型。'),
        gallery(['z-image-demo', 'seedream-sneaker', 'seedream-lifestyle', 'flux-car'], '广告横幅图、运动鞋、生活方式、汽车广告方向', 4),
        stepsBlock()
      ]),
      makeSection('ad-scenarios', '广告场景怎么写', [
        table(['平台和用途', 'Z Image 角色', '提示词要点'], [
          ['Facebook 广告图', '试配色和大字区域', '大促、产品前景、动感光效'],
          ['Meta 广告图', '试构图和视觉钩子', '1:1 或 4:5、产品前景、留标题区域'],
          ['Instagram 帖子', '试构图和氛围', 'Instagram 风、生活方式、产品居中'],
          ['TikTok 商品图', '试高饱和方向', '9:16、产品特写、促销氛围'],
          ['Google Shopping 促销图', '试背景和促销氛围', '1:1、产品清楚、少文字'],
          ['eBay 和 Walmart 活动图', '试折扣视觉', '产品前景、品牌色、促销横幅'],
          ['电商横幅图', '试 3–5 个方向', '促销主题、品牌色、横幅图比例'],
          ['活动海报', '试视觉方向', '终稿换 FLUX/Seedream + GPT Image 加文字'],
          ['YouTube 缩略图', '试高对比构图', '16:9，终稿 FLUX 精修']
        ], 'overview'),
        p('写提示词时把平台和比例写进去：Facebook 1:1 或 4:5、Google Shopping 1:1、TikTok 9:16、横幅图 16:9。促销图加大促、品牌色、动感光效，第三版配色差异最明显时就可以换模型出终稿。'),
        tip('成本控制', 'Turbo 适合连出 3–5 版试错；别在 Z Image 上抠终稿细节，换 FLUX.2 更省总时间。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('prompt-tips', 'Z Image 提示词怎么写', [
        p('把「平台 + 促销主题 + 产品 + 配色」写清楚，比堆形容词有用。终稿阶段换模型，不要在 Z Image 上无限改词。'),
        bullets([
          '促销图：大促、红色背景、动感光效、电商横幅图。',
          '平台图：Meta 广告图、Google Shopping 商品广告图、eBay 促销图要分别写比例和用途。',
          '社媒：Instagram 帖子、运动员剪影、产品前景。',
          '封面：SaaS、极简桌面、博客封面比例。',
          '同一条提示词在 Z Image 和 FLUX 各出一版，对比速度和质量。',
          '黑五/限时折扣：高对比配色 + 产品前景大 + 促销氛围。'
        ])
      ]),
      makeSection('prompt-examples', '提示词与出图示例', [
        promptExample('火星玻璃温室', '火星表面的一座玻璃温室，内部生长着茂盛的热带植物。', 'z-seo-greenhouse'),
        promptExample('列车车厢微型面包店', '建在复古列车车厢里的微型手工面包店。', 'z-seo-bakery'),
        promptExample('雨夜东京市场航拍', '雨夜东京市场的超宽幅航拍视角，发光纸灯笼、拥挤食摊、湿润反光街道，电影感氛围，1536×864。', 'z-seo-market'),
        promptExample('竖版植物展览海报', '竖版植物展览海报，超大橙色字体、珍稀热带叶片、暖白纸张纹理、精确编辑网格，1152×1728。', 'z-seo-poster'),
        promptExample('磨砂玻璃护肤瓶系列广告', '三款磨砂玻璃护肤瓶组成的系列广告，浅绿色石材、柔和漫射光、桉树叶点缀——复用同一种子，在系列图片中保持一致的光线、配色与构图。', 'z-seo-skincare'),
        promptExample('小提琴制作师纪实特写', '纪实特写：小提琴制作师在安静工作室里雕刻枫木琴桥，细碎木屑、磨损手工工具、自然皮肤纹理、柔和北窗光、浅景深。', 'z-seo-violin-maker')
      ]),
      makeSection('model-pick', '和 FLUX、Seedream 怎么配合', [
        p('Z Image 试方向 → FLUX/Seedream 终稿 → GPT Image 加文字。这是我最常用的广告创意工作流。'),
        table(['阶段', '用哪个', '说明'], [
          ['试配色构图', 'Z Image Turbo', '连出 3–5 版，成本低'],
          ['交稿质感', 'FLUX.2', '金属、光感、细节'],
          ['跟商业描述', 'Seedream 5', '场景主图快'],
          ['促销大字', 'GPT Image 1.5', '标题和日期']
        ], 'overview'),
        links('继续尝试', [
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何用 Z Image Turbo 快速做出广告概念图？', '先连出 3–5 个构图和配色方向，把它当草稿模型，不要第一轮就赌终稿。'),
        faqItem('可以用 Z Image Turbo 做社媒广告图吗？', '可以用于找方向和配色测试；重要投放终稿建议换 FLUX 或 Seedream。'),
        faqItem('是否能用 Z Image 快速生成活动草稿？', '可以，它更适合速度优先、细节要求尚可的草稿阶段。'),
        faqItem('快速试广告构图应该用什么 AI 工具？', '方向探索用 Z Image Turbo；产品摄影终稿用 FLUX，可读促销字用 GPT Image。'),
        faqItem('Z Image 草稿产品细节偏弱怎么修复？', '锁定喜欢的构图后，用同一描述到 FLUX 或 Seedream 重出终稿。'),
        faqItem('和 FLUX 怎么选？', '要快试方向用 Z Image；要交稿质感用 FLUX.2。'),
        faqItem('适合 TikTok/Instagram 图吗？', '适合先做帖子和封面草图。'),
        faqItem('Z Image 适合 Google Shopping 广告图吗？', '适合先试方向；写 1:1、产品清楚、少文字，终稿再换 Seedream 或 FLUX。'),
        faqItem('工作流怎么安排？', 'Z Image 连出 3–5 版 → 选方向 → FLUX/Seedream 终稿 → GPT Image 加文字。'),
        faqItem('和 Flux Schnell 怎么选？', '广告创意试 Z Image；摄影构图试 Schnell；终稿都用 FLUX.2。')
      ])
    ],
    related: ['flux-ai-image-generator-review', 'seedream-ai-image-generator-review', 'gpt-image-generator-guide']
  },
  {
    slug: 'stable-diffusion-online-generator',
    category: 'alternatives',
    layout: 'alternatives',
    coverImage: 'sd-demo',
    heroImage: 'sd-hero',
    title: 'Stable Diffusion 在线替代：SD 3.5 无需本地部署',
    excerpt: 'Stable Diffusion 3.5 在线生图和 Midjourney、FLUX 的分工，适合插画、角色设定和概念艺术场景。',
    metaTitle: 'Stable Diffusion 在线替代：SD 3.5 无需安装 | Miral',
    metaDescription: 'Miral Stable Diffusion 3.5 在线替代：不用本地部署生成 AI 插画和角色图，和 Midjourney、FLUX 怎么选。',
    updatedAt: '2026-07-03',
    target: { label: '打开 Stable Diffusion 试一版', path: '/image-models/stable-diffusion-ai-image-generator' },
    keywords: ['Stable Diffusion 在线', 'SD 3.5 在线', '不用本地部署 SD', 'AI 插画生成', 'Stable Diffusion 提示词', '开源 AI 生图'],
    creatingSteps: [
      { title: '确认你要 SD 的原因', text: '插画、动漫、角色设定适合 SD；电商产品摄影终稿往往要 FLUX/Seedream。' },
      { title: '写风格 + 主体 + 构图', text: 'SD 对风格词敏感：动漫风、概念艺术、胶片颗粒、赛博朋克。' },
      { title: '在线版先出 3 版', text: 'SD 3.5 不用装显卡驱动，浏览器直接试。' },
      { title: '商业终稿换模型', text: '同一条提示词可对比 Midjourney 艺术感和 FLUX 商业质感。' }
    ],
    pros: [
      'Stable Diffusion 在线版无需本地安装、不用配置 ComfyUI',
      '插画、动漫风、角色设定、概念艺术方向灵活',
      '开源风格工作流，适合从 SD 入门 AI 生图的用户',
      '和 Midjourney、FLUX、Seedream 同平台对比方便'
    ],
    cons: [
      '硬质感商业产品摄影不如 FLUX',
      '快速电商主图跟描述不如 Seedream',
      '复杂文字海报仍需 GPT Image',
      '正式商用注意模型授权和内容合规'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', 'AI 插画、动漫风、角色设定、概念艺术、海报草图'],
          ['不太适合', '硬质感产品摄影终稿、复杂文字排版'],
          ['和 Midjourney 比', 'SD 更开源灵活；Midjourney 艺术氛围往往更强'],
          ['我的建议', '插画试 SD 3.5；商业产品图试 Seedream/FLUX']
        ], 'overview'),
        p('不想折腾显卡和 ComfyUI 的话，SD 3.5 浏览器直接用——插画和角色设定我会先在这试，商业终稿再换 FLUX。')
      ]),
      makeSection('why-online', '为什么用在线 Stable Diffusion', [
        p('本地 Stable Diffusion 要显卡、模型文件、插件和参数调优。对只想快速出插画、角色图、风格化头像的用户，在线版更直接。'),
        p('SD 3.5 适合和 Midjourney 比艺术方向、和 Seedream/FLUX 比商业成片，同一提示词多模型对比很高效。'),
        p('从 SD 入门 AI 生图的用户，在线版够用到确认自己真的需要 ComfyUI 和本地显卡。国风插画、游戏角色三视图、动漫头像是 SD 在线版最高频的三类需求。')
      ]),
      makeSection('how-i-tested', '我实际测了什么', [
        p('试了幻想角色设定、复古科幻海报、动漫风头像三类，每类 4 版。角色那条写「银色盔甲 + 蓝色披风 + 古老城堡 + 概念艺术」，第二版线条和氛围最稳；同一条提示词丢给 Midjourney 对比，MJ 氛围感更强，SD 线条控制更灵活。'),
        p('商业产品图同一条提示词在 SD 和 FLUX 各出一版——SD 偏插画感，FLUX 偏摄影质感，按终稿需求选。'),
        gallery(['sd-demo', 'midjourney-demo', 'seedream-lifestyle', 'flux-car'], '插画、艺术风、生活方式、广告风对比', 4),
        stepsBlock()
      ]),
      makeSection('style-scenarios', '插画场景怎么写', [
        table(['风格 / 场景', 'SD 3.5 适合度', '提示词关键词'], [
          ['幻想和概念艺术', '很好', '概念艺术、体积光、超细节、史诗氛围'],
          ['动漫和二次元头像', '很好', '动漫风、干净线条、柔和光线'],
          ['游戏角色设定', '很好', '角色设计、盔甲、姿态、世界观'],
          ['复古科幻海报', '好', '电影海报构图、胶片颗粒、复古科幻'],
          ['国风 / 水墨插画', '很好', '国风、水墨、工笔、传统服饰'],
          ['电商产品摄影终稿', '一般', 'Seedream / FLUX 更合适']
        ], 'overview'),
        p('风格词写具体比空泛形容词有用：概念艺术、动漫风、复古科幻、国风水墨。商业产品图同一条提示词在 SD 和 FLUX 各出一版——SD 偏插画感，FLUX 偏摄影。'),
        tip('和 Midjourney 对比', '同一角色设定提示词，MJ 氛围感往往更强，SD 线条和风格控制更灵活；按项目选终稿模型。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('prompt-tips', 'Stable Diffusion 提示词怎么写', [
        p('SD 对风格词敏感——动漫、概念艺术、复古科幻、国风各用不同关键词组合。角色设定写服装、姿态、世界观背景。'),
        bullets([
          '角色：盔甲、披风、姿态、世界观背景 + 概念艺术。',
          '海报：电影海报构图、胶片颗粒、复古科幻。',
          '动漫：动漫风、干净线稿、柔和配色。',
          '国风：水墨、工笔、传统服饰 + 柔和光线。',
          '商业需求同一条提示词在 SD 和 FLUX 各出一版对比。'
        ])
      ]),
      makeSection('prompt-examples', '提示词与出图示例', [
        promptExample('磨砂黑陶瓷花瓶商品图', '高端商品图，磨砂黑陶瓷花瓶置于大理石底座上，柔和的影棚光，干净背景。（负向：杂乱背景、低分辨率、变形反光。）', 'sd-seo-vase'),
        promptExample('柔和窗光男性人像', '年轻男性肖像，柔和窗光，自然皮肤纹理，浅景深。（负向：过度磨皮、蜡像感、过饱和色彩。）', 'sd-seo-portrait'),
        promptExample('金色时刻海岸悬崖', '电影感海岸悬崖的宽幅风光，金色时刻，戏剧性的云层，细腻的岩石质感，1536×896。', 'sd-seo-coast'),
        promptExample('深蓝几何海报背景', '极简海报背景，居中的几何构图，深蓝渐变，细微颗粒，1280×1280。', 'sd-seo-poster'),
        promptExample('手表与陶瓷杯商品编辑图', '商品编辑图，手表旁是折叠的亚麻布和一只陶瓷杯，平衡的三角构图，柔和晨光。', 'sd-seo-still-life'),
        promptExample('雨窗旁温馨阅读角', '雨窗旁温馨的阅读角，温暖台灯光，堆叠的书本，质感毛毯，电影感氛围。', 'sd-seo-reading'),
        promptExample('老年陶艺师编辑人像', '老年陶艺师的编辑特写肖像，阳光充沛的工作室，自然皮肤纹理，手上的陶土粉尘，温暖窗光，浅景深。', 'sd-seo-potter')
      ]),
      makeSection('model-pick', '和 Midjourney、FLUX 怎么选', [
        p('插画、角色、概念艺术 → SD 3.5 或 Midjourney；商业产品摄影 → FLUX/Seedream；带字海报 → GPT Image。'),
        table(['需求', '优先试', '说明'], [
          ['概念艺术 / 奇幻', 'Midjourney 或 SD 3.5', '艺术探索'],
          ['动漫风 / 国风插画', 'SD 3.5', '风格控制灵活'],
          ['电商主图终稿', 'Seedream 5', '跟商业描述快'],
          ['硬质感摄影', 'FLUX.2', '交稿质感']
        ], 'overview'),
        links('可以一起尝试', [
          { label: 'Midjourney', path: '/image-models/midjourney-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何在线使用 Stable Diffusion 且无需安装？', '用浏览器里的 SD 3.5 在线流程即可，首次测试不必装本地模型、显卡驱动或 ComfyUI。'),
        faqItem('可以在没有本地显卡的情况下用 Stable Diffusion 吗？', '可以。在线版的主要好处就是做插画和角色方向时不用自己架环境。'),
        faqItem('是否能在浏览器里运行 SD 3.5？', '可以。先在线试几版风格，商业产品终稿需要时再切 Seedream 或 FLUX。'),
        faqItem('不做 ComfyUI 也能出插画应该用什么工具？', '插画和风格控制用 Stable Diffusion 3.5 在线版；更看氛围时用 Midjourney。'),
        faqItem('Stable Diffusion 角色细节不稳定怎么修复？', '身份关键词尽量短且各版本保持一致；若商业终稿要更硬摄影感，风格定了再换 FLUX。'),
        faqItem('和 Midjourney 怎么选？', '艺术探索两者都可；Midjourney 氛围感往往更强，SD 更偏风格控制。'),
        faqItem('能做电商产品图吗？', '可以试，但终稿建议 Seedream 或 FLUX。'),
        faqItem('还要自己装 ComfyUI 吗？', '在线版不需要；本地高级工作流才需要。'),
        faqItem('游戏角色三视图能做吗？', '可以试角色设计、正面侧面背面、白背景设定图。'),
        faqItem('SD 和 FLUX 插画怎么分工？', '艺术探索、角色设定用 SD；交稿级产品摄影用 FLUX。')
      ])
    ],
    related: ['midjourney-alternative-online', 'flux-ai-image-generator-review', 'seedream-ai-image-generator-review']
  },
  {
    slug: 'ai-watermark-remover-online',
    category: 'how-to-guides',
    layout: 'how-to',
    coverImage: 'watermark-cover',
    heroImage: 'watermark-cover',
    title: 'AI 去水印怎么用：在线去除标志和水印',
    excerpt: '分步骤说明 AI 去水印去除商品图标志、供应商图水印、Shopify、eBay 和 Etsy 图片标记的操作方法，以及和文档矫正工具的配合技巧。',
    metaTitle: 'AI 去水印怎么用：在线去除标志和水印 | Miral',
    metaDescription: 'Miral AI 去水印教程：在线去除图片标志、文字水印、供应商图角落标记，适合 Shopify、eBay、Etsy 和跨境电商商品图清理。',
    updatedAt: '2026-07-14',
    target: { label: '打开 AI 去水印', path: '/tools/watermark-remover' },
    keywords: ['AI 去水印', '在线去水印', '去除图片标志', '图片去文字水印', '电商图片清理', 'Shopify 商品图去水印', 'eBay 图片清理', 'Etsy 商品图清理', 'remove watermark'],
    creatingSteps: [
      { title: '上传原图', text: '商品图、照片、海报截图、带平台水印的社媒图都可以。' },
      { title: '框选水印区域', text: '尽量贴边框选标志、日期戳、角落文字，别大面积盖住主体。' },
      { title: '生成并检查边缘', text: '复杂背景分两次处理：先大水印，再修残留。' },
      { title: '清理后再创作', text: '干净素材可进 Seedream/FLUX 做新海报，或 GPT Image 加文字。' }
    ],
    pros: [
      '在线去水印，不用装 Photoshop 插件',
      '适合电商图、照片、海报上的标志和文字标记',
      '和手写擦除、文档矫正工具同平台，素材处理一条龙',
      '清理后可继续 AI 生图二次创作'
    ],
    cons: [
      '大面积水印或复杂纹理背景可能需要多次处理',
      '低清晰度原图修复质量有限',
      '涉及第三方版权素材需用户自行确认权限',
      '透明渐变水印有时要分区域试'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', '角落标志、日期戳、浅色水印、小面积文字标记'],
          ['不太适合', '整图大面积半透明水印、极低清晰度原图'],
          ['处理技巧', '小范围多次比一次大面积涂抹更自然'],
          ['我的建议', '文档倾斜先 Image Crop & Dewarp，再去水印']
        ], 'overview'),
        p('先把素材清理干净，再拿去做 AI 海报或产品图——去水印是我文档处理链里的常规一步。')
      ]),
      makeSection('what-it-does', 'AI 去水印能做什么', [
        p('AI 去水印适合移除图片里的浅色水印、角落标志、重复文字、日期戳、平台下载标记和遮挡标签。常见用途：电商商品图清理、Shopify 供应商图整理、eBay 和 Etsy 商品页图片清理、社媒截图去平台水印、设计素材预处理、旧海报翻新。'),
        p('它不会「魔法般」恢复所有细节——背景越复杂，越建议分区域多次处理。文档类图片如果本身倾斜，建议先用 Image Crop & Dewarp 拉正，再去水印，边缘会更自然。'),
        p('和 Photoshop 内容识别填充比，优势是网页直接用、不用装插件，适合运营和设计快速清理素材。清理后的图可以进 Seedream/FLUX 做新产品图，或 GPT Image 加促销文字。')
      ]),
      makeSection('how-to-use', '我实际怎么用的', [
        p('试了商品图右下角标志、照片左上角日期戳、海报半透明重复水印三类。商品图那次框选贴边标志，一次就干净；海报半透明水印我分两次——先主水印，再修边缘残留，比一次大面积涂自然得多。'),
        p('框选越准、区域越小，AI 补全周围纹理越自然。复杂背景别指望一次到位。极低清压缩图先尽量找更高清原图，再去水印成功率更高。'),
        p('电商运营常见流程：供应商图带角落标志 → 去水印 → Seedream 换背景出主图。Shopify 独立站、eBay 商品页、Etsy 图集和 Walmart Marketplace 商品图都能用这套思路，但商用前务必确认原图授权。'),
        gallery([
          'watermark-full-before', 'watermark-full-after',
          'watermark-timestamp-before', 'watermark-timestamp-after',
          'watermark-logo-before', 'watermark-logo-after',
          'watermark-draft-before', 'watermark-draft-after'
        ], '每行左图为处理前、右图为处理后：整图水印、时间戳、商品标志和设计稿标记。', 2, 'contain', 'landscape'),
        stepsBlock()
      ]),
      makeSection('watermark-types', '不同类型水印怎么处理', [
        table(['水印类型', '处理难度', '操作建议'], [
          ['角落标志和小标记', '低', '贴边框选，一次通常够'],
          ['浅色重复水印', '中', '可能需要 2 次，分区域处理'],
          ['照片日期戳', '中', '框选贴边，别涂到主体'],
          ['半透明平台水印', '中高', '分块处理，先主水印再修残留'],
          ['Shopify 供应商图标志', '中', '小范围框选，清理后可换背景'],
          ['eBay 和 Etsy 图片标记', '中', '日期戳、小贴纸、多余文字分块处理'],
          ['Walmart Marketplace 商品图', '中', '保护白底和产品边缘，别盖住主体'],
          ['海报大面积水印', '高', '分区域多次，或换更高清原图'],
          ['TikTok 和社媒截图', '中', '截图清晰度越高越好']
        ], 'overview'),
        p('角落标志和日期戳成功率最高；半透明平台水印和重复水印要分块处理。整图大面积水印建议换更高清原图，或分区域多次小范围处理。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('best-practices', '去水印效果更好的技巧', [
        bullets([
          '水印区域框准，避免大面积覆盖产品主体。',
          '复杂背景分两次：先主水印，再修边缘残留。',
          '文档照片先 Image Crop & Dewarp 矫正透视。',
          '清理后的图可进 Seedream/FLUX 生成新商业视觉。',
          'Shopify、eBay、Etsy 商品页图集先处理小标记，再统一背景和比例。',
          'Walmart Marketplace 商品图重点保留白底、产品边缘和真实材质。',
          '社媒截图尽量用原图或高清截图，低清图修复质量有限。',
          '涉及 stock 图、样机图标记，商用前确认授权。'
        ]),
        tip('失败重试', '边缘发虚或纹理不对时，缩小框选范围再试一次，比扩大涂抹更有效。')
      ]),
      makeSection('links', '相关工具', [
        links('相关入口', [
          { label: 'Image Crop & Dewarp', path: '/tools/doc-crop-enhance' },
          { label: 'Handwriting Eraser', path: '/tools/handwritten-erase' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何去除电商图片上的水印？', '上传清晰商品图，只框选水印或标志区域，导出前检查产品边缘。'),
        faqItem('可以从 Shopify 商品图里去掉 Logo 吗？', '在有原图授权的前提下可以。清理后上架前再检查产品边缘是否完整。'),
        faqItem('是否能擦除图片上的半透明水印？', '多数角落标记和重复叠加水印可以；大面积低对比水印可能需要二次处理。'),
        faqItem('清理 Shopify 角落标记应该用什么工具？', '先用 AI 去水印；若要做新产品视觉再进 Seedream 或 FLUX，要促销字再用 GPT Image。'),
        faqItem('去水印后出现重复纹理怎么修复？', '缩小框选范围再处理一次，第一次不要盖住关键产品边缘。'),
        faqItem('可以去除标志吗？', '可以处理小面积标志和角落标记，建议贴边框选。'),
        faqItem('去水印会影响画质吗？', 'AI 按周围纹理补全，复杂背景建议多次小范围处理。'),
        faqItem('文档照片先去水印还是先矫正？', '建议先 Image Crop & Dewarp 拉正，再去水印。'),
        faqItem('半透明水印能去除吗？', '可以试，建议分两次小范围框选；截图越清晰效果越好。'),
        faqItem('Shopify 供应商商品图水印怎么处理？', '只框选角落标志或小面积文字，清理后再用 Seedream 或 FLUX 换背景，商用前确认图片授权。'),
        faqItem('eBay 和 Etsy 商品图可以清理吗？', '可以处理日期戳、小贴纸和多余文字。商品状态和真实细节不要修没。')
      ])
    ],
    related: ['handwriting-eraser-online', 'image-crop-dewarp-online', 'gpt-image-generator-guide']
  },
  {
    slug: 'ai-background-remover-online',
    category: 'how-to-guides',
    layout: 'how-to',
    badge: 'Hot',
    coverImage: 'background-remover-after',
    heroImage: 'background-remover-after',
    title: '免费 AI 背景移除在线抠图并导出透明 PNG',
    excerpt: '免费在线移除图片背景：从上传 JPG、PNG 或 WebP，到 AI 自动识别主体、检查发丝和边缘，再导出透明 PNG。',
    metaTitle: '免费 AI 背景移除：在线抠图导出透明 PNG | Miral',
    metaDescription: '免费使用 Miral AI 背景移除在线抠图：自动去除照片背景，处理人像、商品、Logo 和宠物图片，并导出透明 PNG。',
    updatedAt: '2026-09-11',
    target: { label: '打开 AI 背景移除', path: '/tools/background-remover' },
    keywords: ['免费 AI 背景移除', '免费在线抠图', 'AI 背景移除', '在线抠图', '图片去背景', '自动抠图', '透明背景图片', 'PNG 透明背景', '人像背景移除', '发丝抠图'],
    creatingSteps: [
      { title: '上传原图', text: '选择 JPG、PNG 或 WebP 图片，单张文件不要超过 15 MB。' },
      { title: '等待 AI 自动识别', text: '工具会自动识别前景主体并移除整张背景，不需要手动画选区。' },
      { title: '放大检查边缘', text: '重点检查发丝、半透明物体、产品孔洞和主体边缘是否完整。' },
      { title: '下载透明 PNG', text: '确认效果后下载 PNG，透明区域可以继续用于设计、换背景或商品图排版。' }
    ],
    pros: ['自动识别主体，不需要手动描边', '支持 JPG、PNG 和 WebP', '结果以透明 PNG 下载', '适合人像、商品、Logo、签名和宠物图片'],
    cons: ['复杂发丝和透明物体需要重点复核', '主体与背景颜色接近时边缘可能不稳定', '当前页面按单张图片处理', '超过 15 MB 的文件需要先压缩'],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '说明'], [
          ['费用', '背景移除功能免费使用，登录后即可处理图片'],
          ['输入格式', 'JPG、PNG、WebP，单张最大 15 MB'],
          ['处理方式', 'AI 自动识别主体并移除整张背景，无需手动框选'],
          ['输出格式', '透明 PNG'],
          ['适合内容', '人像、头像、商品、Logo、签名、宠物图片'],
          ['重点检查', '发丝、透明材质、细小孔洞和低对比边缘']
        ], 'overview'),
        p('如果目标是免费把照片背景变透明，可以登录 Miral AI 后直接上传清晰原图，无需安装 Photoshop 或付费抠图软件。主体轮廓越清楚、与背景对比越明显，自动抠图通常越稳定。')
      ]),
      makeSection('what-it-does', 'AI 背景移除能做什么', [
        p('Miral AI 背景移除会分析整张图片，自动区分前景主体和背景，省去 Photoshop 钢笔工具逐点描边。常见用途包括人像背景移除、头像去背景、Logo 背景移除、签名去背景、宠物图片抠图和商品图素材清理。'),
        p('处理完成后下载的是透明 PNG。透明背景不是白色背景：把结果放到深色、浅色或品牌色画布上，背景会透出；如果平台要求白底图，需要在设计工具里再铺一层纯白背景。'),
        gallery(['background-remover-before', 'background-remover-after'], '左图为原始图片，右图为背景移除后的视觉示例；最终文件以透明 PNG 下载。', 2, 'contain', 'portrait'),
        tip('透明底和白底不是一回事', '透明会把画布留空；白色背景会永久填上白色像素。')
      ]),
      makeSection('how-to-use', '在线去除图片背景的步骤', [
        p('打开 Miral AI 背景移除后上传一张 JPG、PNG 或 WebP。AI 会自动处理整张图，不用涂抹背景，也不用框选主体。完成后先放大查看轮廓，再下载透明 PNG 用于海报、电商图或社媒头像。'),
        stepsBlock(),
        tip('保留清晰边缘', '尽量上传未经多次压缩的原图。小尺寸截图、运动模糊和主体背景同色，都会增加边缘识别难度。')
      ]),
      makeSection('edge-check', '不同图片应该检查什么', [
        table(['图片类型', '重点检查', '建议'], [
          ['人像和头像', '发丝、耳饰、眼镜边缘', '放大到 100% 检查细发丝是否缺失'],
          ['服装和商品', '衣角、鞋带、产品孔洞', '确认背景没有残留在封闭区域'],
          ['玻璃和透明物体', '反光、透明边缘', '结果需人工复核，必要时换对比更强的原图'],
          ['Logo 和签名', '细线、镂空区域', '优先上传高分辨率、边缘清楚的版本'],
          ['宠物图片', '毛发和胡须', '选择背景简洁、轮廓对比明显的照片']
        ], 'overview'),
        p('下载后把透明 PNG 分别放到浅色和深色画布上检查。白边、黑边和漏抠会立刻露出来，比只看棋盘格预览更稳。')
      ]),
      makeSection('background-types', '透明背景、白色背景和换背景有什么区别', [
        table(['结果类型', '画面表现', '适合用途'], [
          ['透明背景', '背景区域没有固定颜色，导出为透明 PNG', 'Logo、头像、海报素材、电商素材透明底'],
          ['白色背景', '透明 PNG 下方增加纯白色画布', '商品白底图、证件照和需要白底的页面'],
          ['品牌色背景', '在主体下方铺品牌色或渐变色', '社媒头像、活动海报和品牌视觉'],
          ['场景背景', '把抠出的主体放进新的环境图片', '商品场景图、宣传图和创意合成']
        ], 'overview'),
        p('实际使用时，透明底和白底很容易被混为一谈。更稳妥的做法是先保存透明 PNG，再按最终用途铺白色、品牌色或场景背景。JPG 不支持透明通道，所以不要用 JPG 保存透明母版。')
      ]),
      makeSection('troubleshooting', '去背景效果不完整怎么排查', [
        table(['问题', '常见原因', '处理建议'], [
          ['边缘出现白边或黑边', '原图轮廓受背景颜色污染', '在深浅两种底色上检查，并换用对比更明显的原图重试'],
          ['发丝、胡须被删掉', '细节太细、图片模糊或压缩严重', '使用更高清的原图，放大检查发丝边缘'],
          ['主体内部还有背景', '把手、圆环或网状区域没有完全识别', '重点检查封闭孔洞和交叉细线'],
          ['玻璃或透明包装缺失', '透明物体会同时呈现背景颜色', '换用轮廓更清晰的拍摄图，并人工复核透明区域'],
          ['白色或黑色主体缺边', '主体与背景对比过低', '更换反差更大的背景原图后重新自动抠图'],
          ['结果看起来变糊', '上传的是缩略图或多次压缩图片', '回到相机原图或更高分辨率文件再处理']
        ], 'overview'),
        tip('重试重点', 'AI 抠图边缘发白、发丝缺失或透明物体不完整时，优先改善输入图片，而不是反复提交同一张低清图片。')
      ]),
      makeSection('pros-cons', '优缺点', [prosConsBlock()]),
      makeSection('best-practices', '提高自动抠图质量的技巧', [
        bullets([
          '上传清晰原图，避免使用聊天软件反复压缩后的缩略图。',
          '优先选择主体完整、没有被画面边缘截断的图片。',
          '主体和背景颜色相近时，换一张对比更明显的原图通常更有效。',
          '透明 PNG 下载后，在不同底色上分别检查白边、黑边和漏抠。',
          '白色商品不要只在白色画布上检查，深色底更容易看到残留。',
          '当前一次处理一张图片，适合先把重要图片逐张检查好。'
        ])
      ]),
      makeSection('miral-workflow', '在 Miral AI 中继续处理图片', [
        p('背景移除只是素材处理的第一步。透明 PNG 可以继续在 Miral AI 中增强清晰度、清除多余物体或水印，也可以进入 Seedream 和 FLUX.2 制作新的商品场景图。'),
        links('相关工具和指南', [
          { label: 'Miral AI 背景移除', path: '/tools/background-remover' },
          { label: 'AI 图片增强', path: '/tools/image-enhancer' },
          { label: 'AI 物体移除', path: '/tools/object-remover' },
          { label: 'AI 去水印', path: '/tools/watermark-remover' },
          { label: '商品图去背景与白底图指南', path: '/hub/articles/ecommerce-product-background-removal' },
          { label: '人像去背景与证件照', path: '/hub/articles/ai-portrait-background-remover' },
          { label: 'AI 换背景在线指南', path: '/hub/articles/ai-background-changer-online' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何在线把图片背景变透明？', '上传 JPG、PNG 或 WebP，等待 AI 自动移除背景，然后下载透明 PNG。'),
        faqItem('需要手动框选人物或商品吗？', '不需要。工具自动识别整张图片中的前景主体。'),
        faqItem('为什么下载的是 PNG？', 'PNG 支持透明通道，JPG 不支持透明背景。'),
        faqItem('图片去背景会改变原始尺寸吗？', '输出用于保留主体和透明区域；下载后仍应核对像素尺寸与具体设计需求。'),
        faqItem('AI 抠图边缘有白边怎么办？', '先在深色底上检查；优先换用更清晰、主体与背景对比更强的原图重新处理。'),
        faqItem('可以处理发丝和宠物毛发吗？', '可以，但细发丝、胡须和毛发属于高难度边缘，下载前需要放大复核。'),
        faqItem('AI 去背景和背景橡皮擦有什么区别？', 'AI 去背景会自动识别整张图片的主体；传统背景橡皮擦通常需要手动擦除。'),
        faqItem('白色主体去白色背景为什么容易缺边？', '主体与背景对比过低会增加识别难度，建议换用反差更明显的原图。'),
        faqItem('玻璃或透明物体为什么会缺一块？', '透明材质会透出原背景颜色，边界更难判断。可以换用更清晰、背景反差更大的原图，并人工复核透明区域。'),
        faqItem('Miral AI 背景移除免费吗？', '免费。登录 Miral AI 后即可上传并处理图片，不需要安装额外软件。'),
        faqItem('使用背景移除需要登录吗？', '需要先登录，但背景移除功能本身免费使用。'),
        faqItem('支持哪些图片格式和大小？', '支持 JPG、PNG、WebP，单张最大 15 MB。')
      ])
    ],
    related: ['ecommerce-product-background-removal', 'ai-portrait-background-remover', 'ai-background-changer-online']
  },
  {
    slug: 'ecommerce-product-background-removal',
    category: 'how-to-guides',
    layout: 'how-to',
    badge: 'Hot',
    coverImage: 'ecommerce-background-remover-after',
    heroImage: 'ecommerce-background-remover-after',
    title: '免费 AI 商品图去背景与电商白底图、透明 PNG 指南',
    excerpt: '免费完成商品抠图：先自动移除背景，再为 Amazon、Shopify、eBay、Etsy 等电商场景制作透明底或白底商品图。',
    metaTitle: '免费 AI 商品图去背景：Amazon、Shopify 白底图 | Miral',
    metaDescription: '免费使用 Miral AI 移除商品图片背景，制作透明 PNG 和电商白底图，覆盖 Amazon、Shopify、eBay、Etsy 与跨境电商主图。',
    updatedAt: '2026-09-11',
    target: { label: '打开商品图去背景', path: '/tools/background-remover' },
    keywords: ['免费商品图去背景', '免费电商产品抠图', '商品图去背景', '电商产品抠图', '商品白底图', 'Amazon 产品白底图', 'Shopify 商品图透明背景', 'eBay 商品图去背景', 'Etsy 商品背景移除', '跨境电商主图'],
    creatingSteps: [
      { title: '准备清晰商品原图', text: '选择主体完整、没有遮挡的 JPG、PNG 或 WebP，单张不超过 15 MB。' },
      { title: '自动移除原背景', text: '上传后由 AI 自动识别商品轮廓，不需要手动框选。' },
      { title: '检查商品细节', text: '查看把手、鞋带、首饰链条、玻璃反光和包装透明区域。' },
      { title: '下载透明 PNG', text: '保留透明底用于 Shopify 设计或后续换场景。' },
      { title: '按平台制作白底图', text: '需要纯白背景时再铺白色画布，并按目标平台当前规范检查尺寸、留白和内容。' }
    ],
    pros: ['一张透明 PNG 可复用到多个销售渠道', '自动识别商品轮廓，减少手工抠图时间', '便于统一店铺主图背景与留白', '可继续进入 Seedream 或 FLUX 制作场景图'],
    cons: ['平台规范会变化，上架前仍需核对官方要求', '透明、反光、毛绒和细链商品需要人工检查', '自动去背景不会自动完成平台尺寸排版', '当前工具按单张图片处理'],
    sections: [
      makeSection('tldr', '电商商品图去背景流程', [
        table(['阶段', '产物', '注意事项'], [
          ['免费处理', '登录后使用 Miral AI 背景移除', '无需安装软件，先生成透明 PNG 母版'],
          ['AI 去背景', '透明 PNG 商品素材', '检查产品边缘、孔洞和透明材质'],
          ['白底排版', '纯白背景商品图', '透明 PNG 上再铺白色画布'],
          ['平台适配', 'Amazon、Shopify、eBay、Etsy 等渠道图片', '分别核对当前尺寸和内容规范'],
          ['场景延展', '横幅、详情页和社媒场景图', '保留真实商品形态，不要误改结构']
        ], 'overview'),
        p('Miral AI 商品图去背景可以免费使用。登录后先生成一份边缘干净的透明 PNG 母版，再为不同渠道制作白底、品牌色底或生活方式场景图。')
      ]),
      makeSection('workflow', '商品图片怎么自动抠图', [
        p('把清晰商品原图上传到 Miral AI 背景移除。系统自动识别产品主体并清除原背景，不需要手动画蒙版。下载透明 PNG 后，可以在设计画布中添加纯白背景，也可以交给 Seedream 或 FLUX 制作生活方式场景。'),
        gallery(['ecommerce-background-remover-before', 'ecommerce-background-remover-after'], '商品素材处理前后视觉示例。透明 PNG 是后续白底图和场景图的通用母版。', 2, 'contain', 'portrait'),
        p('最后这一步最容易跳过。把手、接口、鞋带、链条、透明包装，以及旧背景本该透出来的空隙都要看一遍。这些细节决定商品放到新画布上还是否自然。'),
        stepsBlock()
      ]),
      makeSection('transparent-or-white', '为什么先保留透明 PNG', [
        p('透明 PNG 是最值得保留的母版。同一件商品今天可以铺成白底主图，明天可以放进 Shopify 品牌色卡片，下个月还可以做活动横幅。如果一开始只保存白底成品，后面每换一次背景都可能要重新处理。'),
        tip('文件分开保存', '透明母版、白底图和场景图分别保存，不要用渠道成品覆盖透明 PNG。')
      ]),
      makeSection('platforms', 'Amazon、Shopify、eBay、Etsy 怎么使用', [
        table(['渠道', '常见用途', '处理建议'], [
          ['Amazon', '产品主图、辅图', '需要白底时，在透明 PNG 下方铺纯白背景，并核对当前类目规范'],
          ['Shopify', '商品卡片、首页横幅、专题页', '透明底适合灵活套用品牌色和响应式版式'],
          ['eBay', '刊登主图和图集', '保证商品完整、边缘自然，避免背景残影'],
          ['Etsy', '手作商品封面和细节图', '主图保持清晰，场景图不要掩盖真实材质'],
          ['Google Shopping', '商品广告素材', '保持商品与落地页信息一致，并核对最新广告规范'],
          ['跨境独立站', '多语言商品页和广告图', '从同一透明 PNG 母版派生不同尺寸']
        ], 'overview'),
        tip('平台要求', 'AI 去背景只负责生成干净素材，不会自动保证符合每个平台的最新上架政策；发布前应核对目标渠道官方规范。')
      ]),
      makeSection('quality-check', '哪些商品最容易抠坏', [
        bullets([
          '玻璃杯、透明包装和水晶：透明区域可能被误判为背景。',
          '首饰链条、鞋带和网状产品：细线容易断裂或丢失。',
          '白色商品配白背景、黑色商品配深背景：低对比轮廓更难识别。',
          '毛绒服饰和宠物用品：绒毛边缘需要在深浅两种底色上检查。',
          '高反光金属：反光中的环境颜色可能被当作背景残留。'
        ])
      ]),
      makeSection('product-cases', '不同商品类型怎么检查', [
        table(['商品类型', '容易出现的问题', '验收重点'], [
          ['服装和鞋子', '衣角、鞋带、网眼和绒毛被误删', '检查轮廓连续性、鞋带交叉处和面料边缘'],
          ['首饰和珠宝', '细链断裂、镂空区域残留背景', '放大检查链条、爪镶、耳针和内部孔洞'],
          ['玻璃和透明包装', '透明区域缺失或残留原背景颜色', '分别放在白底和深色底上检查'],
          ['美妆产品', '瓶盖缝隙、泵头和透明瓶身不完整', '检查包装文字、瓶身轮廓和真实颜色'],
          ['电子产品', '接口、线缆和反光边缘识别错误', '确认接口孔位、配件和品牌标识完整'],
          ['家具和家居用品', '椅腿空隙、镂空结构漏抠', '检查支架之间的背景是否清除干净']
        ], 'overview'),
        p('不同材质出问题的位置并不一样：衣服要看毛边，首饰要看细链，玻璃要看透明区域，电子产品则要看接口和反光边缘。不要只看缩略图，最终商品图最好放大到 100%，再换一深一浅两种底色检查。')
      ]),
      makeSection('acceptance-checklist', '商品图去背景后的验收清单', [
        bullets([
          '主体轮廓完整，没有白边、黑边、锯齿和原背景残留。',
          '把手、鞋带、首饰链条、网眼和镂空区域没有漏抠。',
          '透明包装、玻璃和反光金属仍然保留真实材质感。',
          '商品颜色、Logo、包装文字、接口和配件没有被修改或删除。',
          '透明 PNG 母版单独保留，白底图和场景图从母版派生。',
          '发布前再次核对目标平台当前的尺寸、留白、背景和内容规则。'
        ]),
        tip('母版管理', '产品图统一背景时，先保存干净的产品透明 PNG。以后更换白底、品牌色或活动场景，不需要重新抠图。')
      ]),
      makeSection('pros-cons', '优缺点', [prosConsBlock()]),
      makeSection('miral-workflow', '用 Miral AI 完成商品图工作流', [
        p('一张商品原图可以在 Miral AI 中完成去背景、清晰度增强和场景延展：先保存透明 PNG 母版，再按渠道生成白底图、品牌色图或生活方式图片。'),
        links('相关工具和指南', [
          { label: 'Miral AI 背景移除', path: '/tools/background-remover' },
          { label: 'AI 图片增强', path: '/tools/image-enhancer' },
          { label: '通用 AI 背景移除教程', path: '/hub/articles/ai-background-remover-online' },
          { label: '人像去背景与证件照', path: '/hub/articles/ai-portrait-background-remover' },
          { label: 'AI 换背景在线指南', path: '/hub/articles/ai-background-changer-online' },
          { label: 'Seedream 5 商品图生成', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2 产品摄影', path: '/image-models/flux-2-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('Miral AI 商品图去背景免费吗？', '免费。登录后即可处理单张商品图片并下载透明 PNG，无需安装额外抠图软件。'),
        faqItem('怎么制作 Amazon 商品白底图？', '先用 AI 移除原背景并下载透明 PNG，再在图片下方铺纯白背景，最后按目标类目当前规范检查。'),
        faqItem('Shopify 商品图必须是白底吗？', '不一定。透明 PNG 便于套用品牌色、卡片和横幅，但最终应按店铺设计和主题效果选择。'),
        faqItem('透明背景和白色背景有什么区别？', '透明背景没有固定底色，可以叠加到任意画布；白色背景已经包含白色像素。'),
        faqItem('能一次批量处理整个商品目录吗？', '目前一次处理一张图片，更适合逐张检查商品边缘和透明材质。'),
        faqItem('玻璃商品去背景后不完整怎么办？', '透明和反光产品识别难度更高，优先换用背景对比更强、边缘更清晰的原图并人工复核。'),
        faqItem('产品抠图出现白边怎么办？', '把透明 PNG 放到深色底上定位白边，并优先使用对比更强、分辨率更高的商品原图重新处理。'),
        faqItem('商品透明 PNG 应该怎么保存？', '保留一份不带固定背景的透明 PNG 母版，再从母版生成各平台需要的白底图、品牌色图和场景图。'),
        faqItem('不同平台可以共用同一张商品图吗？', '可以共用透明 PNG 母版，但最终尺寸、构图、留白和背景仍应按各平台及类目的当前要求分别制作。'),
        faqItem('去背景后可以直接生成场景图吗？', '可以把透明 PNG 继续用于 Seedream 或 FLUX，但要检查生成结果是否保持商品结构、颜色和标识准确。')
      ])
    ],
    related: ['ai-background-remover-online', 'ai-portrait-background-remover', 'ai-background-changer-online']
  }
]

var PORTRAIT_CHANGER_ARTICLES_ZH = require('./portraitChangerArticlesZh.js').ARTICLES
HUB_ARTICLES = HUB_ARTICLES.concat(PORTRAIT_CHANGER_ARTICLES_ZH)

HUB_ARTICLES = HUB_ARTICLES.concat([
  {
    slug: 'handwriting-eraser-online',
    category: 'how-to-guides',
    layout: 'how-to',
    coverImage: 'handwriting-cover',
    heroImage: 'handwriting-cover',
    title: 'AI 手写文字擦除：在线擦除试卷答案和文档手写字',
    excerpt: '分步骤说明 AI 手写文字擦除如何清理试卷手写答案、合同批注、笔记涂鸦和扫描文档手写标记，并尽量保留印刷文字。',
    metaTitle: 'AI 手写文字擦除：在线去除文档手写字 | Miral',
    metaDescription: 'Miral AI 手写文字擦除教程：免费在线擦除手写文字、去除文档中的手写字、还原空白试卷，并配合自动旋转、切边和文档弯曲矫正。',
    updatedAt: '2026-07-14',
    target: { label: '打开手写擦除', path: '/tools/handwritten-erase' },
    keywords: ['AI 手写文字擦除', '免费在线擦除手写文字', '去除文档中的手写字', '试卷手写答案擦除', '保留印刷文字擦除手写字', 'AI 试卷手写答案擦除'],
    creatingSteps: [
      { title: '上传扫描件或照片', text: 'JPG、PNG、WebP 文档图片都可以，试卷、合同、练习册、作业、表格和白板照片都适用。' },
      { title: '先拉正文档方向', text: '倾斜、旋转或弯曲的扫描文档，先自动旋转、切边或做文档弯曲矫正。' },
      { title: '涂抹手写字区域', text: '略大于笔迹涂抹，尽量保留印刷文字、试题和表格线。' },
      { title: '检查边缘并二次处理', text: '表格线附近建议小范围多次擦。' },
      { title: '导出干净版本', text: '可用于打印空白试卷、重新练习、OCR 归档，或继续用 AI Watermark Remover 清理。' }
    ],
    pros: [
      '在线擦除手写字，适合扫描件和拍照文档',
      '适合试卷手写答案擦除、空白试卷还原和学生作业清理',
      '尽量保留印刷文字、试题内容、表格线和合同条款',
      '红笔、蓝笔、铅笔、黑色手写字都可尝试',
      '和自动旋转、文档自动切边、文档弯曲矫正组成处理流程'
    ],
    cons: [
      '大面积手写覆盖印刷内容时效果受限',
      '表格线密集区域要分段处理',
      '模糊照片影响识别和补全',
      '涉及正式合同需人工复核'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', '扫描件批注、试卷手写答案、学生作业、练习册、合同批注、笔记涂鸦'],
          ['不太适合', '手写盖住大部分印刷文字、极低清照片'],
          ['核心能力', '去除文档中的手写字，尽量保留印刷文字和试题内容'],
          ['配合工具', '先 Image Crop & Dewarp 矫正，再擦手写'],
          ['我的建议', '试卷还原成空白试卷时，小范围多次擦比一次大面积涂更稳']
        ], 'overview'),
        p('把文档恢复成更干净的可读版本——教师清理试卷答案、学生还原错题试卷、办公擦合同批注，我都先矫正再擦。需要免费在线擦除手写文字时，可以先用一页样张试试效果。')
      ]),
      makeSection('what-it-does', '手写擦除适合哪些图片', [
        p('手写擦除适合清理扫描文档、课堂讲义、表格照片、合同图片、试卷、收据、白板照片和带手写批注的图片。常见场景：去除文档中的手写字、清理扫描文档手写标记、合同手写内容擦除、笔记手写内容清理。'),
        p('试卷场景更常见：AI 试卷手写答案擦除、免费在线擦除试卷答案、去除试卷上的学生答案、保留试题擦除手写答案、把做过的试卷还原成空白试卷。教师可以清理试卷重新打印，学生也可以把错题试卷重置后再练一遍。'),
        p('如果照片本身倾斜、旋转或书页弯曲，建议先用 Image Crop & Dewarp 自动旋转扫描文档、文档自动切边或做弯曲矫正，再擦手写字——否则 AI 补全表格线和文字边缘时容易歪。'),
        p('清理后可 OCR 归档、打印空白卷、或进 Seedream / FLUX 做产品视觉，需要带字封面时用 GPT Image 或 Qwen Image。正式合同、协议类文档建议人工复核印刷条款是否完整。')
      ]),
      makeSection('how-to-use', '我实际怎么用的', [
        p('试了红笔批注、铅笔笔记、表格内手填数字三类。红笔合同批注那次，涂抹略大于笔迹、没盖住印刷字，一次就干净；表格内手填数字我分段擦，保护表格线，比一次涂整行稳。'),
        p('经验：涂抹区域略大于笔迹，但别一次性盖住整行印刷字；表格场景分段处理效果更好。手写内容覆盖印刷文字时，AI 会尽量补全背景，但印刷字可能受影响，正式文件要人工复核。'),
        p('试卷去答案留空白卷：笔迹清晰时成功率高，擦除后可打印给下一届学生用。白板照片建议先 Image Crop & Dewarp 拉正，再擦除会议笔记。'),
        gallery([
          'handwriting-contract-before', 'handwriting-contract-after',
          'handwriting-exam-ko-before', 'handwriting-exam-ko-after',
          'handwriting-exam-zh-before', 'handwriting-exam-zh-after',
          'handwriting-scan-before', 'handwriting-scan-after'
        ], '每行左图为原始文档、右图为擦除后：英文合同、韩文试卷、中文试卷和英文巡检表。', 2, 'contain', 'portrait'),
        stepsBlock()
      ]),
      makeSection('test-paper-scenarios', '试卷和学生场景', [
        table(['需求', '适合处理什么', '注意事项'], [
          ['AI 试卷手写答案擦除', '学生答案、草稿、批注、圈画', '先保留试题，再小范围擦答案'],
          ['试卷还原成空白试卷', '已答试卷、错题试卷、练习题', '擦完检查题干和选项是否完整'],
          ['教师试卷答案清理工具', '备课、组卷、重新打印', '红笔批改痕迹建议分块处理'],
          ['学生试卷清理工具', '错题重做、复习、重新作答', '铅笔字和圆珠笔字都可试'],
          ['练习册和作业手写字擦除', '练习册答案、学生作业、手写标记', '页面弯曲先矫正再擦'],
          ['空白试卷生成工具', '从已答试卷恢复空白版本', '低清扫描件建议先重拍或增强']
        ], 'overview'),
        p('试卷扫描件手写擦除的关键不是一次擦干净，而是保留印刷试题。题干、选项和表格线附近尽量分段处理；红笔批改、铅笔字、圆珠笔字都可以试，但覆盖到印刷文字时要降低预期。')
      ]),
      makeSection('document-types', '不同文档类型的处理技巧', [
        table(['文档类型', '处理要点', '备注'], [
          ['试卷和讲义', '擦答案留空白卷', '笔迹清晰时成功率高'],
          ['合同和协议', '保留印刷条款', '涂抹别盖住印刷文字'],
          ['扫描文档手写标记', '先自动切边和旋转', '再分块擦手写标记'],
          ['表格和表单', '分段擦，保护表格线', '小范围多次更稳'],
          ['白板照片', '先矫正再擦除', '透视拉正后效果更好'],
          ['收据和票据', '小范围精确涂抹', '略大于笔迹即可'],
          ['笔记和涂鸦', '略大于笔迹涂抹', '归档前清理']
        ], 'overview'),
        p('试卷和讲义最适合；合同要保留印刷条款；表格分段擦；白板先矫正再擦。JPG、PNG、WebP 手写擦除都建议用清晰原图，手写盖住大部分印刷文字时效果受限。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('best-practices', '提高清理质量的方法', [
        bullets([
          '倾斜文档先 Image Crop & Dewarp 拉直。',
          '旋转、弯曲、黑边明显的扫描件，先自动旋转、文档自动切边和弯曲矫正。',
          '涂抹略大于笔迹，避免覆盖印刷文字。',
          '表格线附近分段擦，一次不要涂太大。',
          '清理后可 OCR、归档，或进 Seedream / FLUX 做视觉，带字封面用 GPT Image。',
          '红笔、蓝笔、铅笔都可试；荧光笔标记小范围精确涂抹。',
          '擦除后检查表格线和印刷字边缘，不对就小范围再处理一次。'
        ]),
        tip('推荐顺序', 'Image Crop & Dewarp → Handwriting Eraser → AI Watermark Remover → OCR 或 Seedream / GPT Image。')
      ]),
      makeSection('links', '相关工具', [
        links('相关入口', [
          { label: 'Image Crop & Dewarp', path: '/tools/doc-crop-enhance' },
          { label: 'AI Watermark Remover', path: '/tools/watermark-remover' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何擦除扫描文档中的手写笔记？', '上传清晰的扫描件或照片，只涂抹手写区域；表格和表单线附近建议分成小区域处理。'),
        faqItem('能否只删除手写字而保留印刷文字？', '手写内容没有大面积覆盖印刷文字时可以。导出前要检查小字号文字、题干和表格线边缘。'),
        faqItem('去除试卷手写答案应该用什么工具？', '使用 Handwriting Eraser 可以清理学生答案、计算过程和批注，同时尽量保留可读的印刷题目。'),
        faqItem('擦除后文字模糊或表格线断裂怎么修复？', '撤销过大的涂抹区域，沿笔迹分成更小范围重新处理，避免覆盖印刷字符和表格线。'),
        faqItem('擦除手写前怎么修复倾斜的扫描件？', '先用 Image Crop & Dewarp 拉正倾斜扫描件；只有书页或纸张本身弯曲时，才使用弯曲矫正。'),
        faqItem('支持哪些图片格式和文件大小？', '常见 JPG、PNG、WebP 文档图片都适合处理；建议使用清晰原图，避免过度压缩。'),
        faqItem('手写内容覆盖印刷文字时效果如何？', 'AI 会尝试补全背景和文字边缘，但覆盖太重时可能影响印刷内容，正式文件要人工复核。'),
        faqItem('可以去除学生试卷上的手写答案吗？', '可以，适合去除试卷上的学生答案、练习题答案、错题批注和红笔批改痕迹。'),
        faqItem('能否保留印刷试题并还原空白试卷？', '可以尝试保留印刷试题并擦除手写答案；题干和选项附近建议小范围多次处理。'),
        faqItem('教师可以用它清理和重新打印试卷吗？', '可以，教师可用它清理已答试卷、去除批注，再打印给学生复习或重新练习。'),
        faqItem('可以擦除练习册和作业中的手写答案吗？', '可以，练习册页面弯曲时先矫正，作业和表格区域建议分块擦。'),
        faqItem('支持擦除铅笔字、圆珠笔字和红笔批注吗？', '支持尝试铅笔、圆珠笔、红笔、蓝笔和黑色手写字；低清照片效果会下降。'),
        faqItem('学生可以用它还原错题试卷重新练习吗？', '可以，把错题答案和批注擦掉后重新打印或归档，适合复习和二次作答。'),
        faqItem('能擦掉红笔批注吗？', '可以，红笔、蓝笔、铅笔和黑色手写字都可尝试。'),
        faqItem('会删掉印刷文字吗？', '涂抹准确时 AI 会尽量保留印刷内容。'),
        faqItem('适合表格照片吗？', '适合，建议表格线附近小范围多次处理。'),
        faqItem('PDF 扫描件可以吗？', '可以上传扫描件导出的图片，进手写擦除页处理。'),
        faqItem('用手写擦除安全吗？', '按平台规则上传处理；正式合同建议人工复核印刷条款。'),
        faqItem('先矫正还是先擦手写？', '建议先 Image Crop & Dewarp 矫正透视。'),
        faqItem('免费吗？', 'Miral 按积分算，可先试小区域看效果。'),
        faqItem('试卷去答案留空白卷行吗？', '行，笔迹清晰时成功率高，擦除后可打印。'),
        faqItem('铅笔字能擦吗？', '可以，涂抹略大于笔迹；模糊照片效果会打折扣。'),
        faqItem('表格内手写数字怎么擦？', '分段擦、保护表格线，比一次涂整行稳。'),
        faqItem('手写擦除后打印会留痕迹吗？', '笔迹清晰、涂抹准确时痕迹很淡；建议先小区域试效果。'),
        faqItem('擦除后能直接做 AI 海报吗？', '可以。干净扫描件可进 Seedream 或 FLUX 做视觉底图，促销标题再用 GPT Image 叠加。'),
        faqItem('下一步可以去水印吗？', '可以。Handwriting Eraser 之后若还有角落标志，继续用 AI Watermark Remover 小范围处理。'),
        faqItem('扫描件太模糊还能擦吗？', '可以试，但成功率会下降；建议重拍或先 Image Crop & Dewarp 矫正再擦。')
      ])
    ],
    related: ['image-crop-dewarp-online', 'ai-watermark-remover-online', 'qwen-image-generator-review']
  },
  {
    slug: 'image-crop-dewarp-online',
    category: 'how-to-guides',
    layout: 'how-to',
    coverImage: 'doc-crop-cover',
    heroImage: 'doc-crop-cover',
    title: 'AI 文档切边矫正：裁剪拉直、去阴影与透视修复',
    excerpt: '分步骤说明 AI 文档切边矫正如何处理手机拍照文档、倾斜扫描件、弯曲书页、合同票据和试卷图片，并配合手写擦除、去水印继续清理。',
    metaTitle: 'AI 文档切边矫正：在线裁剪拉直和透视修复 | Miral',
    metaDescription: 'Miral AI 文档切边矫正教程：在线自动裁剪文档图片、识别文档边缘、矫正倾斜和透视、修复弯曲书页，并增强扫描件文字。',
    updatedAt: '2026-07-14',
    target: { label: '打开图片裁剪矫正', path: '/tools/doc-crop-enhance' },
    keywords: ['AI 文档切边矫正', '免费在线文档矫正', '在线自动裁剪文档图片', '自动识别文档边缘', '矫正倾斜文档照片', '文档透视矫正'],
    creatingSteps: [
      { title: '上传倾斜或弯曲的照片', text: 'JPG、PNG、WebP 文档图片都可以，合同、收据、书页、白板和试卷拍照都适用。' },
      { title: '让 AI 识别边缘并矫正', text: '自动识别文档边缘，裁剪多余背景，拉正倾斜、透视和弯曲页面。' },
      { title: '选择增强效果', text: '按需要做去阴影、文字锐化、增亮、灰度增强或黑白扫描效果。' },
      { title: '进入下一步处理', text: '需要时用手写擦除或去水印继续清理。' }
    ],
    pros: [
      'AI 文档切边矫正、自动裁剪、透视矫正一步完成',
      '适合扫描件、合同、票据、试卷、书页、白板拍照',
      '可覆盖去阴影、文字锐化、增亮、灰度和黑白扫描效果',
      '矫正后 OCR、归档、擦手写效果都更好',
      '和去水印、手写擦除组成文档工具链'
    ],
    cons: [
      '极模糊或强反光照片识别边缘可能不准',
      '复杂背景非文档类照片不一定适用',
      '弯曲严重书页可能需要多次尝试',
      '证件类图片注意隐私合规'
    ],
    sections: [
      makeSection('tldr', '快速结论', [
        table(['项目', '我的看法'], [
          ['最适合', '手机拍照文档、倾斜扫描件、透视变形、弯曲书页、合同票据和试卷照片'],
          ['不太适合', '非文档类艺术照片、极低清模糊图'],
          ['核心能力', '自动识别文档边缘、在线自动裁剪文档图片、矫正倾斜和透视'],
          ['推荐顺序', '先矫正 → 再擦手写/去水印'],
          ['我的建议', '矫正后的图再 OCR 或归档，成功率更高']
        ], 'overview'),
        p('文档处理我习惯从 AI 文档切边矫正开始——手机拍歪了先拉正，自动裁剪掉桌面和黑边，再做去阴影、文字锐化或黑白扫描效果，后面擦手写、去水印都更省事。')
      ]),
      makeSection('what-it-does', '裁剪矫正能解决什么', [
        p('图片裁剪矫正用于处理倾斜文档、透视变形、弯曲书页、票据照片、白板照片、证件图片和扫描边框。它会先自动识别文档边缘，再裁剪多余背景，把「拍歪了」的文档变成平整、对齐、易读的图片。'),
        p('常见场景：手机拍合同、拍书页、拍收据、拍课堂白板、拍试卷或票据——先矫正再清理，比直接擦除手写字或去水印效果更好。如果你在找免费在线文档矫正，可以先用一张样图试流程，再决定是否继续处理正式文件。'),
        p('拍文档时尽量垂直角度、光线均匀、拍全四角，AI 识别边缘会更准。强反光或极模糊照片识别可能不准，必要时重拍比反复矫正省事。JPG、PNG、WebP 这类常见文档图片都适合先做切边和增强。')
      ]),
      makeSection('how-to-use', '我实际怎么用的', [
        p('试了倾斜 A4 扫描、弯曲书页、收据透视三类。合同那张手机斜着拍的，矫正后表格线和文字边缘明显更直，再用手写擦除时 AI 补全也更自然。书页弯曲那次分两次——先大致拉正，再微调。'),
        p('拍文档时尽量垂直角度、光线均匀，AI 识别边缘会更准。矫正后检查文字和表格线是否水平，不对可以换角度重拍；阴影重的扫描件先做去阴影，文字发虚的扫描件再开锐化。'),
        p('白板 OCR 前我会先矫正：透视校正后文字更易读，再导出做课件或会议记录。票据拍照矫正后自动裁剪黑边，适合 OCR 或归档。'),
        gallery([
          'doc-example-crop-before', 'doc-example-crop-after',
          'doc-example-dewarp-before', 'doc-example-dewarp-after',
          'doc-example-deshadow-before', 'doc-example-deshadow-after',
          'doc-example-sharpen-before', 'doc-example-sharpen-after'
        ], '每行左图为处理前、右图为处理后：自动裁剪、弯曲书页矫正、去阴影和文字锐化。', 2, 'contain', 'portrait'),
        stepsBlock()
      ]),
      makeSection('enhance-modes', '增强模式怎么选', [
        table(['需求', '适合模式', '适用文档'], [
          ['扫描文档去阴影', '去阴影', '手机拍照合同、票据、书页'],
          ['扫描件文字锐化', '锐化文字', '试卷、合同、表格、说明书'],
          ['文档图片增亮', '增亮', '低光拍摄、灰暗收据、阴影照片'],
          ['文档转黑白扫描效果', '黑白扫描', '打印前试卷、合同复印件、归档文件'],
          ['文档灰度增强', '灰度增强', '票据、档案、需要保留层次的扫描件'],
          ['手机拍照转扫描件', '切边矫正 + 黑白/灰度', '手机拍的 A4、收据、课堂资料']
        ], 'overview'),
        p('合同和票据扫描优化时，我通常先自动裁剪文档边缘，再看光线：阴影重就去阴影，文字浅就锐化，准备打印或归档再转黑白扫描效果。试卷和表格不要一上来拉太高对比，先保住线条和原始内容。')
      ]),
      makeSection('doc-scenarios', '各类文档矫正场景', [
        table(['场景', '矫正价值', '后续建议'], [
          ['倾斜 A4 扫描和合同', '拉直文字和表格线', '再 Handwriting Eraser 擦批注'],
          ['弯曲文档和书页', '减少透视变形', '分段矫正严重弯曲页'],
          ['票据和收据拍照', '自动裁剪边缘', 'OCR 或归档'],
          ['试卷和作业拍照', '转成接近扫描件的效果', '再擦手写答案或打印'],
          ['白板照片', '透视矫正后更易读', '可再 OCR 或做课件'],
          ['扫描边框和黑边', '自动裁剪干净', '再去水印或擦手写'],
          ['证件类拍照', '对齐边框', '注意隐私保护']
        ], 'overview'),
        p('倾斜 A4、合同和票据拉直后，Handwriting Eraser 和 OCR 成功率都更高。弯曲书页严重时分两次矫正。证件类图片注意隐私，处理完及时删除。')
      ]),
      makeSection('pros-cons', '优缺点', [
        prosConsBlock()
      ]),
      makeSection('best-practices', '使用技巧', [
        bullets([
          '拍文档时尽量垂直角度，减少极端透视。',
          '书页弯曲严重时可分两次：先大致拉正，再微调。',
          '矫正后再擦手写，表格线不易歪。',
          'JPG、PNG、WebP 文档增强都建议先检查四角是否拍全。',
          '商业封面需求可接 GPT Image 或 Seedream。',
          '低光或阴影重的文档，尽量换光线均匀的环境重拍。',
          '多页 PDF 拍照逐页矫正，比一次跨页拍摄失败率低。'
        ]),
        tip('工具链顺序', 'Image Crop & Dewarp → Handwriting Eraser → AI 去水印 → OCR 或 AI 生图封面。')
      ]),
      makeSection('workflow', '文档处理完整流程', [
        table(['步骤', '工具', '说明'], [
          ['1 矫正', 'Image Crop & Dewarp', '拉正、裁剪黑边'],
          ['2 擦手写', 'Handwriting Eraser', '涂抹略大于笔迹'],
          ['3 去水印', 'AI Watermark Remover', '可选，清理标志'],
          ['4 后续', 'OCR、归档、AI 生图', '按需选择']
        ], 'overview'),
        links('相关工具', [
          { label: 'Handwriting Eraser', path: '/tools/handwritten-erase' },
          { label: 'AI Watermark Remover', path: '/tools/watermark-remover' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何自动裁剪并拉正扫描文档？', '上传四角完整、画面清晰的 JPG、PNG 或 WebP，裁掉桌面背景后拉正倾斜文字行。'),
        faqItem('可以在线拉正文档照片吗？', '可以。普通倾斜用拉正，斜拍用透视校正；纸张本身弯曲再用弯曲矫正。'),
        faqItem('是否能在浏览器里矫正弯曲书页？', '可以。书脊弯曲或纸张卷曲时使用弯曲矫正，这和单纯拉正不是同一步。'),
        faqItem('OCR 前修复文档透视应该用什么工具？', '先用 Image Crop & Dewarp；页面仍有笔迹或印章时再接手写擦除或去水印。'),
        faqItem('自动裁剪时页面四角被切掉怎么修复？', '重拍保证四角完整、减少反光，然后再裁剪，再做 OCR 或手写清理。'),
        faqItem('文档照片的透视变形怎么修复？', '拍全四角后运行透视校正；如果反光或阴影遮住边缘，建议换到光线均匀的位置重拍。'),
        faqItem('弯曲的书页怎么修复？', '书脊附近弯曲或纸张卷曲时使用弯曲矫正；这和单纯拉正倾斜扫描件是两种不同处理。'),
        faqItem('能否把手机拍摄的文档变成扫描效果？', '可以，先自动裁剪文档图片并拉正，再选择黑白扫描、灰度增强、增亮或文字锐化。'),
        faqItem('支持哪些图片格式和文件大小？', '常见 JPG、PNG、WebP 文档图片都适合处理；正式上传前建议用清晰原图，避免过度压缩。'),
        faqItem('处理会不会改变文档原始内容？', '工具会裁剪、拉正和增强图像显示，不会主动改写文档文字；正式合同、票据仍建议人工复核。'),
        faqItem('可以修复弯曲书页吗？', '可以尝试处理书页弯曲和透视变形。'),
        faqItem('适合票据和收据吗？', '适合，能裁剪边缘并拉正图片。'),
        faqItem('处理后还能去手写字吗？', '可以，建议先矫正再 Handwriting Eraser。'),
        faqItem('护照或 ID 照片可以用吗？', 'Miral 可处理这类拍照，请注意隐私保护。'),
        faqItem('文档工具链怎么用？', 'Image Crop & Dewarp → Handwriting Eraser → AI Watermark Remover → OCR，都在同一平台完成。'),
        faqItem('白板照片能矫正吗？', '可以，透视矫正后文字更易读。'),
        faqItem('免费吗？', 'Miral 按积分算，可先试一张看效果。'),
        faqItem('手机拍合同怎么拉正？', '尽量垂直拍全四角；上传后 AI 自动裁剪黑边并拉直透视。'),
        faqItem('矫正失败怎么办？', '换光线均匀的环境重拍，或分两次矫正弯曲书页。'),
        faqItem('书页弯曲很严重怎么办？', '分两次：先大致拉正，满意后再微调；比一次强行拉直更自然。'),
        faqItem('收据 OCR 前要先矫正吗？', '建议先 Image Crop & Dewarp 拉正，文字行更齐，OCR 识别率明显更高。'),
        faqItem('矫正后图片尺寸会变吗？', '会裁剪多余黑边并拉正透视，比例可能略有变化；归档前可检查。'),
        faqItem('矫正后还能做 AI 封面吗？', '可以。干净文档图可进 Seedream 或 FLUX 做视觉，标题排版再用 GPT Image。'),
      ])
    ],
    related: ['handwriting-eraser-online', 'ai-watermark-remover-online', 'gpt-image-generator-guide']
  }
])

var HUB_ARTICLE_PINNED_SLUGS = [
  'ai-portrait-background-remover',
  'ai-background-changer-online',
  'ai-background-remover-online',
  'ecommerce-product-background-removal'
]

HUB_ARTICLES.sort(function (a, b) {
  var aIndex = HUB_ARTICLE_PINNED_SLUGS.indexOf(a.slug)
  var bIndex = HUB_ARTICLE_PINNED_SLUGS.indexOf(b.slug)
  if (aIndex < 0) aIndex = HUB_ARTICLE_PINNED_SLUGS.length
  if (bIndex < 0) bIndex = HUB_ARTICLE_PINNED_SLUGS.length
  return aIndex - bIndex
})

var HUB_SEARCH_TERM_BANK = {
  'seedream-ai-image-generator-review': [
    'Seedream 5 在线生图', 'Seedream 提示词怎么写', 'Seedream 电商主图', 'Seedream 产品图教程',
    'AI 商品图生成', 'AI Instagram 产品帖', 'Seedream vs FLUX', 'Seedream vs Midjourney',
    'AI 生活方式海报', 'Seedream 5 和 4 区别', 'AI 生图哪个好用',
    '亚马逊主图 AI 生成', '亚马逊产品图怎么做', 'Shopify 场景图', 'TikTok Shop 商品图',
    'AI 白底图生成器', 'AI 详情页配图', 'Seedream 在线怎么用', 'AI 电商主图生成器',
    'AI 品牌海报', 'AI 职业头像生成', 'Seedream AI 图片生成器', '不用 Discord 的 AI 生图',
    'AI 产品摄影提示词', 'AI 独立站横幅图', 'Seedream 产品图提示词',
    'Seedream 5 测评', 'Seedream 怎么做产品图', 'Seedream 免费吗', 'Seedream 提示词',
    'AI 跨境电商主图', 'Seedream 和 Dreamina 哪个好', 'Seedream 海报怎么写', 'AI 场景图生成',
    'Seedream 亚马逊白底图', 'Seedream 亚马逊 A+', 'Seedream 适合电商吗', 'AI 产品图哪个模型好',
    'Seedream 5 在线', 'Seedream 出图速度', 'Seedream 和 FLUX 怎么选', 'AI 主图生成器推荐',
    'Seedream 提示词示例', 'Seedream 护肤品主图', 'Seedream 3C 产品图', 'AI 生活方式图怎么出',
    'Seedream 和 SD 哪个好', 'Seedream 做横幅图', 'Seedream 积分怎么算', 'Seedream 新手教程',
    'Seedream 护肤品图', 'Seedream 家居场景图', 'Seedream 食品摄影', 'Seedream 宠物产品图',
    'Seedream 多图对比技巧', 'Seedream 换背景', 'Seedream 4K 出图', 'Seedream 和 Qwen Image',
    'AI 主图 A/B 测试', 'Seedream 批量出图', 'Seedream 跨境电商横幅图',
    'Seedream eBay 商品图', 'Seedream Etsy 商品页图', 'Seedream Walmart Marketplace 商品图',
    'Seedream Google Shopping 商品广告图', 'Seedream WooCommerce 商品图',
    'Seedream BigCommerce 商品图', 'Seedream Squarespace 横幅图'
  ],
  'flux-ai-image-generator-review': [
    'FLUX.2 在线生图', 'FLUX 提示词示例', 'FLUX 产品摄影', 'FLUX 广告图',
    'Flux Schnell 和 FLUX.2 区别', 'FLUX vs Seedream', 'AI 商业摄影生成',
    'Flux Pro Ultra 测评', 'FLUX 电商主图', '真实感 AI 产品图',
    'FLUX 提示词示例', 'FLUX 产品图怎么写', 'AI 商业摄影提示词', 'AI 广告图提示词',
    'FLUX 在线怎么用', 'AI 广告图生成器', '真实感 AI 图片生成器', 'FLUX 珠宝产品图',
    'FLUX 手表微距摄影', 'FLUX 咖啡生活方式图', 'FLUX 汽车广告风', 'Flux Schnell 试构图',
    'FLUX 测评', 'FLUX 怎么做产品图', 'FLUX 免费吗', 'FLUX 提示词',
    'FLUX 和 Midjourney 怎么选', 'FLUX 护肤品摄影', 'FLUX 3C 产品图', 'FLUX 美食摄影',
    'FLUX 在线免费', 'FLUX 出图速度', 'FLUX 新手教程', 'FLUX 广告大片',
    'FLUX 金属反光怎么写', 'FLUX 生活方式图', 'FLUX 和 SD 哪个好', 'AI 产品摄影哪个模型',
    'Flux Pro 1.1 Ultra 值得吗', 'FLUX Schnell 怎么用', 'FLUX 亚马逊产品图', 'FLUX Shopify 图',
    'FLUX 硬光产品图', 'FLUX 微距怎么写', 'FLUX 边缘光技巧', 'FLUX 交稿工作流',
    'FLUX AI 图片生成器', 'FLUX 不用安装', 'FLUX 和 Seedream 对比', 'FLUX 商业摄影教程',
    'FLUX 家居产品图', 'FLUX 宠物广告图', 'FLUX 户外产品摄影', 'FLUX 夜景产品图',
    'FLUX 双版本对比', 'FLUX 和 GPT Image 配合', 'FLUX 批量试构图', 'FLUX 4K 产品图',
    'FLUX 品牌大片', 'FLUX 视频封面静帧', 'FLUX 产品场景合成',
    'FLUX Walmart 商品图', 'FLUX Target 商品广告图', 'FLUX Wayfair 家居产品图',
    'FLUX Google Shopping 商品广告图', 'FLUX 户外用品商品图', 'FLUX 家电产品摄影'
  ],
  'midjourney-alternative-online': [
    'Midjourney alternative online', 'Midjourney without Discord', 'Midjourney online generator', 'Midjourney free alternative',
    'AI art generator like Midjourney', 'Midjourney 提示词', 'Midjourney 提示词示例', 'best Midjourney alternative',
    'Dreamina alternative', 'Leonardo alternative', 'Stable Diffusion alternative', 'AI 插画生成器', 'AI 艺术图生成器',
    'AI poster generator online', 'AI 概念艺术生成器', 'AI game art generator', 'AI 奇幻插画提示词',
    '不用 Discord 的 AI 图片生成器', '在线 Midjourney 替代', 'AI 海报设计工具', 'AI 社媒图片生成', 'AI 图像生成平台',
    'Dreamina 和 Midjourney 哪个好', 'Leonardo alternative online', 'AI 电商主图生成器', 'Midjourney 替代方案哪个最好',
    'Midjourney 在线怎么用', 'Midjourney 不用 Discord 生图', 'Midjourney 替代哪个好', 'AI 概念艺术生成',
    'Midjourney 和 SD 怎么选', 'Midjourney 商业图替代', 'AI 奇幻插画提示词', 'Midjourney 网页版',
    'Midjourney 免费替代', 'Dreamina 替代方案', 'Leonardo 替代在线', 'AI 游戏原画生成器',
    'Midjourney 提示词示例', 'AI 艺术图在线', 'Midjourney 和 FLUX 配合', 'AI 海报不用 Discord',
    'Midjourney 替代 Seedream', 'AI 插画在线', 'Midjourney 测评', 'Midjourney 新手入门',
    'AI 风格探索工具', 'Midjourney 和 GPT Image', 'AI 图像生成对比', 'Midjourney 积分',
    'Midjourney 杂志风插画', 'Midjourney 写实人像', 'Midjourney 品牌视觉探索', 'Midjourney 包装设计风格',
    'AI 包装效果图', 'Midjourney 室内设计', 'Midjourney 时尚插画', 'AI 图书封面生成',
    'Midjourney 同提示词多风格', 'Midjourney 和 Canva 对比', 'AI 创意灵感生成'
  ],
  'gpt-image-generator-guide': [
    'GPT Image generator online', 'GPT Image 1.5 generator', 'GPT-Image-1 提示词', 'OpenAI image generator online',
    'GPT Image 提示词', 'AI text poster generator', 'AI flyer generator with text', 'AI 产品样机图生成器',
    'AI editable image generator', 'AI banner with text', 'AI typography poster', 'AI marketing poster generator',
    'AI product explanation image', 'AI 界面样机图', 'GPT Image vs Midjourney', 'GPT Image vs Seedream',
    'AI 文字海报生成器', 'AI 电商卖点图', 'AI 产品说明图', 'AI 社媒封面生成', '带文字 AI 图片生成', 'OpenAI 图片生成',
    'AI 海报提示词', 'AI 文字排版怎么生成', 'AI 营销海报生成器',
    'GPT Image 生成器', 'GPT Image 怎么用', 'GPT Image 英文标题', 'GPT Image 促销海报',
    'GPT Image 和 Qwen 怎么选', 'AI 活动海报生成', 'GPT Image 免费吗', 'GPT Image 卖点图教程',
    'AI 文字海报提示词', 'GPT Image 1.5 测评', 'OpenAI 生图在线', 'AI 说明型排版',
    'GPT Image 电商图', 'AI 传单生成', 'GPT Image 新手', '带标题 AI 海报',
    'GPT Image 和 FLUX 配合', 'AI 营销图生成', 'GPT Image 比例怎么写', 'AI 产品样机图',
    'GPT Image 文字可控吗', 'AI 海报设计提示词', 'GPT Image 在线免费', 'GPT Image 工作流',
    'GPT Image 菜单设计', 'GPT Image 价格标签图', 'GPT Image 招聘海报', 'GPT Image 课程宣传图',
    'GPT Image 多语言海报', 'GPT Image 和 Canva 对比', 'GPT Image 品牌字体海报', 'AI 说明图生成',
    'GPT Image 横版横幅图', 'GPT Image 竖版海报', 'GPT Image 节日促销图',
    'GPT Image Shopify 横幅图', 'GPT Image WooCommerce 卖点图',
    'GPT Image Squarespace 首屏图', 'GPT Image Google Shopping 促销图',
    'GPT Image BigCommerce 商品卖点图'
  ],
  'qwen-image-generator-review': [
    'Qwen Image generator online', 'Qwen Image 2.0 Pro', 'Qwen Image 提示词', 'Qwen Image 提示词', 'Qwen Image 在线生成',
    'AI 图片生成器', 'AI 海报生成器', 'AI 文字图片', 'Qwen 产品图提示词', 'Qwen 海报提示词',
    'AI 高分辨率图片生成', 'AI Instagram 封面生成', 'AI 邮件通讯头图生成', 'AI 营销海报',
    'Qwen vs GPT Image', 'Qwen vs Seedream', 'Qwen alternative online', 'AI course cover generator',
    'AI 电商详情页图片', '产品海报生成', 'AI 品牌海报设计', '高分辨率 AI 生图',
    'Qwen Image AI 生图', 'Qwen 海报怎么生成', 'Qwen Image 在线怎么用',
    'Qwen Image 生成器', 'Qwen Image 测评', 'Qwen Image 免费吗', 'Qwen Image 提示词',
    'Qwen 和 GPT Image 区别', 'Qwen 营销海报教程', 'Qwen 产品图提示词', 'Qwen 2K 出图',
    'Qwen Image 和 FLUX 怎么选', 'AI 课程封面生成', 'Qwen 电商海报', 'Qwen Image 在线生图',
    'Qwen Image 新手', 'Qwen 高分辨率海报', 'Qwen 品牌视觉', 'AI 详情页配图 Qwen',
    'Qwen Image 工作流', 'Qwen 和 Midjourney', 'Qwen Image 提示词', 'Qwen 社媒封面',
    'Qwen Image 积分', 'AI 海报 2.0 Pro', 'Qwen 产品展示图', 'Qwen Image 生图教程',
    'Qwen 节日营销海报', 'Qwen 黑五海报', 'Qwen 网络星期一海报', 'Qwen 新品发布海报',
    'Qwen 直播预告封面', 'Qwen 品牌联名海报', 'Qwen 横版横幅图', 'Qwen 竖版主视觉',
    'Qwen 和 Dreamina 对比', 'Qwen 多尺寸导出', 'Qwen 海报 A/B 测试',
    'Qwen Shopify 新品发布图', 'Qwen Squarespace 品牌横幅图',
    'Qwen Etsy 商品页封面', 'Qwen WooCommerce 品牌海报',
    'Qwen BigCommerce 活动主视觉'
  ],
  'z-image-ai-generator-review': [
    'Z Image AI generator', 'Z Image Turbo online', 'Z Image 提示词示例', 'Z Image 提示词', 'fast AI image generator',
    'AI ad image generator', 'AI social media image generator', 'AI creative image generator', 'AI poster draft generator',
    'AI Facebook ad image', 'AI Instagram post generator', 'AI TikTok product image', 'AI YouTube thumbnail draft',
    'AI 横幅图在线生成器', 'AI 电商横幅图生成', 'AI 活动海报生成', 'AI 促销图生成',
    'Z Image vs FLUX', 'Z Image vs Seedream', '快速 AI 出图工具', 'AI 广告创意草图', 'AI 社媒封面',
    'AI 促销海报怎么生成', 'Z Image Turbo 在线', 'AI ad image generator',
    'Z Image AI 生成器', '快速 AI 生图', 'AI 横幅图生成', 'Z Image 测评', 'Z Image 免费吗',
    'Z Image 和 Schnell 怎么选', 'Z Image 广告草图', 'Z Image 促销横幅图', 'Z Image 新手教程',
    'Z Image 出图速度', 'Z Image 电商图', 'Z Image 和 GPT Image', 'AI 创意草图工具',
    'Z Image Turbo 提示词', 'Z Image 工作流', 'AI 社媒广告图', 'Z Image 试方向',
    'Z Image 终稿换 FLUX', 'AI 快速出图推荐', 'Z Image 提示词', 'Z Image 活动图',
    'Z Image 和 Seedream 配合', 'AI YouTube thumbnail 草图', 'Z Image 积分', 'Z Image 在线怎么用',
    'Z Image 黑五促销图', 'Z Image 新品预告', 'Z Image 直播封面草图', 'Z Image 限时折扣横幅图',
    'Z Image 品牌联名草图', 'Z Image 多尺寸试稿', 'Z Image 和 Midjourney 对比', 'Z Image 低成本试错',
    'Z Image 连出多版技巧', 'Z Image 配色试稿', 'Z Image 节日活动图',
    'Z Image Google Shopping 广告草图', 'Z Image eBay 促销图',
    'Z Image Walmart 活动横幅', 'Z Image Meta 广告图', 'Z Image Target 促销草图'
  ],
  'stable-diffusion-online-generator': [
    'Stable Diffusion online', 'Stable Diffusion 3.5 online', 'SD 3.5 generator', 'Stable Diffusion without installation',
    'online Stable Diffusion generator', 'Stable Diffusion 提示词示例', 'Stable Diffusion 提示词',
    'Stable Diffusion alternative online', 'AI illustration generator', 'AI anime image generator', 'AI 概念艺术生成器',
    'AI 角色设计生成器', 'AI game asset generator', '不用本地部署 Stable Diffusion', '在线 SD 生图',
    'Stable Diffusion web generator', 'Stable Diffusion vs Midjourney', 'Stable Diffusion vs FLUX',
    '开源 AI 图片生成器', 'AI 插画提示词', 'AI 角色设定图', 'AI 风格化头像',
    'SD 插画提示词', 'AI 游戏原画', 'Stable Diffusion 不用安装', 'ComfyUI 替代在线',
    '不用本地部署 SD', 'AI 插画生成', '开源 AI 生图', 'SD 3.5 在线怎么用',
    'SD 和 Midjourney 哪个好', 'SD 新手教程', 'SD 免费吗', 'SD 提示词',
    'SD 角色设计提示词', 'SD 动漫风怎么写', 'SD 概念艺术教程', 'SD 在线免费',
    'SD 和 FLUX 怎么选', 'SD 插画在线', 'Stable Diffusion 测评', 'SD 不用显卡',
    'SD 游戏资产生成', 'SD 风格控制', 'SD 和 Seedream 配合', 'AI 二次元生成',
    'SD 3.5 测评', 'Stable Diffusion 网页版', 'SD 提示词示例', 'SD 工作流在线',
    'SD 杂志风插画', 'SD 科幻场景', 'SD 像素风', 'SD 水彩插画',
    'SD 角色三视图', 'SD 表情包生成', 'SD 壁纸生成', 'SD 和 MJ 同提示词对比',
    'SD 批量试风格', 'SD 线稿上色', 'SD 绘本插画'
  ],
  'ai-watermark-remover-online': [
    'AI Watermark Remover', 'AI watermark remover online', 'remove watermark from image', 'remove watermark from photo online',
    'remove logo from image', 'AI remove text from image', 'online watermark eraser', 'photo watermark remover',
    'remove transparent watermark', 'remove repeated watermark', 'remove product image watermark', 'remove poster watermark',
    'remove TikTok watermark from image', '图片去水印在线', 'AI 去水印工具', '图片去标志', '去除照片文字水印',
    '去除商品图水印', '去除海报水印', '去除图片标记', 'AI 图片清理工具', '电商图片去水印',
    '去水印不留痕', 'remove text from image', 'AI 图片清理工具链',
    '在线去水印', '图片去文字水印', '电商图片清理', 'AI 去水印怎么用',
    '去水印免费吗', '去标志工具', '去水印会影响画质吗', '商品图去水印教程',
    '社媒截图去水印', '透明水印怎么去除', '重复水印处理', '海报水印清理',
    '去水印和 PS 对比', '去水印后商用', 'AI 清理图片标记', '去水印新手',
    '图片去标记在线', '水印擦除工具', '去水印步骤', 'Miral 去水印',
    '去水印安全吗', '批量去水印', '角落标志去除', 'AI 补全背景',
    '去除视频截图水印', '去除 PDF 转图片水印', '去除 ID photo 水印', '去除样机图水印',
    '去除 stock 图标记', '去除平台下载水印', '去水印后调色调', '去水印进 FLUX 流程',
    '小图去水印技巧', '大面积水印处理', '去水印失败怎么办',
    'Shopify 商品图去水印', 'Shopify 供应商图去标志', 'eBay 图片清理',
    'Etsy 商品图清理', 'Walmart Marketplace 图片去标志',
    'Google Shopping 商品图清理', '跨境电商商品图去水印'
  ],
  'ai-background-remover-online': [
    '免费 AI 背景移除', '免费在线抠图', 'AI 背景移除', 'AI 去背景', '图片去背景', '在线抠图', '自动抠图', '一键抠图',
    '透明背景图片', 'PNG 透明背景', '透明 PNG 制作', '背景橡皮擦', '照片背景移除',
    'JPG 去背景', 'PNG 去背景', 'WebP 去背景', '人像背景移除', '人物自动抠图',
    '发丝抠图', '头像去背景', 'Logo 背景移除', '签名去背景', '证件照去背景',
    '宠物图片去背景', '商品图片去背景', '如何在线去除图片背景', '如何把图片背景变透明',
    '如何导出透明 PNG', 'JPG 怎么转透明背景 PNG', '手机照片怎么去背景',
    '不用 Photoshop 怎么抠图', '图片去背景保留原尺寸', '图片去背景会降低画质吗',
    'AI 抠图边缘发白怎么办', '去背景后有白边怎么办', '发丝边缘怎么处理',
    '透明物体去背景', '玻璃产品去背景', '复杂背景自动抠图', '白色主体去白色背景',
    '黑色主体去深色背景', '照片换背景前怎么抠图', '社媒头像透明背景',
    '海报素材去背景', '电商素材透明底', '图片背景透明在线工具', '免费在线自动抠图',
    'JPG PNG WebP 背景移除', '15MB 图片去背景', 'Miral 背景移除'
  ],
  'ecommerce-product-background-removal': [
    '免费商品图去背景', '免费电商产品抠图', '商品图去背景', '电商产品抠图', '商品白底图', '电商商品透明背景', '产品图背景移除',
    'Amazon 产品白底图', 'Amazon 商品主图去背景', 'Shopify 商品图透明背景',
    'Shopify 产品图片去背景', 'eBay 商品图去背景', 'Etsy 商品背景移除',
    'Google Shopping 商品图背景', '跨境电商主图', '跨境电商商品抠图',
    '商品透明 PNG', '产品透明 PNG', '白底商品图制作', 'AI 商品抠图', '自动产品抠图',
    '服装商品去背景', '鞋子商品图抠图', '首饰图片去背景', '珠宝透明背景',
    '玻璃商品去背景', '透明包装去背景', '毛绒商品抠图', '家具商品图去背景',
    '美妆产品白底图', '电子产品白底图', '如何制作 Amazon 白底图',
    '如何移除商品图片背景', 'Shopify 商品图必须白底吗', '透明背景和白底的区别',
    '商品图背景换成白色', '产品图统一背景', '商品主图背景处理', '电商详情页透明素材',
    '独立站产品图去背景', '商品图去背景不损失边缘', '产品抠图白边怎么办',
    '商品图去背景后换场景', '商品抠图后生成场景图', 'Amazon Shopify 商品图处理',
    'eBay Etsy 产品图片优化', '跨境电商图片处理工具', '商品目录图片去背景',
    '产品摄影背景移除', 'AI 电商白底图工具'
  ],
  'ai-portrait-background-remover': [
    '免费人像去背景', 'AI 人像抠图', '头像去背景', '证件照去背景', 'LinkedIn 职业照抠图',
    '简历照片去背景', '发丝抠图', '微信头像透明背景', '护照照片换背景', '蓝底证件照制作',
    '白底证件照在线', '社媒头像去背景', '人像背景移除', '职业照透明 PNG',
    '如何做人像去背景', '如何做证件照白底', '如何做蓝底证件照', '戴眼镜人像怎么抠图',
    '自拍去背景做头像', '招聘网站头像去背景', 'Instagram 头像去背景', '儿童照片去背景',
    '卷发发丝抠图', '人像抠图白边怎么办', '透明底和证件照白底区别', '人像去背景免费吗',
    '手机自拍职业照', '会议室自拍去背景', '证件照换底色', '人像透明 PNG 下载',
    'Miral 人像去背景', '头肩照背景移除', '简历附件照片处理', '签证照片背景准备',
    '如何做 LinkedIn 职业照抠图', '可以在线抠戴眼镜的人像吗', '用什么工具做发丝抠图',
    '用什么工具准备护照签证照背景', '如何修复人像抠图后的白边', '灰底职业照怎么做',
    '西装照去背景', '小红书头像去背景', '可以免费去除微信头像背景吗', '透明底和白底证件照有什么区别'
  ],
  'ai-background-changer-online': [
    '免费 AI 换背景', 'AI 换背景在线', '照片替换背景', '抠图后换场景', '人像换背景',
    '生活方式场景图', '社媒封面换背景', '透明 PNG 换背景', 'AI 场景替换', '活动海报换背景',
    '办公室背景替换', '咖啡馆人像场景', '品牌色背景合成', '去背景后生成场景',
    '如何在线换照片背景', '如何把自拍换成咖啡馆背景', '如何做生活方式封面',
    '换背景看起来假怎么办', '抠图后换办公室背景', 'AI 生成背景放人物后面',
    '纯色品牌墙换背景', '户外日光换背景', '海报标题区换背景', '透明主体合成新场景',
    '换背景和去背景区别', '换背景和电商白底区别', 'Seedream 换背景场景',
    'FLUX.2 生活方式场景', '视频封面换背景', 'Miral AI 换背景',
    '如何在抠图后更换社媒封面背景', '可以把自拍换成咖啡馆背景吗',
    '用什么工具做活动海报换背景', '用什么工具做社媒封面换背景',
    '如何解决户外日光换背景光位冲突', '课程封面换背景', '演讲预告换背景',
    'Instagram 封面换背景', '可以让 AI 生成场景放在真人后面吗', '换背景和去背景有什么区别'
  ],
  'handwriting-eraser-online': [
    'Handwriting Eraser online', 'AI handwriting remover', 'remove handwriting from image', 'remove handwritten text from scanned document',
    'erase handwriting from photo', 'AI remove pen marks', 'remove annotations from document', 'remove handwriting from PDF image',
    'remove red pen marks', 'remove notes from scanned paper', 'clean scanned document online', '手写擦除工具',
    'AI 手写文字擦除', 'AI handwritten text remover', '免费在线擦除手写文字', 'remove handwriting online for free',
    '去除文档中的手写字', 'remove handwriting from documents', '试卷手写答案擦除', 'remove handwritten answers from test papers',
    '保留印刷文字擦除手写字', 'remove handwriting while preserving printed text', '清理扫描文档手写标记', 'remove handwritten marks from scanned documents',
    '扫描件擦除手写字', 'erase handwriting on scanned docs', '合同手写内容擦除', 'remove handwriting from contracts',
    '笔记手写内容擦除', 'erase handwritten notes', 'JPG PNG WebP 手写擦除', 'remove handwriting from JPG PNG WebP',
    'AI 试卷手写答案擦除', 'AI test paper answer remover', '免费在线擦除试卷答案', 'remove test paper answers online for free',
    '试卷还原成空白试卷', 'restore a test paper to a blank copy', '去除试卷上的学生答案', 'remove student answers from test papers',
    '学生作业手写字擦除', 'remove handwriting from student homework', '清除练习册手写答案', 'remove handwritten answers from workbooks',
    '保留试题擦除手写答案', 'remove handwritten answers while preserving questions', '教师试卷答案清理工具', 'test paper answer remover for teachers',
    '学生试卷清理工具', 'test paper cleaner for students', '错题试卷还原', 'restore answered test papers for review',
    '试卷批注擦除', 'remove handwritten annotations from test papers', '擦除试卷红笔批改', 'remove red pen corrections from test papers',
    '清除试卷铅笔字', 'remove pencil writing from test papers', '清除试卷圆珠笔字迹', 'remove pen writing from test papers',
    '空白试卷生成工具', 'blank test paper generator from answered sheets', '练习题答案擦除', 'erase answers from worksheets',
    '学生复习试卷重置', 'reset test papers for student revision', '试卷扫描件手写擦除', 'remove handwriting from scanned test papers',
    '去除图片手写字', '扫描件去手写批注', '擦除试卷手写答案', '去除合同手写标注', '清理文档批注',
    '去除红笔标记', '去除笔记涂鸦', 'AI 文档清理', '图片文字擦除', '表格照片去手写',
    '扫描件去手写', 'remove pen marks from document', 'AI 文档清理流程',
    'AI 擦除手写字', '试卷去答案', '手写擦除怎么用', '手写擦除免费吗',
    'PDF 扫描件去手写', '红笔批注怎么擦', '合同手写清理', '笔记涂鸦去除',
    '手写擦除会删印刷字吗', '表格去手写教程', '文档批注清理步骤', '扫描件清理流程',
    '手写擦除和矫正顺序', 'AI 擦除笔迹', '手写痕迹去除', 'Miral 手写擦除',
    '擦除后打印', '手写擦除安全吗', '多页扫描件处理', '手写擦除新手',
    '铅笔字能擦吗', '蓝笔标记去除', '手写擦除效果', '文档数字化清理',
    '擦除荧光笔标记', '擦除签名', '擦除日期手写', '擦除页眉批注',
    '多栏文档擦手写', '横版扫描件擦除', '擦除后压缩 PDF', '擦除进 OCR 流程',
    '历史文档修复', '老旧扫描件擦除', '擦除失败重试技巧'
  ],
  'image-crop-dewarp-online': [
    'Image Crop and Dewarp online', 'document dewarp online', 'fix skewed document photo', 'straighten scanned document',
    'deskew scanned documents online', 'auto crop scanned document images', 'crop document photo online', 'auto crop receipt photo',
    'dewarp book page', 'fix curved document image',
    'document perspective correction', 'whiteboard photo correction', 'scan photo dewarp', '图片裁剪矫正',
    'AI 文档切边矫正', 'AI document crop and correction', '免费在线文档矫正', 'correct documents online for free',
    '在线自动裁剪文档图片', 'crop document images online', '自动识别文档边缘', 'automatic document edge detection',
    '矫正倾斜文档照片', 'straighten skewed document photos', '文档透视矫正', 'document perspective correction',
    '弯曲文档矫正', 'dewarp curved documents online', '扫描文档去阴影', 'remove shadows from scanned documents',
    '扫描件文字锐化', 'sharpen text in scanned documents', '文档图片增亮', 'brighten document images',
    '文档转黑白扫描效果', 'convert document photos to black and white', '文档灰度增强', 'grayscale document enhancement',
    '手机拍照转扫描件', 'turn phone photos into scanned documents', '合同和票据扫描优化', 'enhance scanned contracts and receipts',
    'JPG PNG WebP 文档增强', 'enhance JPG PNG WebP documents',
    '文档照片拉正', '扫描件自动裁剪', '拍照扫描件矫正', '书页弯曲矫正', '白板照片透视矫正',
    '证件图片裁剪', '票据照片矫正', '图片自动拉正', '文档边缘检测', 'AI 文档增强',
    '文档照片拉直在线处理', '弯曲文档图片修复工具', 'AI 文档增强工具链',
    '文档矫正怎么用', '文档矫正免费吗', '倾斜扫描件修复', '透视变形修复',
    '收据自动裁剪', '书页拉直教程', '白板 OCR 前处理', '证件照矫正',
    '文档拍照拉直', '弯曲页面修复', '扫描件边缘裁剪', '文档增强流程',
    'Miral 文档矫正', '矫正后 OCR', '矫正和擦手写顺序', '文档矫正新手',
    '票据边缘检测', '多页文档矫正', '文档透视校正', 'AI 拉正文档',
    '扫描件拉直工具', '文档照片修复', '裁剪拉正在线', '文档数字化矫正',
    'A4 文档矫正', '横版 PPT 拍照矫正', '菜单拍照拉正', '发票拍照矫正',
    '档案扫描矫正', '多页 PDF 拍照矫正', '矫正后压缩', '矫正进 OCR 流程',
    '低光文档矫正', '阴影文档修复', '矫正失败重拍建议'
  ],
  'kimi-k3-review': [
    'Kimi K3 评测', 'Kimi K3 是什么', 'Kimi K3 编程', 'Kimi K3 长文档研究',
    'Kimi K3 1M 上下文', 'Kimi K3 开放权重', 'Kimi K3 模型 ID', 'Kimi K3 PDF 分析',
    'Kimi K3 智能体', 'Kimi K3 原生视觉', 'Kimi K3 推理强度', 'Kimi K3 自部署',
    'Kimi K3 上下文丢失', 'Kimi K3 代码重构', 'Kimi K3 截图排错', 'Kimi K3 多模态分析',
    'Kimi K3 和 GPT-5.6 Sol 对比', 'Kimi K3 和 Claude Fable 5 对比',
    '如何使用 Kimi K3 编程', 'Kimi K3 怎么核对多份长报告',
    'Kimi K3 如何重构大型代码库', 'Kimi K3 上下文丢失怎么办',
    'Kimi K3 开放权重适合自部署吗', 'Kimi K3 可以构建工具调用智能体吗',
    'Kimi K3 如何结合截图排查代码错误'
  ],
  'claude-fable-5-review': [
    'Claude Fable 5 评测', 'Claude Fable 5 是什么', 'Claude Fable 5 编程',
    'Claude Fable 5 长期编码', 'Claude Fable 5 智能体', 'Claude Fable 5 文档分析',
    'Claude Fable 5 模型 ID', 'Claude Fable 5 Token 成本', 'Claude Fable 5 工具调用失败',
    'Claude Fable 5 和 Mythos 5 区别', 'Claude Fable 5 Opus 4.8 回退',
    'Claude Fable 5 安全路由', 'Claude Fable 5 阶段摘要', 'Claude Fable 5 跨文件重构',
    'Claude Fable 5 和 GPT-5.6 Sol 对比', 'Claude Fable 5 和 Kimi K3 对比',
    '如何使用 Claude Fable 5 编程', 'Claude Fable 5 可以分析复杂文档吗',
    'Claude Fable 5 如何完成跨文件代码迁移', 'Claude Fable 5 工具调用失败怎么办',
    'Claude Fable 5 如何运行长期智能体任务', '如何降低 Claude Fable 5 的 Token 成本',
    '为什么 Claude Fable 5 会回退到 Opus 4.8', 'Claude Fable 5 适合知识工作吗',
    'Claude Fable 5 和 GPT-5.6 Sol 编程怎么选'
  ],
  'gpt-5-6-sol-review': [
    'GPT-5.6 Sol 评测', 'GPT-5.6 Sol 是什么', 'GPT-5.6 Sol 编程',
    'GPT-5.6 Sol 模型 ID', 'GPT-5.6 Sol API 价格', 'GPT-5.6 Sol 1.05M 上下文',
    'GPT-5.6 Sol 128K 输出', 'GPT-5.6 Sol computer use', 'GPT-5.6 Sol 工具调用',
    'GPT-5.6 Sol 智能体', 'GPT-5.6 Sol reasoning effort', 'GPT-5.6 Sol 长上下文价格',
    'GPT-5.6 Sol 和 Terra Luna 区别', 'GPT-5.6 Sol 和 Claude Fable 5 对比',
    'GPT-5.6 Sol 和 Kimi K3 对比', 'GPT-5.6 Sol 专业研究', 'GPT-5.6 Sol Responses API',
    '如何使用 GPT-5.6 Sol 编程', 'GPT-5.6 Sol 如何迁移多服务代码',
    'GPT-5.6 Sol 可以核对多份研究报告吗', 'GPT-5.6 Sol 如何使用 computer use',
    'GPT-5.6 Sol 可以生成可编辑专业文档吗', 'GPT-5.6 Sol 超长上下文如何控制成本',
    'GPT-5.6 Sol 如何构建多工具智能体', '什么时候不应该使用 GPT-5.6 Sol'
  ]
}

var MODEL_CREATING_STEPS = [
  { title: '选择目标场景', text: '先确定图片用途：产品主图、社媒封面、广告横幅图、人物写真、插画、室内设计或文档封面。' },
  { title: '写清主体和画面结构', text: '在提示词里写主体、背景、镜头、光线、材质、构图、比例、文字内容和使用平台。' },
  { title: '生成多个方向', text: '先用宽泛提示词生成几版，再根据效果补充风格、颜色、商业用途、真实感和细节要求。' },
  { title: '跳转到 Miral 功能页精修', text: '进入对应模型页继续调整尺寸、数量、清晰度和提示词；必要时结合去水印、裁剪矫正等工具处理素材。' }
]

var TOOL_CREATING_STEPS = [
  { title: '上传需要处理的图片', text: '选择照片、商品图、扫描件、文档照片、海报或带标记的素材。' },
  { title: '标记需要处理的区域', text: '对水印、手写字、标志、倾斜边缘、透视变形或弯曲区域进行定位。' },
  { title: '让 AI 自动修复', text: 'AI 根据周围纹理和内容结构补全背景、清理痕迹、拉正文档或增强可读性。' },
  { title: '下载并进入下一步创作', text: '处理后的素材可以继续用于 GPT Image、Seedream、FLUX 等模型生成海报、产品图和社媒内容。' }
]

var MODEL_PROS = ['适合从具体创作需求直接开始试图', '提示词、替代方案和模型对比都能放在同一条创作流程里看', '可以和 Miral 的图片工具一起使用，先清理素材再生成新图', '适合产品图、海报、社媒图、广告图和创意草图等常见需求']
var MODEL_CONS = ['不同模型对文字、真实感和艺术风格的侧重点不同，需要根据场景选择', '含复杂文字的海报仍建议生成后人工检查', '商业素材需要确认图片授权和品牌合规', '同一提示词在不同模型里可能出现构图差异，需要保留对比结果']
var TOOL_PROS = ['适合处理水印、手写字、文档倾斜这类明确的问题', '打开工具、上传图片、标记区域就能开始操作', '处理后的素材可以继续拿去做 AI 海报、产品图或社媒封面', '适合文档、商品图、社媒图、海报和扫描件处理', '可以先做小图测试，再把稳定流程用于批量素材']
var TOOL_CONS = ['复杂背景或大面积遮挡可能需要多次局部处理', '低清晰度原图会影响修复质量', '涉及版权或第三方素材时仍需用户确认使用权限', '重要文档、票据和证件类图片处理后仍需要人工复核']

function uniq(items) {
  var seen = {}
  var out = []
  for (var i = 0; i < items.length; i++) {
    var item = String(items[i] || '').trim()
    if (!item || seen[item]) continue
    seen[item] = true
    out.push(item)
  }
  return out
}

var ARTICLE_COVER_IMAGES = {
  'seedream-ai-image-generator-review': 'seedream-product',
  'flux-ai-image-generator-review': 'flux-watch',
  'midjourney-alternative-online': 'midjourney-hero',
  'gpt-image-generator-guide': 'gpt-image-demo',
  'qwen-image-generator-review': 'qwen-image-demo',
  'z-image-ai-generator-review': 'z-image-demo',
  'stable-diffusion-online-generator': 'sd-demo',
  'ai-watermark-remover-online': 'watermark-cover',
  'handwriting-eraser-online': 'handwriting-cover',
  'image-crop-dewarp-online': 'doc-crop-cover'
}

function decorateHubArticle(article) {
  var isTool = article.target && article.target.path && article.target.path.indexOf('/tools/') === 0
  delete article.readTime
  if (!article.layout) {
    if (article.category === 'alternatives') {
      article.layout = 'alternatives'
    } else if (article.category === 'prompt-guides') {
      article.layout = 'prompt-guide'
    } else if (article.category === 'how-to-guides' || isTool) {
      article.layout = 'how-to'
    } else {
      article.layout = 'review'
    }
  }
  if (!article.coverImage && ARTICLE_COVER_IMAGES[article.slug]) {
    article.coverImage = ARTICLE_COVER_IMAGES[article.slug]
  }
  if (!article.heroImage && article.coverImage) {
    article.heroImage = article.coverImage
  }
  var bank = HUB_SEARCH_TERM_BANK[article.slug] || []
  searchIndex.attachArticleSearchFields(article, {
    locale: 'zh',
    extraTerms: bank,
    includeKeywords: true,
    stripCjkForNonZh: false
  })
  if (!article.creatingSteps) {
    article.creatingSteps = isTool ? TOOL_CREATING_STEPS : MODEL_CREATING_STEPS
  }
  if (!article.pros) {
    article.pros = isTool ? TOOL_PROS : MODEL_PROS
  }
  if (!article.cons) {
    article.cons = isTool ? TOOL_CONS : MODEL_CONS
  }
  var platformRef = HUB_PLATFORM_REFS[article.slug]
  if (platformRef && article.sections) {
    var hasPlatform = false
    var pi
    for (pi = 0; pi < article.sections.length; pi++) {
      if (article.sections[pi].id === 'platform-ref') {
        hasPlatform = true
        break
      }
    }
    if (!hasPlatform) {
      var platformBlocks = [p(platformRef.intro)]
      platformBlocks.push(table(platformRef.columns, platformRef.rows, 'overview'))
      insertBeforeFaq(article, makeSection('platform-ref', platformRef.title, platformBlocks))
    }
  }
  var articleConclusion = HUB_ARTICLE_CONCLUSIONS[article.slug]
  if (articleConclusion && article.sections && article.target) {
    var hasConclusion = false
    var ci
    for (ci = 0; ci < article.sections.length; ci++) {
      if (article.sections[ci].id === 'conclusion') {
        hasConclusion = true
        break
      }
    }
    if (!hasConclusion) {
      var conclusionBlocks = [p(articleConclusion.intro)]
      if (articleConclusion.bullets && articleConclusion.bullets.length) {
        conclusionBlocks.push(bullets(articleConclusion.bullets))
      }
      conclusionBlocks.push(ctaBlock(
        articleConclusion.ctaTitle || article.target.label,
        articleConclusion.ctaText || '进入对应功能页继续创作。',
        article.target.label,
        article.target.path
      ))
      insertBeforeFaq(article, makeSection('conclusion', '总结与下一步', conclusionBlocks))
    }
  }
  var scenarios = HUB_SEARCH_SCENARIOS[article.slug] || []
  if (scenarios.length && article.sections) {
    var hasIntents = false
    var ii
    for (ii = 0; ii < article.sections.length; ii++) {
      if (article.sections[ii].id === 'search-intents') {
        hasIntents = true
        break
      }
    }
    if (!hasIntents) {
      var intentBlocks = [
        p('下面这些是我实际遇到最多的需求。先找到相近场景，再把产品、比例、光线和用途换成自己的内容。')
      ]
      for (ii = 0; ii < scenarios.length; ii++) {
        intentBlocks.push(scenarioItem(scenarios[ii].title, scenarios[ii].text))
      }
      insertBeforeFaq(article, makeSection('search-intents', isTool ? '常见处理场景' : '实际创作场景', intentBlocks))
    }
  }
  if (article.sections && article.sections.length) {
    var profilePatch = {}
    var si
    for (si = 0; si < article.sections.length; si++) {
      if (article.sections[si].id === 'tldr' && article.sections[si].title) {
        profilePatch.tldrTitle = article.sections[si].title
      }
      if (article.sections[si].id === 'faq' && article.sections[si].title) {
        profilePatch.faqTitle = article.sections[si].title
      }
    }
    if (Object.keys(profilePatch).length) {
      article.layoutProfile = Object.assign({}, article.layoutProfile || {}, profilePatch)
    }
  }
}

function insertBeforeFaq(article, section) {
  var insertAt = -1
  var i
  for (i = 0; i < article.sections.length; i++) {
    if (article.sections[i].id === 'faq') {
      insertAt = i
      break
    }
  }
  if (insertAt >= 0) {
    article.sections.splice(insertAt, 0, section)
  } else {
    article.sections.push(section)
  }
}

var HUB_ARTICLE_ALIGNMENT_TARGETS = {
  'seedream-ai-image-generator-review': { prompts: 8, steps: 4, pros: 4, cons: 4 },
  'flux-ai-image-generator-review': { prompts: 8, steps: 4, pros: 4, cons: 4 },
  'midjourney-alternative-online': { prompts: 7, steps: 4, pros: 4, cons: 4 },
  'gpt-image-generator-guide': { prompts: 7, steps: 4, pros: 4, cons: 4 },
  'qwen-image-generator-review': { prompts: 7, steps: 4, pros: 4, cons: 4 },
  'z-image-ai-generator-review': { prompts: 6, steps: 4, pros: 4, cons: 4 },
  'stable-diffusion-online-generator': { prompts: 7, steps: 4, pros: 4, cons: 4 },
  'ai-watermark-remover-online': { prompts: 6, steps: 4, pros: 4, cons: 4 },
  'ai-background-remover-online': { prompts: 6, steps: 4, pros: 4, cons: 4 },
  'ecommerce-product-background-removal': { prompts: 6, steps: 5, pros: 4, cons: 4 },
  'ai-portrait-background-remover': { prompts: 6, steps: 4, pros: 4, cons: 4 },
  'ai-background-changer-online': { prompts: 6, steps: 5, pros: 4, cons: 4 },
  'handwriting-eraser-online': { prompts: 6, steps: 5, pros: 5, cons: 4 },
  'image-crop-dewarp-online': { prompts: 6, steps: 4, pros: 5, cons: 4 }
}

function findHubSection(article, sectionId) {
  var sections = article.sections || []
  var i
  for (i = 0; i < sections.length; i++) {
    if (sections[i].id === sectionId) return sections[i]
  }
  return null
}

function countHubBlocks(section, blockType) {
  var blocks = section && section.blocks ? section.blocks : []
  var count = 0
  var i
  for (i = 0; i < blocks.length; i++) {
    if (blocks[i].type === blockType) count++
  }
  return count
}

function ensureHubArrayLength(list, targetCount, fallbackItems) {
  var i = 0
  while (list.length < targetCount) {
    list.push(fallbackItems[i % fallbackItems.length])
    i++
  }
}

function alignHubArticleContent(article) {
  var target = HUB_ARTICLE_ALIGNMENT_TARGETS[article.slug]
  if (!target || !article.sections) return
  var isTool = article.target && article.target.path && article.target.path.indexOf('/tools/') === 0
  var promptSection = findHubSection(article, 'prompt-examples')
  var bestPracticeSection = findHubSection(article, 'best-practices')
  var practiceFallbacks = isTool
    ? [
        { title: '先用小图测试', text: '先处理一张代表性图片，确认边缘、阴影和文字稳定后再批量处理。' },
        { title: '保留原图备份', text: '上传前保留原始文件，方便对比处理前后效果或回退重做。' },
        { title: '分区域处理', text: '复杂水印、手写字或阴影建议分区域多次处理，不要一次框选过大。' },
        { title: '检查导出用途', text: '用于打印、OCR、商品图或归档前，分别检查清晰度、边缘和文字可读性。' },
        { title: '串联下一步工具', text: '文档类图片可先矫正，再擦除手写字或去水印，最后进入归档或 OCR。' },
        { title: '批量前抽检', text: '批量处理前抽检不同类型图片，确认同一参数对多种素材都稳定。' }
      ]
    : [
        { title: '先定用途', text: '先明确图片用于商品、广告、社媒、海报还是概念草图，再写提示词。' },
        { title: '固定比例', text: '先确定平台尺寸和画面比例，避免生成后再大幅裁切。' },
        { title: '保留品牌元素', text: '涉及包装、Logo、字体或卖点文案时，把必须保留的元素单独写清楚。' },
        { title: '多模型对比', text: '同一提示词可以在不同模型中测试，比较真实感、文字控制和构图稳定性。' },
        { title: '终稿前检查', text: '发布前放大检查文字、手部、反光、产品结构和平台合规要求。' },
        { title: '结合图片工具', text: '如果生成结果还需要裁切、去水印或文档矫正，可以再进入对应工具处理。' }
      ]
  var promptFallbacks = [
    {
      label: '电商主图补充',
      prompt: article.title + '，电商产品主图，清晰主体，干净背景，真实材质，适合商品详情页。'
    },
    {
      label: '社媒封面补充',
      prompt: article.title + '，社媒封面构图，强焦点，留出标题空间，现代视觉风格。'
    },
    {
      label: '广告海报补充',
      prompt: article.title + '，商业广告海报，明确卖点区域，高质量光影，品牌感强。'
    },
    {
      label: '产品场景补充',
      prompt: article.title + '，产品使用场景，真实环境，主体突出，适合线上营销素材。'
    },
    {
      label: '概念草图补充',
      prompt: article.title + '，创意概念草图，多方案探索，构图干净，方便继续精修。'
    }
  ]
  var promptIndex
  if (promptSection) {
    promptIndex = countHubBlocks(promptSection, 'prompt-example') + 1
    while (countHubBlocks(promptSection, 'prompt-example') < target.prompts) {
      var promptFallback = promptFallbacks[(promptIndex - 1) % promptFallbacks.length]
      promptSection.blocks.push(promptExample(promptFallback.label, promptFallback.prompt, ''))
      promptIndex++
    }
  } else if (bestPracticeSection && article.slug !== 'ai-background-remover-online' && article.slug !== 'ecommerce-product-background-removal' && article.slug !== 'ai-portrait-background-remover' && article.slug !== 'ai-background-changer-online') {
    promptIndex = countHubBlocks(bestPracticeSection, 'tip') + 1
    while (countHubBlocks(bestPracticeSection, 'tip') < target.prompts) {
      var practiceFallback = practiceFallbacks[(promptIndex - 1) % practiceFallbacks.length]
      bestPracticeSection.blocks.push(tip(practiceFallback.title, practiceFallback.text))
      promptIndex++
    }
  }
  ensureHubArrayLength(article.creatingSteps || (article.creatingSteps = []), target.steps, isTool ? TOOL_CREATING_STEPS : MODEL_CREATING_STEPS)
  ensureHubArrayLength(article.pros || (article.pros = []), target.pros, isTool ? TOOL_PROS : MODEL_PROS)
  ensureHubArrayLength(article.cons || (article.cons = []), target.cons, isTool ? TOOL_CONS : MODEL_CONS)
}

for (var hi = 0; hi < HUB_ARTICLES.length; hi++) {
  decorateHubArticle(HUB_ARTICLES[hi])
  alignHubArticleContent(HUB_ARTICLES[hi])
  brandContent.decorateArticleBrandContent(HUB_ARTICLES[hi], 'zh')
  ctaLabels.applyFreeTrialTarget(HUB_ARTICLES[hi], 'zh', HUB_TEXT.tryForFreeTemplate || '免费试用 {name}')
}

var HUB_ARTICLE_MAP = HUB_ARTICLES.reduce(function (map, article) {
  map[article.slug] = article
  return map
}, {})

function getHubCategories() {
  return HUB_CATEGORIES
}

function getHubArticles(category) {
  if (!category || category === 'all') return HUB_ARTICLES
  return HUB_ARTICLES.filter(function (article) {
    return article.category === category
  })
}

function getHubArticle(slug) {
  return HUB_ARTICLE_MAP[slug] || null
}

function getHubCategory(key) {
  return HUB_CATEGORY_MAP[key] || null
}

function getRelatedArticles(article) {
  if (!article || !article.related) return []
  return article.related.map(function (slug) {
    return HUB_ARTICLE_MAP[slug]
  }).filter(Boolean)
}

var HUB_FEATURED_SLUGS = [
  'seedream-ai-image-generator-review',
  'flux-ai-image-generator-review',
  'midjourney-alternative-online',
  'gpt-image-generator-guide',
  'ai-watermark-remover-online',
  'image-crop-dewarp-online'
]

function getHubFeaturedArticles(category) {
  if (category && category !== 'all') {
    return getHubArticles(category).slice(0, 5)
  }
  var featured = []
  var i
  for (i = 0; i < HUB_FEATURED_SLUGS.length; i++) {
    var article = HUB_ARTICLE_MAP[HUB_FEATURED_SLUGS[i]]
    if (article) featured.push(article)
  }
  return featured
}

function normalizeHubSearchQuery(query) {
  return searchIndex.normalizeSearchQuery(query)
}

function getArticleSearchHaystack(article) {
  return searchIndex.buildArticleSearchHaystack(article, {
    locale: 'zh',
    includeKeywords: true,
    stripCjkForNonZh: false
  })
}

function searchHubArticles(query, category) {
  var list = getHubArticles(category || 'all')
  if (!normalizeHubSearchQuery(query)) return list
  return list.filter(function (article) {
    return searchIndex.articleMatchesQuery(article, query, {
      locale: 'zh',
      includeKeywords: true,
      stripCjkForNonZh: false
    })
  })
}

function getHubSearchSuggestions(limit, category) {
  return searchIndex.buildSearchSuggestions(getHubArticles(category || 'all'), limit, {
    locale: 'zh',
    includeKeywords: true,
    stripCjkForNonZh: false
  })
}

function truncateNavTitle(text, maxLen) {
  var limit = maxLen || 40
  var value = String(text || '').trim()
  if (value.length <= limit) return value
  return value.slice(0, limit) + '…'
}

function getStepNavTitle(article) {
  if (!article) return HUB_TEXT.defaultStepTitle
  if (article.category === 'alternatives') return HUB_TEXT.alternativesStepTitle
  if (article.category === 'how-to-guides') return HUB_TEXT.howToStepTitle
  if (article.category === 'prompt-guides') return HUB_TEXT.promptStepTitle
  return HUB_TEXT.reviewStepTitle
}

function buildSectionNavChildren(section, article) {
  var children = []
  var blocks = section.blocks || []
  var i
  for (i = 0; i < blocks.length; i++) {
    if (blocks[i].type === 'steps') {
      children.push({
        id: section.id + '-steps',
        anchor: section.id + '-steps',
        title: getStepNavTitle(article)
      })
    }
  }
  if (section.id === 'faq') {
    for (i = 0; i < blocks.length; i++) {
      if (blocks[i].type === 'faq-item') {
        children.push({
          id: section.id + '-q-' + i,
          anchor: section.id + '-q-' + i,
          title: truncateNavTitle(blocks[i].question)
        })
      }
    }
    return children
  }
  if (section.id === 'prompt-examples') {
    for (i = 0; i < blocks.length; i++) {
      if (blocks[i].type === 'prompt-example') {
        children.push({
          id: section.id + '-p-' + i,
          anchor: section.id + '-p-' + i,
          title: truncateNavTitle(blocks[i].label || HUB_TEXT.promptExample, 28)
        })
      }
    }
  }
  return children
}

function buildArticleNavTree(article) {
  if (!article) return []
  var sections = article.sections || []
  var tree = []
  var i
  for (i = 0; i < sections.length; i++) {
    var section = sections[i]
    tree.push({
      id: section.id,
      title: section.title,
      children: buildSectionNavChildren(section, article)
    })
  }
  return tree
}

module.exports = {
  HUB_CATEGORIES: HUB_CATEGORIES,
  HUB_ARTICLES: HUB_ARTICLES,
  HUB_SEARCH_TERM_BANK: HUB_SEARCH_TERM_BANK,
  HUB_TEXT: HUB_TEXT,
  HUB_COLLAPSIBLE_VISIBLE_COUNT: HUB_COLLAPSIBLE_VISIBLE_COUNT,
  COMMON_MODEL_LINKS: COMMON_MODEL_LINKS,
  COMMON_TOOL_LINKS: COMMON_TOOL_LINKS,
  HUB_FEATURE_LINKS: HUB_FEATURE_LINKS,
  getHubCategories: getHubCategories,
  getHubArticles: getHubArticles,
  getHubArticle: getHubArticle,
  getHubCategory: getHubCategory,
  getRelatedArticles: getRelatedArticles,
  getHubFeaturedArticles: getHubFeaturedArticles,
  searchHubArticles: searchHubArticles,
  getHubSearchSuggestions: getHubSearchSuggestions,
  buildArticleNavTree: buildArticleNavTree,
  countHubSectionBlocks: countHubSectionBlocks,
  shouldCollapseHubSection: shouldCollapseHubSection,
  hiddenHubSectionBlockCount: hiddenHubSectionBlockCount,
  buildHubCollapsibleEntries: buildHubCollapsibleEntries
}
